// Version: 4.05
// v4.05: Clearview Agent list at phone width: Rename, Move, Archive and Delete and the last seen time move
//        onto their own row under the device instead of a column beside it, which squeezed the device
//        details into a narrow strip one word per line (useIsMobile). Updated together with ClientDetail v3.12.
// v4.04: Computers tab lists computers added in Action1 since the daily sync (Action1Live.js v1.1), marked
//        "New, patch data at the next sync" in grey rather than Non-compliant; Total counts them. Updated
//        together with ClientDetail v3.11.
// v4.03: New Files tab (CV-60, app.py v4.54), STG admins only. Pinned links at
//        the top (add, edit, reorder, unpin, pin any file from the folder) and
//        the client's Client Folder below, read live from Microsoft 365:
//        folders first, breadcrumb, each file opens in SharePoint, Upload
//        (several files, drag and drop, a name clash keeps both) and New
//        folder. Nothing is copied into Clearview.
// v4.02: Settings gains a Backups card (CV-58, app.py v4.53): last backup and
//        where it went, Back up now, and Show backups listing every copy in the
//        client's team and on the backup site. Restore asks for the private key
//        (sent for that restore only, cleared from the page straight after) and
//        the client's folder name, then shows the restore's progress.
// v4.01: Teams card lists each warning from the last create or link on its own
//        line (a General channel Microsoft would not rename, people not added).
// v4.00: Microsoft Teams (CV-57, app.py v4.51). New Client has "Create a Teams
//        team" with the team name it will use (editable). Settings opens with a
//        Microsoft Teams card: the linked team and its Client Folder with Open
//        links, progress while a team is created or linked, Create team, Link
//        existing (picks from the "Client - " teams not linked elsewhere),
//        Retry, and Unlink (forgets the link only; the team is not changed).
// v3.99: Opening a client shows that client on its own: the other clients
//        and the search bar are hidden until you go back. A bar that stays at
//        the top while you scroll names the client and has "All clients"; the
//        client ends with an "End of <client>" marker, so scrolling to the
//        bottom stops at the client you are in. Going back returns to that
//        client's place in the list. ?client=<slug> links open the same view
//        and closing clears the link. Unsaved Settings changes still ask first.
// v3.98: Row label reads IT Health (capital H), matching the IT Health Grade.
// v3.97: Each client row shows two labelled grades: IT health (the monthly IT and
//        Cyber Security Report, it_health from app.py v4.49) and External (the
//        External Cyber Security Assessment). Hovering a grade gives its score and
//        date; a client without one shows a dash. The row's count says
//        assessments, which is what it counts. The Overview tab's Latest Grade tile
//        is now two tiles, IT Health Grade and External Grade, and its Reports tile
//        reads Assessments.
// v3.96: "STG Edge Node" in title case on the tag, label and tooltip.
// v3.95: Device Hub network list marks the STG Edge Node's host (edge_node from
//        app.py v4.39), the same as ClientDetail.js v3.09.
// v3.94: Computers tab shows live Action1 status and last seen (Action1Live.js v1.0, app.py v4.36), with where the status
//        came from, instead of the 04:00 snapshot (PCs off at 04:00 showed Disconnected all day). Updated with ClientDetail v3.06.
// v3.93: Client Identity's Edge Nodes list has the Linux desktop controls under each node, called Desktop
//        (Start Desktop, then Desktop and Stop Desktop with the login), shared with Edge Nodes
//        (EdgeNodes.js v2.39). Shown only for clients with an edge node; the list refreshes every 30 seconds.
// v3.92: IT and Cyber Security Reports list shows the time as well as the date, and all three report lists end the time with GMT (ClientDetail updated with it).
// v3.91: Number tiles use the shared .stat-card; inputs and selects take their look from index.css (input-sm for compact) (CV-50).
// v3.90: Status labels in sentence case ("Not assessed", "In progress", "Non-compliant", "No data"), like the reports.
// v3.89: Buttons use the shared button system (CV-49): 8px corners, standard variants and sizes, one selected look; no inline radius, padding or font size.
// v3.88: Rename and create messages name the client, not its folder name.
// v3.87: Reports tab sections all work the same way: title, count, and the
//        same two actions from ReportSend.js, Generate (opens Reports and
//        Assessments with the type and client chosen) and Email to client (a
//        box showing the report and the stored address before sending). The
//        IT section's own Generate Report Now and Email Latest Report buttons
//        are replaced; assessments and analytics reports can now be emailed
//        from here too.
// v3.86: Email Latest Report says whether it sent, and why not (no contact
//        email, no report); it ignored the response, so nothing appeared. It
//        asks first, shows a spinner and is disabled until there is a report.
// v3.85: removed an eslint-disable comment naming react-hooks/exhaustive-deps,
//        a rule this build doesn't register (the build failed on it).
// v3.84: /manage?client=<slug>&tab=reports opens that client expanded on the
//        Reports tab and scrolls to it; Active Scans' Reports button uses it.
// v3.83: Reports tab has a Website Analytics Reports section listing every
//        analytics report sent (app.py v3.96 saves a copy), with period,
//        visits, enquiries and recipients, and View, Download and Delete.
// v3.82: Discovered Devices shows known vulnerabilities on edge-discovered
//        devices (CV-29): CVE badge, red dot on affected services and an
//        expandable CVE list (NetworkCves.js), plus Re-check vulnerabilities.
// v3.81: Agreed report names on the Reports tab: External Cyber Security
//        Assessments and IT and Cyber Security Reports (kept in step with
//        ClientDetail.js 2.96).
// v3.80: Grade badge moved to the right of the client name in the list header,
//        so every name lines up at the same left edge whether or not the client
//        has a grade yet.
// v3.79: Client list sorts alphabetically ignoring a leading "The", so
//        "The Backroom Stirling" files under B, not T.
// v3.78: Overview tab shows a Company details card (Companies House number,
//        type, incorporated, registered address, website, phone, account
//        manager) and the client's contacts, carried across from the sales
//        pipeline (app.py v3.85).
// v3.77: After Run assessment starts, the Assessment box lists the office
//        public IPs included in the port scan (app.py v3.83).
// v3.76: Reports tab now shows security assessment reports (client and
//        internal, from clients/<slug>/assessment/reports) above the monthly
//        reports, with grade, View, Download and Delete. Previously only the
//        monthly reports were listed, so assessments run since v3.59 could
//        only be opened from the client's own Reports page.
// v3.75: Run assessment from the client's Overview tab (admin). Shows the
//        domains it will scan, the last assessment date and grade, and a
//        confirm step before starting. Uses POST /api/clients/<slug>/assessment/run
//        (app.py v3.81) so reports land in this client's folder. While a scan
//        runs, shows its status with a link to watch progress, and refreshes
//        the client list when it finishes.
// v3.73: Discovered Devices subnet card now shows one row per scanned subnet
//        (SiteSubnetsCard, same as ClientDetail.js v2.91): CIDR, device count,
//        site name, public IP and per-site Updated time from summary.scanners
//        (app.py v3.52). Previously listed every saved site under a single
//        subnet line. Adds module-level ipInSubnet helper.
// v3.72: Network Labels Sites — public IP cyan colour now applies to both
//        'edge' and 'agent' auto-detected sources; column header updated to
//        show '(auto-detected)' in cyan; tooltip clarifies source.
// v3.71: Network Labels — Discovered Subnets panel fetches agent and edge
//        subnets from new /api/clients/{slug}/network/discovered_subnets
//        endpoint; edge subnets auto-added to Sites; agent subnets shown with
//        device count; "+ Add as Site" pre-populates subnet field; already-
//        added subnets show a tick instead of the add button.
// v3.70: Discovered Devices badge fix — alignItems:flex-start on host card
//        header stops badges stretching to full card height; badges wrapped in
//        flex column so NEW/Agent/Edge stack neatly; source==='both' now shows
//        both Agent and Edge badges.
// v3.69:
// v3.66: Demo mode toggle — admin header switch shows/hides the Acme Corporation
//        demo client. Fetches GET /api/admin/demo/status on load; POST
//        /api/admin/demo/toggle to flip. Demo clients get a purple DEMO pill
//        on their row so admins always know which is fake.
// v3.65: Per-host source badge (Edge/Agent) in NetworkSubTab.
// v3.63: hub_schedules and hub_resources added to ALL_HUBS and HUB_LABELS.
// v3.62: Replace window.confirm in SubscriptionTab with styled Yes/No modal.
// v3.61: SubscriptionTab component; tier pill on ClientRow; CLIENT_TABS updated; hub feature flags.
// v3.60: Device Hub map — switched from CARTO to OSM tiles with CSS invert filter.
// v3.58: Aligned ReportsHubInline with ClientDetail.js's ReportsHub —
//        added Delete (the one real gap between the two versions). No
//        admin gate needed on Delete here since this whole component only
//        ever renders inside the admin-only /manage route.
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { authFetch } from './auth';
import { useAction1Live, Action1StatusSource, A1_STATUS_COLOR, fmtA1Time, a1Compliance } from './Action1Live';
import AssetHub from './AssetHub';
import CyberSecurityHub from './CyberSecurityHub';
import DashboardAdmin from './DashboardAdmin';
import DigitalHub from './DigitalHub';
import ComplianceTile from './ComplianceTile';
import PhishingSection from './PhishingSection';
import ProductivityHub from './ProductivityHub';
import { BulkImportModal } from './AssetInventory';
import { HostCveBadge, HostCveList, ServiceCveDot } from './NetworkCves';
import { ReportActions } from './ReportSend';
import { LinuxDesktopControls } from './EdgeNodes';
import { useIsMobile } from './salesShared';
import './ClientManagement.css';

// v3.87: every report section has the same header: title, count and the same
// two actions (Generate, Email to client) from ReportSend.js
function ReportSectionHeader({ title, count, slug, kind, onSent }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
        {title}{count != null ? <span style={{ marginLeft: 8, textTransform: 'none', letterSpacing: 0, fontWeight: 400 }}>{count} report{count !== 1 ? 's' : ''}</span> : null}
      </div>
      <ReportActions slug={slug} kind={kind} onSent={onSent} />
    </div>
  );
}

// ── Helpers ────────────────────────────────────────────────────────────────────

function fmtDate(iso) {
  if (!iso) return null;
  try {
    const cleaned = iso.replace(/\+00:00Z$/, '+00:00').replace(/Z$/, '');
    const d = new Date(cleaned);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
  } catch { return null; }
}

function sanitizeCompanyCode(raw) {
  return (raw || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
}

function sanitizeCompanyNumber(raw) {
  return (raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
}

// Markets available for national Search Strength competitor tracking.
// gl = Serper/Google country code, suffix = appended to search query.
const SS_MARKETS = [
  { country: "United Kingdom",  gl: "gb", suffix: "UK",          flag: "🇬🇧" },
  { country: "United States",   gl: "us", suffix: "USA",         flag: "🇺🇸" },
  { country: "Australia",       gl: "au", suffix: "Australia",   flag: "🇦🇺" },
  { country: "Canada",          gl: "ca", suffix: "Canada",      flag: "🇨🇦" },
  { country: "Ireland",         gl: "ie", suffix: "Ireland",     flag: "🇮🇪" },
  { country: "New Zealand",     gl: "nz", suffix: "New Zealand", flag: "🇳🇿" },
  { country: "Germany",         gl: "de", suffix: "Germany",     flag: "🇩🇪" },
  { country: "France",          gl: "fr", suffix: "France",      flag: "🇫🇷" },
  { country: "Spain",           gl: "es", suffix: "Spain",       flag: "🇪🇸" },
  { country: "Italy",           gl: "it", suffix: "Italy",       flag: "🇮🇹" },
  { country: "Netherlands",     gl: "nl", suffix: "Netherlands", flag: "🇳🇱" },
  { country: "Sweden",          gl: "se", suffix: "Sweden",      flag: "🇸🇪" },
  { country: "Norway",          gl: "no", suffix: "Norway",      flag: "🇳🇴" },
  { country: "Denmark",         gl: "dk", suffix: "Denmark",     flag: "🇩🇰" },
  { country: "South Africa",    gl: "za", suffix: "South Africa",flag: "🇿🇦" },
];

// Standard sector list — mirrors the SIC_SECTORS grouping in app.py. Keep in sync
// if the backend list changes.
const SIC_SECTORS = [
  'Administrative Services', 'Agriculture and Fishing', 'Arts and Entertainment',
  'Construction', 'Education', 'Financial Services', 'Food and Drink Manufacturing',
  'Health and Social Care', 'Hospitality and Tourism', 'IT and Technology',
  'Manufacturing', 'Media and Publishing', 'Membership Organisations',
  'Mining and Quarrying', 'Personal Services', 'Professional Services',
  'Public Administration', 'Real Estate', 'Repair Services', 'Retail',
  'Sport and Recreation', 'Telecommunications', 'Transport and Logistics',
  'Utilities', 'Veterinary', 'Wholesale Trade',
];

// Sector is stored as an array, but legacy clients may still have a single
// freeform string saved from before this field became a standard list.
function asSectorList(v) {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string' && v.trim()) return [v.trim()];
  return [];
}

function suggestCompanyCode(name, existingCodes = []) {
  if (!name) return '';
  const stop = new Set(['ltd','limited','llp','llc','group','the','and','co','company','inc','plc','services','solutions']);
  const words = name.replace(/&/g, ' and ').split(/[\s,.'-]+/).map(w => w.replace(/[^a-zA-Z]/g, '')).filter(Boolean);
  const sig = words.filter(w => !stop.has(w.toLowerCase()));
  const pool = sig.length ? sig : words;
  if (!pool.length) return '';

  const candidates = [];
  if (pool.length >= 3) candidates.push(pool.slice(0, 3).map(w => w[0]).join(''));
  if (pool[0] && pool[0].length >= 3) candidates.push(pool[0].slice(0, 3));
  if (pool.length >= 2) candidates.push((pool[0].slice(0, 2) + pool[1][0]));
  if (pool.length === 1) candidates.push(pool[0].slice(0, 3).padEnd(3, 'X'));

  const existing = new Set((existingCodes || []).filter(Boolean).map(c => String(c).toUpperCase()));
  for (const c of candidates) {
    const code = sanitizeCompanyCode(c);
    if (code.length === 3 && !existing.has(code)) return code;
  }
  // Fall back to cycling the last letter of the first candidate until free
  const base = sanitizeCompanyCode(candidates[0] || '').padEnd(2, 'X').slice(0, 2);
  for (let i = 0; i < 26; i++) {
    const alt = base + String.fromCharCode(65 + i);
    if (!existing.has(alt)) return alt;
  }
  return '';
}

function GradeBadge({ grade }) {
  const letter = grade ? grade[0] : '?';
  const cls = ['A','B','C','D','E','F'].includes(letter) ? `grade-${letter}` : 'grade-unknown';
  return <span className={`grade-badge ${cls}`} style={{width:28,height:28,fontSize:13,flexShrink:0}}>{grade || '?'}</span>;
}

// v3.97: a grade with its label, for rows that show both report grades
function LabelledGrade({ label, grade, score, date, empty }) {
  const letter = grade ? grade[0] : null;
  const cls = ['A','B','C','D','E','F'].includes(letter) ? `grade-${letter}` : 'grade-unknown';
  const tip = grade ? `${label}: grade ${grade}${score != null ? `, ${score}/100` : ''}${date ? `, ${fmtDate(date)}` : ''}` : empty;
  return (
    <div title={tip} style={{display:'flex',flexDirection:'column',alignItems:'center',gap:3,flexShrink:0,minWidth:44}}>
      <span className={`grade-badge ${cls}`} style={{width:28,height:28,fontSize:13}}>{grade || '–'}</span>
      <span style={{fontSize:10,color:'var(--text-muted)',fontWeight:600,whiteSpace:'nowrap'}}>{label}</span>
    </div>
  );
}

function SectionTitle({ children }) {
  return <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-muted)',marginBottom:12}}>{children}</div>;
}

function SubTabBar({ tabs, active, onChange }) {
  return (
    <div style={{overflowX:'auto',scrollbarWidth:'none',borderBottom:'1px solid var(--border)',marginBottom:16}}>
      <div style={{display:'flex',gap:2,minWidth:'max-content'}}>
        {tabs.map(t => (
          <button className="tab-btn" aria-selected={active===t.id} key={t.id} onClick={() => onChange(t.id)}>{t.label}</button>
        ))}
      </div>
    </div>
  );
}

// ── Productivity Tenants tab ───────────────────────────────────────────────────

const PROVIDERS = [
  { id: 'm365',   label: 'Microsoft 365' },
  { id: 'google', label: 'Google Workspace' },
];

function ProductivityTab({ slug }) {
  const [tenants, setTenants]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [adding, setAdding]         = useState(false);
  const [editId, setEditId]         = useState(null);
  const [saving, setSaving]         = useState(false);
  const [deleting, setDeleting]     = useState(null);
  const [running, setRunning]       = useState(null);
  const [error, setError]           = useState('');
  const [showSecret, setShowSecret] = useState(false);
  const blank = { provider: 'm365', tenant_name: '', tenant_id: '', client_id: '', client_secret: '', schedule_time: '03:00', schedule_enabled: true };
  const [form, setForm] = useState(blank);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await authFetch(`/api/clients/${slug}/productivity/tenants`);
      const d = await r.json();
      setTenants(d.tenants || []);
    } catch { setError('Failed to load'); }
    finally { setLoading(false); }
  }, [slug]);

  useEffect(() => { load(); }, [load]);

  const save = async (e) => {
    e.preventDefault(); setSaving(true); setError('');
    try {
      const url = editId ? `/api/clients/${slug}/productivity/tenants/${editId}` : `/api/clients/${slug}/productivity/tenants`;
      const r = await authFetch(url, { method: editId ? 'PUT' : 'POST', body: JSON.stringify(form) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Save failed');
      setAdding(false); setEditId(null); setForm(blank); load();
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  const del = async (id, name) => {
    if (!window.confirm(`Remove "${name}"?`)) return;
    setDeleting(id);
    try {
      const r = await authFetch(`/api/clients/${slug}/productivity/tenants/${id}`, { method: 'DELETE' });
      if (!r.ok) throw new Error('Delete failed');
      load();
    } catch (err) { setError(err.message); }
    finally { setDeleting(null); }
  };

  const run = async (t) => {
    setRunning(t.id);
    try { await authFetch(`/api/clients/${slug}/productivity/tenants/${t.id}/run`, { method: 'POST' }); }
    catch (err) { setError(err.message); }
    finally { setRunning(null); }
  };

  const inp = { width: '100%', fontFamily: 'var(--font-mono)' };   // look from index.css; input-sm on the tags
  const lbl = { fontSize: 12, fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: 4 };

  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;

  return (
    <div>
      <SectionTitle>Productivity Tenants</SectionTitle>
      {error && <div className="error-msg" style={{marginBottom:12}}>{error}</div>}
      <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:16}}>
        {tenants.length === 0 && !adding && <div style={{fontSize:13,color:'var(--text-muted)',padding:'12px 0'}}>No tenants configured.</div>}
        {tenants.map(t => (
          <div key={t.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
            <div>
              <div style={{fontWeight:600,fontSize:13}}>{t.tenant_name}</div>
              <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>
                {PROVIDERS.find(p=>p.id===t.provider)?.label || t.provider}
                {t.provider==='google'&&<span style={{marginLeft:6,fontSize:10,color:'#e6b800',background:'#e6b80018',border:'1px solid #e6b80040',borderRadius:3,padding:'1px 5px'}}>Admin only</span>}
                {t.configured?<span style={{marginLeft:6,color:'#30d158'}}>● Configured</span>:<span style={{marginLeft:6,color:'#ff9f0a'}}>● Incomplete</span>}
              </div>
            </div>
            <div style={{display:'flex',gap:6}}>
              <button className="btn btn-secondary btn-sm" onClick={()=>{setEditId(t.id);setAdding(false);setShowSecret(false);setForm({provider:t.provider,tenant_name:t.tenant_name,tenant_id:t.tenant_id||'',client_id:t.client_id||'',client_secret:t.client_secret||'',schedule_time:t.schedule_time||'03:00',schedule_enabled:t.schedule_enabled!==false});}}>Edit</button>
              {t.provider==='m365'&&t.configured&&<button className="btn btn-secondary btn-sm" disabled={running===t.id} onClick={()=>run(t)}>{running===t.id?<span className="spinner"/>:'↺ Run'}</button>}
              <button className="btn btn-danger btn-sm" disabled={deleting===t.id} onClick={()=>del(t.id,t.tenant_name)}>{deleting===t.id?<span className="spinner"/>:'Remove'}</button>
            </div>
          </div>
        ))}
      </div>
      {(adding||editId) ? (
        <form onSubmit={save} style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:16,display:'flex',flexDirection:'column',gap:12}}>
          <div style={{fontWeight:600,fontSize:13}}>{editId?'Edit Tenant':'Add Tenant'}</div>
          {!editId&&(
            <div>
              <label style={lbl}>Provider</label>
              <select className="input-sm" value={form.provider} onChange={e=>setForm(p=>({...p,provider:e.target.value}))}>
                {PROVIDERS.map(p=><option key={p.id} value={p.id}>{p.label}</option>)}
              </select>
            </div>
          )}
          <div><label style={lbl}>Tenant Name</label><input className="input-sm" type="text" value={form.tenant_name} onChange={e=>setForm(p=>({...p,tenant_name:e.target.value}))} placeholder="e.g. Contoso Ltd" required style={inp}/></div>
          {form.provider==='m365'&&<div><label style={lbl}>Tenant ID</label><input className="input-sm" type="text" value={form.tenant_id} onChange={e=>setForm(p=>({...p,tenant_id:e.target.value}))} placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" style={inp}/></div>}
          <div><label style={lbl}>Client ID</label><input className="input-sm" type="text" value={form.client_id} onChange={e=>setForm(p=>({...p,client_id:e.target.value}))} placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" style={inp}/></div>
          <div>
            <label style={lbl}>Client Secret</label>
            <div style={{display:'flex',gap:6}}>
              <input className="input-sm" type={showSecret?'text':'password'} value={form.client_secret} onChange={e=>setForm(p=>({...p,client_secret:e.target.value}))} placeholder="Paste client secret" style={{ flex:1 }}/>
              <button className="btn btn-secondary btn-sm" type="button" onClick={()=>setShowSecret(s=>!s)}>{showSecret?'Hide':'Show'}</button>
            </div>
            <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Encrypted with AES-256 before storage</div>
          </div>
          <div style={{display:'flex',gap:12,alignItems:'flex-end'}}>
            <div style={{flex:1}}><label style={lbl}>Daily run time (GMT)</label><input className="input-sm" type="time" value={form.schedule_time} onChange={e=>setForm(p=>({...p,schedule_time:e.target.value}))}/></div>
            <div style={{display:'flex',alignItems:'center',gap:8,paddingBottom:2}}>
              <input type="checkbox" id="sched-en" checked={form.schedule_enabled} onChange={e=>setForm(p=>({...p,schedule_enabled:e.target.checked}))} style={{width:14,height:14,flexShrink:0,cursor:'pointer'}}/>
              <label htmlFor="sched-en" style={{fontSize:12,cursor:'pointer'}}>Schedule enabled</label>
            </div>
          </div>
          <div style={{display:'flex',gap:8}}>
            <button className="btn btn-primary" type="submit" disabled={saving}>{saving?<span className="spinner"/>:(editId?'Save':'Add Tenant')}</button>
            <button className="btn btn-secondary" type="button" onClick={()=>{setAdding(false);setEditId(null);setForm(blank);}}>Cancel</button>
          </div>
        </form>
      ) : (
        <button className="btn btn-secondary btn-sm" onClick={()=>{setAdding(true);setEditId(null);setShowSecret(false);setForm(blank);}}>+ Add Tenant</button>
      )}
    </div>
  );
}

// ── Xero Integration Panel (Clearflow CF-05) ────────────────────────────────────
// Mirrors the ProductivityTab pattern: row-list of connections, status badges,
// connect/disconnect/sync actions. Unlike ProductivityTab, "Add" doesn't open an
// inline form — it kicks off the Xero OAuth redirect in a new tab, then the admin
// returns here and clicks Refresh (or we poll briefly) to pick up the new connection.

function XeroPanel({ slug }) {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading]         = useState(true);
  const [connecting, setConnecting]   = useState(false);
  const [syncing, setSyncing]         = useState(null);
  const [removing, setRemoving]       = useState(null);
  const [error, setError]             = useState('');

  const load = useCallback(async () => {
    try {
      const r = await authFetch(`/api/clients/${slug}/xero/connections`);
      const d = await r.json();
      setConnections(Array.isArray(d) ? d : []);
    } catch { setError('Failed to load Xero connections'); }
    finally { setLoading(false); }
  }, [slug]);

  useEffect(() => { load(); }, [load]);

  // If an OAuth tab was opened, poll briefly on return to pick up the new connection
  // without requiring a manual refresh click.
  useEffect(() => {
    const onFocus = () => { if (connecting) load(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [connecting, load]);

  const connect = async () => {
    setConnecting(true); setError('');
    try {
      const r = await authFetch(`/api/clients/${slug}/xero/connect`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Could not start Xero connection');
      window.open(d.authorize_url, '_blank', 'noopener,noreferrer');
    } catch (err) { setError(err.message); setConnecting(false); }
  };

  const sync = async (conn) => {
    setSyncing(conn.id); setError('');
    try {
      const r = await authFetch(`/api/clients/${slug}/xero/sync/${conn.id}`, { method: 'POST' });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Sync failed');
      await load();
    } catch (err) { setError(err.message); }
    finally { setSyncing(null); }
  };

  const remove = async (conn) => {
    if (!window.confirm(`Disconnect "${conn.tenant_name}" from Xero? This removes cached invoice, contact and quote data for this client.`)) return;
    setRemoving(conn.id);
    try {
      const r = await authFetch(`/api/clients/${slug}/xero/connections/${conn.id}`, { method: 'DELETE' });
      if (!r.ok) { const d = await r.json(); throw new Error(d.error || 'Disconnect failed'); }
      await load();
    } catch (err) { setError(err.message); }
    finally { setRemoving(null); }
  };

  const fmtDate = (iso) => {
    if (!iso) return 'Never';
    try {
      return new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
    } catch { return iso; }
  };

  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;

  return (
    <div>
      <SectionTitle>Xero</SectionTitle>
      {error && <div className="error-msg" style={{marginBottom:12}}>{error}</div>}
      <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:16}}>
        {connections.length === 0 && (
          <div style={{fontSize:13,color:'var(--text-muted)',padding:'12px 0'}}>No Xero organisation connected.</div>
        )}
        {connections.map(c => {
          const statusOk = c.last_sync_status === 'ok';
          const statusError = c.last_sync_status === 'error';
          return (
            <div key={c.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
              <div>
                <div style={{fontWeight:600,fontSize:13}}>{c.tenant_name}</div>
                <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>
                  Last synced: {fmtDate(c.last_synced_at)}
                  {statusOk && <span style={{marginLeft:6,color:'#30d158'}}>● Synced</span>}
                  {statusError && <span style={{marginLeft:6,color:'#ff2d55'}}>● Sync error</span>}
                  {!c.last_synced_at && !statusError && <span style={{marginLeft:6,color:'#ff9f0a'}}>● Pending first sync</span>}
                </div>
                {statusError && c.last_sync_error && (
                  <div style={{fontSize:11,color:'#ff2d55',marginTop:2}}>{c.last_sync_error}</div>
                )}
              </div>
              <div style={{display:'flex',gap:6}}>
                <button className="btn btn-secondary btn-sm" disabled={syncing===c.id} onClick={()=>sync(c)}>
                  {syncing===c.id ? <span className="spinner"/> : '↺ Sync now'}
                </button>
                <button className="btn btn-danger btn-sm" disabled={removing===c.id} onClick={()=>remove(c)}>
                  {removing===c.id ? <span className="spinner"/> : 'Disconnect'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
      <button className="btn btn-secondary btn-sm" disabled={connecting} onClick={connect}>
        {connecting ? <span className="spinner"/> : '+ Connect Xero Organisation'}
      </button>
      <div style={{fontSize:11,color:'var(--text-muted)',marginTop:8}}>
        Opens Xero's login in a new tab. Once authorised, return here — the connection appears automatically.
        Read-only access (invoices, contacts and quotes). Syncs hourly, or use Sync now for an immediate refresh.
      </div>
    </div>
  );
}

// ── Network Labels tab ─────────────────────────────────────────────────────────

function NetworkTab({ slug }) {
  const [labels, setLabels]           = useState({ sites: {}, devices: {} });
  const [loading, setLoading]         = useState(true);
  const [saving, setSaving]           = useState(false);
  const [saveMsg, setSaveMsg]         = useState('');
  const [error, setError]             = useState('');
  const [editSites, setEditSites]     = useState([]);
  const [editDevices, setEditDevices] = useState([]);
  const [discovered, setDiscovered]   = useState([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      authFetch(`/api/clients/${slug}/network/labels`).then(r => r.json()),
      authFetch(`/api/clients/${slug}/network/discovered_subnets`).then(r => r.json()).catch(() => ({ subnets: [] })),
    ]).then(([d, disc]) => {
      setLabels(d);
      const subnets = disc.subnets || [];
      setDiscovered(subnets);
      // Build sites from saved labels
      const sites = Object.entries(d.sites || {}).map(([subnet, v]) => ({
        subnet,
        name: typeof v === 'string' ? v : (v.label || subnet),
        public_ip: typeof v === 'object' ? (v.public_ip || '') : '',
        public_ip_source: typeof v === 'object' ? (v.public_ip_source || 'manual') : 'manual',
        edge_id: typeof v === 'object' ? (v.edge_id || '') : '',
      }));
      // Auto-add edge node subnets not already in saved sites
      const existing = new Set(sites.map(s => s.subnet));
      subnets.filter(s => s.source === 'edge' && !existing.has(s.subnet)).forEach(s => {
        sites.push({ subnet: s.subnet, name: s.edge_label || '', public_ip: '', public_ip_source: 'edge', edge_id: s.edge_id || '' });
      });
      setEditSites(sites);
      setEditDevices(Object.entries(d.devices || {}).map(([mac, v]) => ({ mac, label: typeof v === 'string' ? v : (v?.label || v?.name || '') })));
      setLoading(false);
    }).catch(() => { setError('Failed to load labels'); setLoading(false); });
  }, [slug]);

  const save = async () => {
    setSaving(true); setError('');
    const sites = {};
    editSites.forEach(({ subnet, name, public_ip, public_ip_source, edge_id }) => {
      if (subnet.trim() && name.trim()) sites[subnet.trim()] = {
        label: name.trim(),
        public_ip: (public_ip || '').trim() || null,
        public_ip_source: public_ip_source || 'manual',
        edge_id: edge_id || null,
      };
    });
    const devices = {};
    editDevices.forEach(({ mac, label }) => {
      if (mac.trim() && label.trim()) devices[mac.trim().toLowerCase()] = label.trim();
    });
    try {
      const r = await authFetch(`/api/clients/${slug}/network/labels`, { method: 'POST', body: JSON.stringify({ sites, devices }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Save failed');
      setSaveMsg('Saved'); setTimeout(() => setSaveMsg(''), 2000);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  const inp = (extra={}) => ({ fontFamily: 'var(--font-mono)', ...extra });   // look from index.css; monospace for addresses

  // Group discovered subnets by CIDR so multiple sources render on one row
  const discBySubnet = {};
  discovered.forEach(d => { if (!discBySubnet[d.subnet]) discBySubnet[d.subnet] = []; discBySubnet[d.subnet].push(d); });
  const discEntries = Object.entries(discBySubnet);

  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;

  return (
    <div>
      {error && <div className="error-msg" style={{marginBottom:12}}>{error}</div>}
      {saveMsg && <div className="success-msg" style={{marginBottom:12}}>{saveMsg}</div>}

      {/* ── Discovered Subnets ──────────────────────────────────────────────── */}
      {discEntries.length > 0 && (
        <div style={{marginBottom:24}}>
          <SectionTitle>Discovered Subnets</SectionTitle>
          <div style={{fontSize:11,color:'var(--text-muted)',marginBottom:10}}>
            Detected from agent check-ins and edge node configurations. Edge node subnets are added to Sites automatically — name them and save to confirm.
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:6}}>
            {discEntries.map(([subnet, sources]) => {
              const alreadyAdded = editSites.some(s => s.subnet === subnet);
              return (
                <div key={subnet} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',borderRadius:8,background:'var(--card-bg)',border:'1px solid var(--border)'}}>
                  <div style={{fontFamily:'var(--font-mono)',fontSize:12,flex:'0 0 160px',color:'var(--text)'}}>{subnet}</div>
                  <div style={{display:'flex',gap:6,flex:1,flexWrap:'wrap'}}>
                    {sources.map((s, i) => (
                      <span key={i} style={{
                        fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:4,textTransform:'uppercase',letterSpacing:'0.06em',
                        background: s.source==='edge' ? '#00d4ff18' : '#30d15818',
                        color:      s.source==='edge' ? '#00d4ff'   : '#30d158',
                        border:     `1px solid ${s.source==='edge' ? '#00d4ff40' : '#30d15840'}`,
                      }}>
                        {s.source==='edge'
                          ? `Edge · ${s.edge_label || s.edge_id || ''}`
                          : `Agent · ${s.device_count} device${s.device_count!==1?'s':''}`}
                      </span>
                    ))}
                  </div>
                  {alreadyAdded ? (
                    <span style={{fontSize:11,color:'#30d158',fontWeight:700,whiteSpace:'nowrap'}}>✓ In Sites</span>
                  ) : (
                    <button className="btn btn-secondary btn-sm"
                     
                     
                      onClick={() => setEditSites(prev => [...prev, {
                        subnet,
                        name: '',
                        public_ip: '',
                        public_ip_source: sources.find(s => s.source==='edge') ? 'edge' : 'manual',
                        edge_id: sources.find(s => s.source==='edge')?.edge_id || '',
                      }])}>
                      + Add as Site
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Sites ───────────────────────────────────────────────────────────── */}
      <SectionTitle>Sites</SectionTitle>
      <div style={{display:'flex',flexDirection:'column',gap:6,marginBottom:16}}>
        <div style={{display:'flex',gap:8,paddingBottom:4,borderBottom:'1px solid var(--border)'}}>
          <div style={{flex:'0 0 150px',fontSize:10,color:'var(--text-muted)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em'}}>Subnet</div>
          <div style={{flex:1,fontSize:10,color:'var(--text-muted)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em'}}>Site Name</div>
          <div style={{flex:'0 0 130px',fontSize:10,color:'var(--text-muted)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em'}}>Public IP <span style={{color:'var(--accent)',fontWeight:400,textTransform:'none'}}>(auto-detected)</span></div>
          <div style={{width:20}}/>
        </div>
        {editSites.map((s, i) => (
          <div key={i} style={{display:'flex',gap:8,alignItems:'center'}}>
            <input className="input-sm" value={s.subnet} onChange={e=>{const ns=[...editSites];ns[i]={...ns[i],subnet:e.target.value};setEditSites(ns);}} placeholder="192.168.168.0/24" style={inp({'flex':'0 0 150px'})}/>
            <input className="input-sm" value={s.name} onChange={e=>{const ns=[...editSites];ns[i]={...ns[i],name:e.target.value};setEditSites(ns);}} placeholder="Main Office" style={inp({flex:1})}/>
            <input className="input-sm" value={s.public_ip||''} onChange={e=>{const ns=[...editSites];ns[i]={...ns[i],public_ip:e.target.value,public_ip_source:'manual'};setEditSites(ns);}}
              placeholder="e.g. 1.2.3.4"
              title={['edge','agent'].includes(s.public_ip_source)?`Auto-detected (${s.public_ip_source}${s.public_ip_source==='edge'?' · '+s.edge_id:''})` :'Manually entered'}
              style={inp({'flex':'0 0 130px',color:['edge','agent'].includes(s.public_ip_source)?'var(--accent-ink)':'var(--text)'})}/>
            <button className="btn btn-danger btn-lg" onClick={()=>setEditSites(editSites.filter((_,j)=>j!==i))}>×</button>
          </div>
        ))}
        <button className="btn btn-secondary btn-sm" style={{ alignSelf: 'flex-start' }} onClick={()=>setEditSites([...editSites,{subnet:'',name:'',public_ip:'',public_ip_source:'manual',edge_id:''}])}>+ Add Site</button>
      </div>

      {/* ── Devices ─────────────────────────────────────────────────────────── */}
      <SectionTitle>Devices</SectionTitle>
      <div style={{display:'flex',flexDirection:'column',gap:6,marginBottom:16}}>
        <div style={{display:'flex',gap:8,paddingBottom:4,borderBottom:'1px solid var(--border)'}}>
          <div style={{flex:'0 0 160px',fontSize:10,color:'var(--text-muted)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em'}}>MAC Address</div>
          <div style={{flex:1,fontSize:10,color:'var(--text-muted)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em'}}>Device Label</div>
          <div style={{width:20}}/>
        </div>
        {editDevices.map((d, i) => (
          <div key={i} style={{display:'flex',gap:8,alignItems:'center'}}>
            <input className="input-sm" value={d.mac} onChange={e=>{const nd=[...editDevices];nd[i]={...nd[i],mac:e.target.value};setEditDevices(nd);}} placeholder="aa:bb:cc:dd:ee:ff" style={inp({'flex':'0 0 160px'})}/>
            <input className="input-sm" value={d.label} onChange={e=>{const nd=[...editDevices];nd[i]={...nd[i],label:e.target.value};setEditDevices(nd);}} placeholder="" style={inp({flex:1})}/>
            <button className="btn btn-danger btn-lg" onClick={()=>setEditDevices(editDevices.filter((_,j)=>j!==i))}>×</button>
          </div>
        ))}
        <button className="btn btn-secondary btn-sm" style={{ alignSelf: 'flex-start' }} onClick={()=>setEditDevices([...editDevices,{mac:'',label:''}])}>+ Add Device</button>
      </div>

      <div style={{display:'flex',gap:8}}>
        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving?<span className="spinner"/>:'Save Labels'}</button>
      </div>
    </div>
  );
}

// ── Settings tab ───────────────────────────────────────────────────────────────

// ── Watched Accounts Panel ─────────────────────────────────────────────────────

const COUNTRY_PRESETS = [
  { code: 'GB', label: 'United Kingdom' },
  { code: 'US', label: 'United States' },
  { code: 'IE', label: 'Ireland' },
  { code: 'DE', label: 'Germany' },
  { code: 'FR', label: 'France' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'AU', label: 'Australia' },
  { code: 'CA', label: 'Canada' },
];

const EMPTY_ACCOUNT = {
  upn: '', label: '',
  alert_any_login: false,
  alert_out_of_hours: false,
  alert_foreign_country: false,
  alert_new_ip: false,
  alert_failed: true,
  business_hours_start: 8,
  business_hours_end: 18,
  allowed_countries: ['GB'],
};

function ChannelPill({ label, active, warn, warnMsg }) {
  const color = active ? '#30d158' : warn ? '#e6b800' : '#86868b';
  const icon  = active ? '●' : warn ? '◐' : '○';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 4,
      background: `${color}18`, border: `1px solid ${color}40`, color,
    }}>
      {icon} {label}{warn && warnMsg ? ` — ${warnMsg}` : !active ? ' off' : ''}
    </span>
  );
}

function WatchedAccountsPanel({ slug }) {
  const [accounts, setAccounts]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState('');
  const [editingId, setEditingId] = useState(null); // null = none, 'new' = add form
  const [form, setForm]           = useState({ ...EMPTY_ACCOUNT });
  const [saving, setSaving]       = useState(false);
  const [alertCfg, setAlertCfg]   = useState(null); // global alert channel config

  const load = async () => {
    try {
      const [acctRes, cfgRes] = await Promise.all([
        authFetch(`/api/clients/${slug}/watched-accounts`),
        authFetch('/api/admin/alerts/config'),
      ]);
      const acctData = await acctRes.json();
      const cfgData  = await cfgRes.json();
      setAccounts(acctData.watched_accounts || []);
      setAlertCfg(cfgData);
    } catch { setError('Failed to load watched accounts'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [slug]);

  const openNew = () => {
    setForm({ ...EMPTY_ACCOUNT });
    setEditingId('new');
    setError('');
  };

  const openEdit = (acct) => {
    setForm({ ...EMPTY_ACCOUNT, ...acct });
    setEditingId(acct.id);
    setError('');
  };

  const cancel = () => { setEditingId(null); setError(''); };

  const toggleCountry = (code) => {
    setForm(f => {
      const cur = f.allowed_countries || [];
      return {
        ...f,
        allowed_countries: cur.includes(code)
          ? cur.filter(c => c !== code)
          : [...cur, code],
      };
    });
  };

  const save = async () => {
    if (!form.upn.trim()) { setError('UPN is required'); return; }
    if (form.alert_foreign_country && (!form.allowed_countries || form.allowed_countries.length === 0)) {
      setError('Select at least one allowed country'); return;
    }
    setSaving(true); setError('');
    try {
      const isNew = editingId === 'new';
      const url   = isNew
        ? `/api/clients/${slug}/watched-accounts`
        : `/api/clients/${slug}/watched-accounts/${editingId}`;
      const r = await authFetch(url, {
        method: isNew ? 'POST' : 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Save failed');
      setEditingId(null);
      await load();
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  const remove = async (acct) => {
    if (!window.confirm(`Remove ${acct.label || acct.upn} from watched accounts?`)) return;
    try {
      const r = await authFetch(`/api/clients/${slug}/watched-accounts/${acct.id}`, { method: 'DELETE' });
      if (!r.ok) { const d = await r.json(); throw new Error(d.error || 'Delete failed'); }
      await load();
    } catch (err) { setError(err.message); }
  };

  const FLAG = { any: '🔔', out_of_hours: '🌙', foreign: '🌍', new_ip: '🖥', failed: '⚠' };

  if (loading) return <div style={{ padding: 16, textAlign: 'center' }}><span className="spinner" /></div>;

  const emailOn = alertCfg?.email_alerts !== false;
  const teamsOn = alertCfg?.teams_alerts !== false;
  const hasWebhook = !!(alertCfg?.teams_webhook_url);
  const allGood = emailOn && teamsOn && hasWebhook;

  return (
    <div>
      {error && <div className="error-msg" style={{ marginBottom: 10 }}>{error}</div>}

      {/* Alert channel status banner */}
      {alertCfg && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
          background: allGood ? 'var(--surface)' : '#e6b80010',
          border: `1px solid ${allGood ? 'var(--border)' : '#e6b80040'}`,
          borderRadius: 7, padding: '8px 12px', marginBottom: 14,
          fontSize: 11,
        }}>
          <span style={{ color: 'var(--text-muted)', fontWeight: 600, marginRight: 4 }}>Alert channels:</span>
          <ChannelPill label="Email" active={emailOn} />
          <ChannelPill label="Teams" active={teamsOn && hasWebhook} warn={teamsOn && !hasWebhook} warnMsg="no webhook configured" />
          <a
            href="/system"
            style={{ marginLeft: 'auto', fontSize: 10, color: 'var(--accent)', textDecoration: 'none', whiteSpace: 'nowrap' }}
          >
            Configure in System Admin →
          </a>
        </div>
      )}

      {/* Account list */}
      {accounts.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
          {accounts.map(acct => (
            <div key={acct.id} style={{
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 8, padding: '10px 14px',
              display: 'flex', alignItems: 'center', gap: 12,
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>
                  {acct.label && acct.label !== acct.upn ? acct.label : acct.upn}
                </div>
                {acct.label && acct.label !== acct.upn && (
                  <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--text-muted)', marginTop: 2 }}>{acct.upn}</div>
                )}
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                  {acct.alert_any_login      && <span style={pillStyle('#00d4ff')}>{FLAG.any} Any sign-in</span>}
                  {acct.alert_failed         && <span style={pillStyle('#ff2d55')}>{FLAG.failed} Failed attempts</span>}
                  {acct.alert_out_of_hours   && <span style={pillStyle('#e6b800')}>{FLAG.out_of_hours} Out of hours ({acct.business_hours_start}:00–{acct.business_hours_end}:00 UTC)</span>}
                  {acct.alert_foreign_country && <span style={pillStyle('#bf5af2')}>{FLAG.foreign} Foreign country ({(acct.allowed_countries || []).join(', ')})</span>}
                  {acct.alert_new_ip         && <span style={pillStyle('#30d158')}>{FLAG.new_ip} New IP</span>}
                  {!acct.alert_any_login && !acct.alert_failed && !acct.alert_out_of_hours && !acct.alert_foreign_country && !acct.alert_new_ip && (
                    <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>No alerts configured</span>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button className="btn btn-secondary btn-sm" onClick={() => openEdit(acct)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => remove(acct)}>Remove</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {accounts.length === 0 && editingId === null && (
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 12 }}>
          No accounts being watched. Add one below.
        </div>
      )}

      {/* Add / Edit form */}
      {editingId !== null ? (
        <div style={{
          background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 8, padding: 16,
        }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 14 }}>
            {editingId === 'new' ? 'Add Watched Account' : 'Edit Watched Account'}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
            <div>
              <label>User Principal Name (UPN)</label>
              <input className="input-sm"
                value={form.upn}
                onChange={e => setForm(f => ({ ...f, upn: e.target.value }))}
                placeholder="user@tenant.onmicrosoft.com"
                
                disabled={editingId !== 'new'}/>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
                Must match exactly as it appears in Entra ID.
              </div>
            </div>
            <div>
              <label>Label</label>
              <input
                value={form.label}
                onChange={e => setForm(f => ({ ...f, label: e.target.value }))}
                placeholder="e.g. Break-Glass Admin"
              />
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
                Friendly name shown in alerts.
              </div>
            </div>
          </div>

          {/* Alert toggles */}
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10 }}>
            Alert on
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>

            <AlertToggle
              checked={form.alert_any_login}
              onChange={v => setForm(f => ({ ...f, alert_any_login: v }))}
              label="Any successful sign-in"
              sub="Alert every time this account signs in — best for break-glass and service accounts that should never have routine logins."
              color="#00d4ff"
            />

            <AlertToggle
              checked={form.alert_failed}
              onChange={v => setForm(f => ({ ...f, alert_failed: v }))}
              label="Failed sign-in attempts"
              sub="Alert on any failed authentication — catches brute force and credential stuffing attacks."
              color="#ff2d55"
            />

            <AlertToggle
              checked={form.alert_out_of_hours}
              onChange={v => setForm(f => ({ ...f, alert_out_of_hours: v }))}
              label="Sign-in outside business hours"
              sub="Alert when this account signs in outside the configured window (UTC)."
              color="#e6b800"
            >
              {form.alert_out_of_hours && (
                <div style={{ display: 'flex', gap: 10, marginTop: 8, alignItems: 'center' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 11 }}>Start (UTC hour)</label>
                    <input
                      type="number" min={0} max={23}
                      value={form.business_hours_start}
                      onChange={e => setForm(f => ({ ...f, business_hours_start: parseInt(e.target.value) || 0 }))}
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 11 }}>End (UTC hour)</label>
                    <input
                      type="number" min={0} max={23}
                      value={form.business_hours_end}
                      onChange={e => setForm(f => ({ ...f, business_hours_end: parseInt(e.target.value) || 0 }))}
                      style={{ width: '100%' }}
                    />
                  </div>
                </div>
              )}
            </AlertToggle>

            <AlertToggle
              checked={form.alert_foreign_country}
              onChange={v => setForm(f => ({ ...f, alert_foreign_country: v }))}
              label="Sign-in from outside allowed countries"
              sub="Alert when this account signs in from a country not on the allowed list."
              color="#bf5af2"
            >
              {form.alert_foreign_country && (
                <div style={{ marginTop: 10 }}>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6 }}>Allowed countries</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {COUNTRY_PRESETS.map(({ code, label }) => {
                      const active = (form.allowed_countries || []).includes(code);
                      return (
                        <button className="btn btn-secondary btn-sm" aria-pressed={active}
                          key={code}
                          type="button"
                          onClick={() => toggleCountry(code)}
                        >{code} — {label}</button>
                      );
                    })}
                  </div>
                  <div style={{ marginTop: 8 }}>
                    <label style={{ fontSize: 11 }}>Additional country codes (comma-separated)</label>
                    <input className="input-sm"
                      placeholder="e.g. ES, PT, CH"
                      
                      value={(form.allowed_countries || []).filter(c => !COUNTRY_PRESETS.find(p => p.code === c)).join(', ')}
                      onChange={e => {
                        const extra = e.target.value.split(',').map(c => c.trim().toUpperCase()).filter(Boolean);
                        const preset = (form.allowed_countries || []).filter(c => COUNTRY_PRESETS.find(p => p.code === c));
                        setForm(f => ({ ...f, allowed_countries: [...new Set([...preset, ...extra])] }));
                      }}/>
                  </div>
                </div>
              )}
            </AlertToggle>

            <AlertToggle
              checked={form.alert_new_ip}
              onChange={v => setForm(f => ({ ...f, alert_new_ip: v }))}
              label="Sign-in from a new IP address"
              sub="Alert the first time this account signs in from an IP not seen before. Subsequent logins from that IP are silent."
              color="#30d158"
            />
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary btn-sm" onClick={save} disabled={saving}>
              {saving ? <span className="spinner" /> : editingId === 'new' ? 'Add Account' : 'Save Changes'}
            </button>
            <button className="btn btn-secondary btn-sm" onClick={cancel}>Cancel</button>
          </div>
        </div>
      ) : (
        <button className="btn btn-secondary btn-sm" onClick={openNew}>
          + Add Watched Account
        </button>
      )}
    </div>
  );
}

function AlertToggle({ checked, onChange, label, sub, color, children }) {
  return (
    <div style={{
      background: checked ? `${color}08` : 'transparent',
      border: `1px solid ${checked ? color + '40' : 'var(--border)'}`,
      borderRadius: 7, padding: '10px 12px', transition: 'all 0.15s',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }} onClick={() => onChange(!checked)}>
        <div style={{
          width: 32, height: 18, borderRadius: 9, flexShrink: 0, marginTop: 2,
          background: checked ? color : 'var(--border)',
          position: 'relative', transition: 'background 0.2s',
        }}>
          <div style={{
            position: 'absolute', top: 2, left: checked ? 16 : 2,
            width: 14, height: 14, borderRadius: '50%',
            background: '#fff', transition: 'left 0.2s',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
          }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: checked ? 'var(--text)' : 'var(--text-muted)' }}>{label}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2, lineHeight: 1.4 }}>{sub}</div>
        </div>
      </div>
      {children}
    </div>
  );
}

function pillStyle(color) {
  return {
    fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 4,
    background: `${color}18`, border: `1px solid ${color}40`, color,
    display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap',
  };
}

// v4.00: UTC timestamps from the API (…Z) in en-GB, Europe/London, GMT suffix
function fmtUtc(iso) {
  if (!iso) return '';
  const d = new Date(/(Z|[+-]\d\d:?\d\d)$/i.test(iso) ? iso : `${iso}Z`);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
}

function TeamsPanel({ slug }) {
  const [info, setInfo]       = useState(null);
  const [busy, setBusy]       = useState(false);
  const [err, setErr]         = useState('');
  const [mode, setMode]       = useState(null);     // null | 'create' | 'link'
  const [name, setName]       = useState('');
  const [teams, setTeams]     = useState(null);
  const [pick, setPick]       = useState('');

  const load = useCallback(() => {
    authFetch(`/api/clients/${slug}/teams`).then(r => r.json()).then(d => {
      setInfo(d);
      setName(n => n || d.suggested_name || '');
    }).catch(() => setInfo({}));
  }, [slug]);
  useEffect(() => { load(); }, [load]);

  const running = info?.job?.state === 'running';
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [running, load]);

  const call = async (url, method, body) => {
    setBusy(true); setErr('');
    try {
      const r = await authFetch(url, { method, body: body ? JSON.stringify(body) : undefined });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed');
      setMode(null);
      load();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const openLink = async () => {
    setMode('link'); setTeams(null); setPick(''); setErr('');
    try {
      const r = await authFetch('/api/admin/m365/teams');
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Could not list teams');
      setTeams(d.teams || []);
    } catch (e) { setErr(e.message); setTeams([]); }
  };

  const unlink = () => {
    if (!window.confirm('Unlink this team from the client? The team and its files are not changed.')) return;
    call(`/api/clients/${slug}/teams`, 'DELETE');
  };

  if (!info) return null;
  if (info.is_demo) return null;
  const team = info.team;
  const job  = info.job;

  return (
    <div className="card" style={{marginBottom:16}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,flexWrap:'wrap',marginBottom:10}}>
        <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)'}}>Microsoft Teams</div>
        {team && <span style={pillStyle(team.linked ? '#00d4ff' : '#30d158')}>{team.linked ? 'Linked' : 'Created by Clearview'}</span>}
      </div>

      {!info.configured && (
        <div style={{fontSize:12,color:'var(--text-muted)'}}>
          Microsoft 365 is not set up yet. See System Admin, Microsoft 365.
        </div>
      )}

      {err && <div className="error-msg" style={{marginBottom:10}}>{err}</div>}

      {running && (
        <div style={{display:'flex',alignItems:'center',gap:10,fontSize:13,marginBottom:10}}>
          <span className="spinner" />
          <span>{job.mode === 'link' ? 'Linking' : 'Creating'} {job.team_name || 'the team'}: {job.step}…</span>
        </div>
      )}
      {!running && job?.state === 'failed' && !team && (
        <div className="error-msg" style={{marginBottom:10}}>
          {job.mode === 'link' ? 'Linking' : 'Creating'} the team failed: {job.error}
        </div>
      )}
      {!running && job?.state === 'done' && (job.warnings || []).length > 0 && (
        <div style={{fontSize:12,color:'var(--amber)',marginBottom:10,display:'flex',flexDirection:'column',gap:4}}>
          {job.warnings.map((w, i) => <div key={i}>{w}</div>)}
        </div>
      )}

      {team && (
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          <div style={{fontSize:14,fontWeight:600,wordBreak:'break-word'}}>{team.team_name}</div>
          <div style={{fontSize:12,color:'var(--text-muted)'}}>
            Channel {team.channel_name} · Updated {fmtUtc(team.at)}{team.by ? ` by ${team.by}` : ''}
          </div>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:4}}>
            {team.web_url && <a className="btn btn-secondary btn-sm" href={team.web_url} target="_blank" rel="noopener noreferrer">Open in Teams</a>}
            {team.folder_url && <a className="btn btn-secondary btn-sm" href={team.folder_url} target="_blank" rel="noopener noreferrer">Open {team.channel_name}</a>}
            <button className="btn btn-secondary btn-sm" type="button" disabled={busy || running} onClick={unlink}>Unlink</button>
          </div>
        </div>
      )}

      {!team && info.configured && !running && mode === null && (
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          <button className="btn btn-primary btn-sm" type="button" onClick={() => { setMode('create'); setErr(''); }}>Create team</button>
          <button className="btn btn-secondary btn-sm" type="button" onClick={openLink}>Link existing</button>
          {job?.state === 'failed' && job.team_id && (
            // A team that exists but wasn't finished (files area not ready, API restarted) is finished by linking it
            <button className="btn btn-secondary btn-sm" type="button" disabled={busy}
              onClick={() => call(`/api/clients/${slug}/teams/link`, 'POST', { team_id: job.team_id })}>Retry</button>
          )}
        </div>
      )}

      {mode === 'create' && (
        <div style={{display:'flex',flexDirection:'column',gap:8,maxWidth:420}}>
          <label>Team name</label>
          <input className="input-sm" value={name} onChange={e => setName(e.target.value)} maxLength={256} />
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            <button className="btn btn-primary btn-sm" type="button" disabled={busy || !name.trim()}
              onClick={() => call(`/api/clients/${slug}/teams`, 'POST', { name })}>
              {busy ? <span className="spinner" /> : 'Create'}
            </button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={() => setMode(null)}>Cancel</button>
          </div>
        </div>
      )}

      {mode === 'link' && (
        <div style={{display:'flex',flexDirection:'column',gap:8,maxWidth:420}}>
          <label>Team</label>
          {teams === null ? <span className="spinner" /> : (
            <select value={pick} onChange={e => setPick(e.target.value)}>
              <option value="">Choose a team</option>
              {teams.map(t => (
                <option key={t.id} value={t.id} disabled={!!t.linked_to && t.linked_to !== slug}>
                  {t.name}{t.linked_to && t.linked_to !== slug ? ` (linked to ${t.linked_to.replace(/_/g, ' ')})` : ''}
                </option>
              ))}
            </select>
          )}
          {teams && teams.length === 0 && !err && <div style={{fontSize:12,color:'var(--text-muted)'}}>No client teams found.</div>}
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            <button className="btn btn-primary btn-sm" type="button" disabled={busy || !pick}
              onClick={() => call(`/api/clients/${slug}/teams/link`, 'POST', { team_id: pick })}>
              {busy ? <span className="spinner" /> : 'Link'}
            </button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={() => setMode(null)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}

function FilesTab({ slug }) {
  const [links, setLinks]     = useState(null);
  const [listing, setListing] = useState(null);
  const [item, setItem]       = useState('');
  const [err, setErr]         = useState('');
  const [msg, setMsg]         = useState('');
  const [loading, setLoading] = useState(false);
  const [busy, setBusy]       = useState(false);
  const [form, setForm]       = useState(null);     // null | {id?, title, url, note}
  const [newFolder, setNewFolder] = useState(null);
  const [dragOver, setDragOver]   = useState(false);
  const fileRef = useRef(null);

  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(''), 5000); };

  const loadLinks = useCallback(() => {
    authFetch(`/api/clients/${slug}/links`).then(r => r.json()).then(d => setLinks(d.links || [])).catch(() => setLinks([]));
  }, [slug]);

  const loadFiles = useCallback((id) => {
    setLoading(true); setErr('');
    authFetch(`/api/clients/${slug}/files${id ? `?item=${encodeURIComponent(id)}` : ''}`)
      .then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.error || 'Could not read the folder'); return d; })
      .then(d => { setListing(d); setItem(id || ''); })
      .catch(e => { setErr(e.message); setListing(l => l || { items: [], none: true }); })
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => { loadLinks(); loadFiles(''); }, [loadLinks, loadFiles]);

  const saveLink = async () => {
    setBusy(true); setErr('');
    try {
      const editing = !!form.id;
      const r = await authFetch(editing ? `/api/clients/${slug}/links/${form.id}` : `/api/clients/${slug}/links`,
        { method: editing ? 'PUT' : 'POST', body: JSON.stringify({ title: form.title, url: form.url, note: form.note }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Could not save the link');
      setForm(null); loadLinks();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const linkAction = async (id, method, body) => {
    setErr('');
    try {
      const r = await authFetch(`/api/clients/${slug}/links/${id}`, { method, body: body ? JSON.stringify(body) : undefined });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed');
      setLinks(d.links || []);
    } catch (e) { setErr(e.message); }
  };

  const pinFile = async (f) => {
    setErr('');
    try {
      const r = await authFetch(`/api/clients/${slug}/links`, { method: 'POST', body: JSON.stringify({ title: f.name, url: f.web_url }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Could not pin');
      loadLinks(); flash(`Pinned ${f.name}`);
    } catch (e) { setErr(e.message); }
  };

  const upload = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setBusy(true); setErr('');
    const fd = new FormData();
    fd.append('item', item);
    files.forEach(f => fd.append('files', f, f.name));
    try {
      const r = await authFetch(`/api/clients/${slug}/files/upload`, { method: 'POST', body: fd });
      const d = await r.json();
      if (!r.ok && !(d.uploaded || []).length) throw new Error(d.error || (d.failed || []).map(f => `${f.name}: ${f.error}`).join('; ') || 'Upload failed');
      const done = (d.uploaded || []).map(u => u.name);
      if (done.length) flash(`Uploaded ${done.join(', ')}`);
      if ((d.failed || []).length) setErr(d.failed.map(f => `${f.name}: ${f.error}`).join('; '));
      loadFiles(item);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); if (fileRef.current) fileRef.current.value = ''; }
  };

  const makeFolder = async () => {
    setBusy(true); setErr('');
    try {
      const r = await authFetch(`/api/clients/${slug}/files/folder`, { method: 'POST', body: JSON.stringify({ name: newFolder, item }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Could not make the folder');
      setNewFolder(null); loadFiles(item);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const sizeText = (n) => !n ? '' : n < 1024 ? `${n} B` : n < 1048576 ? `${Math.round(n / 1024)} KB` : `${(n / 1048576).toFixed(1)} MB`;
  const noTeam = listing?.none && /no linked team/i.test(err);
  const crumbs = listing?.crumbs || [];

  return (
    <div style={{display:'flex',flexDirection:'column',gap:16}}>
      {err && !noTeam && <div className="error-msg">{err}</div>}
      {msg && <div className="success-msg">{msg}</div>}

      <div className="card">
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,flexWrap:'wrap',marginBottom:10}}>
          <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)'}}>Pinned links</div>
          {!form && <button className="btn btn-secondary btn-sm" type="button" onClick={() => setForm({ title: '', url: '', note: '' })}>Add link</button>}
        </div>
        {links === null ? <span className="spinner" /> : links.length === 0 && !form && (
          <div style={{fontSize:12,color:'var(--text-muted)'}}>No pinned links yet. Add one, or pin a file from the folder below.</div>
        )}
        {(links || []).map((l, i) => (
          <div key={l.id} style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'7px 0',borderTop: i ? '1px solid var(--border)' : 'none'}}>
            <div style={{flex:1,minWidth:200}}>
              <a href={l.url} target="_blank" rel="noopener noreferrer" style={{fontSize:13,fontWeight:600,wordBreak:'break-word'}}>{l.title}</a>
              {l.note && <div style={{fontSize:12,color:'var(--text-muted)',wordBreak:'break-word'}}>{l.note}</div>}
            </div>
            <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
              <button className="btn btn-secondary btn-sm" type="button" disabled={i === 0} onClick={() => linkAction(l.id, 'PUT', { move: 'up' })} aria-label="Move up">↑</button>
              <button className="btn btn-secondary btn-sm" type="button" disabled={i === links.length - 1} onClick={() => linkAction(l.id, 'PUT', { move: 'down' })} aria-label="Move down">↓</button>
              <button className="btn btn-secondary btn-sm" type="button" onClick={() => setForm({ id: l.id, title: l.title, url: l.url, note: l.note || '' })}>Edit</button>
              <button className="btn btn-secondary btn-sm" type="button" onClick={() => { if (window.confirm(`Unpin ${l.title}?`)) linkAction(l.id, 'DELETE'); }}>Unpin</button>
            </div>
          </div>
        ))}
        {form && (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:10,marginTop:10}}>
            <div><label>Title</label><input className="input-sm" value={form.title} maxLength={150} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder="Network diagram" /></div>
            <div><label>Link</label><input className="input-sm" type="url" value={form.url} onChange={e => setForm(f => ({ ...f, url: e.target.value }))} placeholder="https://…" /></div>
            <div style={{gridColumn:'1/-1'}}><label>Note (optional)</label><input className="input-sm" value={form.note} maxLength={300} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} /></div>
            <div style={{gridColumn:'1/-1',display:'flex',gap:8,flexWrap:'wrap'}}>
              <button className="btn btn-primary btn-sm" type="button" disabled={busy || !form.title.trim() || !form.url.trim()} onClick={saveLink}>{busy ? <span className="spinner" /> : 'Save'}</button>
              <button className="btn btn-secondary btn-sm" type="button" onClick={() => setForm(null)}>Cancel</button>
            </div>
          </div>
        )}
      </div>

      <div className={`card${dragOver ? ' drag-over' : ''}`}
        style={dragOver ? {outline:'2px dashed var(--accent, #00d4ff)',outlineOffset:-6} : undefined}
        onDragOver={e => { if (!noTeam && listing && !listing.none) { e.preventDefault(); setDragOver(true); } }}
        onDragLeave={() => setDragOver(false)}
        onDrop={e => { e.preventDefault(); setDragOver(false); if (!noTeam) upload(e.dataTransfer.files); }}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,flexWrap:'wrap',marginBottom:10}}>
          <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)'}}>
            {listing?.folder?.name || 'Client Folder'}
          </div>
          {!noTeam && listing && !listing.none && (
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              <input ref={fileRef} type="file" multiple style={{display:'none'}} onChange={e => upload(e.target.files)} />
              <button className="btn btn-primary btn-sm" type="button" disabled={busy} onClick={() => fileRef.current && fileRef.current.click()}>
                {busy ? <span className="spinner" /> : 'Upload'}
              </button>
              <button className="btn btn-secondary btn-sm" type="button" disabled={busy} onClick={() => setNewFolder('')}>New folder</button>
              {listing.folder?.web_url && <a className="btn btn-secondary btn-sm" href={listing.folder.web_url} target="_blank" rel="noopener noreferrer">Open in SharePoint</a>}
              <button className="btn btn-secondary btn-sm" type="button" disabled={loading} onClick={() => loadFiles(item)}>↻</button>
            </div>
          )}
        </div>

        {noTeam && <div style={{fontSize:12,color:'var(--text-muted)'}}>This client has no linked team. Create or link one on the Settings tab.</div>}

        {!noTeam && listing && !listing.none && (
          <>
            <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap',fontSize:13,marginBottom:8}}>
              <button className="btn btn-secondary btn-sm" type="button" disabled={!crumbs.length} onClick={() => loadFiles('')}>{listing.folder && !crumbs.length ? listing.folder.name : 'Client Folder'}</button>
              {crumbs.map((c, i) => <span key={i} style={{color: i === crumbs.length - 1 ? 'var(--text)' : 'var(--text-muted)'}}>/ {c}</span>)}
              {crumbs.length > 0 && <button className="btn btn-secondary btn-sm" type="button" onClick={() => loadFiles(listing.parent_id === listing.root_id ? '' : listing.parent_id)}>Up</button>}
            </div>
            {newFolder !== null && (
              <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:10,maxWidth:460}}>
                <input className="input-sm" value={newFolder} onChange={e => setNewFolder(e.target.value)} placeholder="Folder name" autoFocus style={{flex:1,minWidth:180}} />
                <button className="btn btn-primary btn-sm" type="button" disabled={busy || !newFolder.trim()} onClick={makeFolder}>Create</button>
                <button className="btn btn-secondary btn-sm" type="button" onClick={() => setNewFolder(null)}>Cancel</button>
              </div>
            )}
            {loading ? <span className="spinner" /> : listing.items.length === 0 ? (
              <div style={{fontSize:12,color:'var(--text-muted)'}}>This folder is empty. Upload files or drop them here.</div>
            ) : listing.items.map((f, i) => (
              <div key={f.id} style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'7px 0',borderTop: i ? '1px solid var(--border)' : 'none'}}>
                <span aria-hidden="true" style={{width:18,textAlign:'center'}}>{f.folder ? '📁' : '📄'}</span>
                <div style={{flex:1,minWidth:180}}>
                  {f.folder
                    ? <button type="button" className="btn-bare" onClick={() => loadFiles(f.id)} style={{wordBreak:'break-word'}}><span style={{fontSize:13,fontWeight:600}}>{f.name}</span></button>
                    : <a href={f.web_url} target="_blank" rel="noopener noreferrer" style={{fontSize:13,fontWeight:600,wordBreak:'break-word'}}>{f.name}</a>}
                  <div style={{fontSize:11,color:'var(--text-muted)'}}>
                    {f.folder ? `${f.child_count ?? 0} item${f.child_count === 1 ? '' : 's'}` : sizeText(f.size)}
                    {f.modified ? ` · Updated ${fmtUtc(f.modified)}` : ''}{f.modified_by ? ` by ${f.modified_by}` : ''}
                  </div>
                </div>
                <button className="btn btn-secondary btn-sm" type="button" onClick={() => pinFile(f)}>Pin</button>
              </div>
            ))}
          </>
        )}
        {!listing && <span className="spinner" />}
      </div>
    </div>
  );
}

function BackupsPanel({ slug }) {
  const [info, setInfo]       = useState(null);
  const [listing, setListing] = useState(false);
  const [list, setList]       = useState(null);
  const [err, setErr]         = useState('');
  const [msg, setMsg]         = useState('');
  const [pick, setPick]       = useState(null);
  const [key, setKey]         = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy]       = useState(false);

  const load = useCallback(() => {
    authFetch(`/api/clients/${slug}/backups`).then(r => r.json()).then(setInfo).catch(() => setInfo({}));
  }, [slug]);
  useEffect(() => { load(); }, [load]);
  const restoring = info?.restore?.state === 'running';
  useEffect(() => {
    if (!restoring) return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [restoring, load]);

  const showList = async () => {
    setListing(true); setErr('');
    try {
      const r = await authFetch(`/api/clients/${slug}/backups?list=1`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Could not list backups');
      setList(d.backups || []);
      if ((d.problems || []).length) setErr(d.problems.join('; '));
    } catch (e) { setErr(e.message); }
    finally { setListing(false); }
  };

  const backupNow = async () => {
    setErr(''); setMsg('');
    try {
      const r = await authFetch(`/api/clients/${slug}/backups`, { method: 'POST' });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed');
      setMsg('Backing up. This takes a minute or two; refresh the card to see the result.');
      setTimeout(load, 20000);
    } catch (e) { setErr(e.message); }
  };

  const restore = async () => {
    setBusy(true); setErr('');
    const body = { drive_id: pick.drive_id, item_id: pick.item_id, name: pick.name, private_key: key, confirm };
    setKey('');
    try {
      const r = await authFetch(`/api/clients/${slug}/backups/restore`, { method: 'POST', body: JSON.stringify(body) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Restore failed');
      setPick(null); setConfirm('');
      load();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  if (!info || info.is_demo) return null;
  const last = info.last;
  const rs = info.restore;
  const where = last ? Object.entries(last.copies || {}).map(([k, v]) =>
    `${k === 'team' ? 'team' : 'backup site'} ${v.ok ? '✓' : '✗'}`).join(', ') : '';

  return (
    <div className="card" style={{marginBottom:16}}>
      <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Backups</div>
      {!info.configured && <div style={{fontSize:12,color:'var(--text-muted)'}}>Backups are not set up yet. See System Admin, Microsoft 365.</div>}
      {err && <div className="error-msg" style={{marginBottom:10}}>{err}</div>}
      {msg && <div className="success-msg" style={{marginBottom:10}}>{msg}</div>}

      {info.configured && (
        <>
          <div style={{fontSize:13,marginBottom:4}}>
            {last ? (last.ok
              ? <>Backed up {fmtUtc(last.at)} ({where})</>
              : <span style={{color:'var(--red)'}}>Last backup failed {fmtUtc(last.at)}: {last.error}{last.last_good ? `. Last good ${fmtUtc(last.last_good)}` : ''}</span>)
              : 'Not backed up yet'}
          </div>
          {!info.team && <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:4}}>No team linked, so backups go to the backup site only.</div>}

          {rs && (
            <div style={{fontSize:12,margin:'8px 0',color: rs.state === 'failed' ? 'var(--red)' : 'var(--text-muted)'}}>
              {rs.state === 'running' && <><span className="spinner" /> Restoring {rs.name}: {rs.step}…</>}
              {rs.state === 'done' && <>Restored from {rs.name} {fmtUtc(rs.finished)} by {rs.by}. The data from before the restore was kept in {rs.safety_copy}.</>}
              {rs.state === 'failed' && <>Restore from {rs.name} failed: {rs.error}</>}
            </div>
          )}

          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:8}}>
            <button className="btn btn-secondary btn-sm" type="button" onClick={backupNow} disabled={restoring}>Back up now</button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={showList} disabled={listing}>
              {listing ? <span className="spinner" /> : (list ? 'Refresh backups' : 'Show backups')}
            </button>
          </div>

          {list && (
            <div style={{marginTop:12,display:'flex',flexDirection:'column'}}>
              {list.length === 0 && <div style={{fontSize:12,color:'var(--text-muted)'}}>No backups yet.</div>}
              {list.map((b, i) => (
                <div key={`${b.location}-${b.item_id}`} style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'6px 0',borderTop: i ? '1px solid var(--border)' : 'none'}}>
                  <div style={{flex:1,minWidth:200}}>
                    <div style={{fontSize:13}}>{fmtUtc(b.created)}</div>
                    <div style={{fontSize:11,color:'var(--text-muted)'}}>{b.location === 'team' ? 'Team' : 'Backup site'} · {Math.max(1, Math.round((b.size || 0) / 1048576))} MB</div>
                  </div>
                  <button className="btn btn-secondary btn-sm" type="button" disabled={restoring}
                    onClick={() => { setPick(b); setKey(''); setConfirm(''); setErr(''); }}>Restore</button>
                </div>
              ))}
            </div>
          )}

          {pick && (
            <div style={{marginTop:14,padding:14,border:'1px solid var(--border)',borderRadius:8,display:'flex',flexDirection:'column',gap:10,maxWidth:520}}>
              <div style={{fontSize:13,fontWeight:600}}>Restore {fmtUtc(pick.created)} from the {pick.location === 'team' ? 'team' : 'backup site'}</div>
              <div style={{fontSize:12,color:'var(--text-muted)',lineHeight:1.5}}>
                This replaces the client's files, tickets and settings with the backup. A copy of what is there now
                is kept first. The private key is used for this restore only and is not saved.
              </div>
              <div>
                <label>Private key</label>
                <textarea className="input-sm" rows={2} value={key} onChange={e => setKey(e.target.value)}
                  placeholder="AGE-SECRET-KEY-1…" autoComplete="off" spellCheck={false}
                  style={{width:'100%',fontFamily:'var(--font-mono)',WebkitTextSecurity:'disc'}} />
              </div>
              <div>
                <label>Type {slug} to confirm</label>
                <input className="input-sm" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="off" />
              </div>
              <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                <button className="btn btn-danger btn-sm" type="button" disabled={busy || !key.trim() || confirm !== slug} onClick={restore}>
                  {busy ? <span className="spinner" /> : 'Restore'}
                </button>
                <button className="btn btn-secondary btn-sm" type="button" onClick={() => { setPick(null); setKey(''); }}>Cancel</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function SettingsTab({ slug, displayName, users, onSaved, onArchived, onDirtyChange }) {
  const [meta, setMeta]       = useState({});
  const [initialMeta, setInitialMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [renaming, setRenaming] = useState(false);
  const [newName, setNewName] = useState('');
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [codeError, setCodeError] = useState('');
  const [edgeNodes, setEdgeNodes] = useState([]);
  const [chLoading, setChLoading] = useState(false);
  const [chError, setChError]     = useState('');
  const [chResult, setChResult]   = useState(null);
  const [ssNewTerm, setSsNewTerm] = useState('');
  const [newLoc, setNewLoc] = useState({ name: '', town: '', region: '', reputation_query: '' });

  const addSearchTerm = (term) => {
    const t = term.trim().toLowerCase();
    if (!t) return;
    const current = meta.search_terms || [];
    if (current.length >= 5 || current.includes(t)) return;
    setMeta(p => ({ ...p, search_terms: [...(p.search_terms || []), t] }));
    setSsNewTerm('');
  };
  const removeSearchTerm = (i) => {
    setMeta(p => ({ ...p, search_terms: (p.search_terms || []).filter((_, j) => j !== i) }));
  };
  const addLocation = () => {
    if (!newLoc.name.trim()) return;
    const current = meta.locations || [];
    if (current.length >= 5) return;
    setMeta(p => ({ ...p, locations: [...(p.locations || []), { ...newLoc }] }));
    setNewLoc({ name: '', town: '', region: '', reputation_query: '' });
  };
  const removeLocation = (i) => {
    setMeta(p => ({ ...p, locations: (p.locations || []).filter((_, j) => j !== i) }));
  };
  const updateLocation = (i, field, value) => {
    setMeta(p => {
      const locs = [...(p.locations || [])];
      locs[i] = { ...locs[i], [field]: value };
      return { ...p, locations: locs };
    });
  };
  const addMarket = (market) => {
    const current = meta.markets || [];
    if (current.length >= 5) return;
    if (current.some(m => m.gl === market.gl)) return;
    setMeta(p => ({ ...p, markets: [...(p.markets || []), market] }));
  };
  const removeMarket = (i) => {
    setMeta(p => ({ ...p, markets: (p.markets || []).filter((_, j) => j !== i) }));
  };

  const loadEdgeNodes = useCallback(() => {
    authFetch('/api/edge/nodes')
      .then(r => r.json())
      .then(d => setEdgeNodes((d.nodes || []).filter(n => n.client_slug === slug)))
      .catch(() => {});
  }, [slug]);

  useEffect(() => {
    loadEdgeNodes();
    // Keep the Desktop state current while this panel is open (start and stop happen at the node's next check-in)
    const t = setInterval(loadEdgeNodes, 30000);
    return () => clearInterval(t);
  }, [loadEdgeNodes]);

  useEffect(() => {
    Promise.all([
      authFetch(`/api/clients/${slug}/meta`).then(r => r.json()),
      authFetch(`/api/clients/${slug}/action1/config`).then(r => r.json()),
    ]).then(([metaData, a1Data]) => {
      const loaded = { ...metaData, action1_org: a1Data.action1_org || metaData.action1_org || '' };
      setMeta(loaded);
      setInitialMeta(loaded);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [slug]);

  // Unsaved-changes tracking — compares live meta against the last loaded/saved snapshot
  const dirty = initialMeta !== null && JSON.stringify(meta) !== JSON.stringify(initialMeta);

  useEffect(() => { if (onDirtyChange) onDirtyChange(dirty); }, [dirty, onDirtyChange]);

  useEffect(() => {
    const handler = (e) => { if (dirty) { e.preventDefault(); e.returnValue = ''; } };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [dirty]);

  const save = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setCodeError('');
    if (meta.company_code && meta.company_code.length !== 3) {
      setCodeError('Company Code must be exactly 3 letters.');
      return;
    }
    setSaving(true); setError('');
    try {
      // watched_accounts is owned by WatchedAccountsPanel via /watched-accounts.
      // Never send it here: this meta snapshot is from tab load and would be stale.
      const payload = { ...meta };
      delete payload.watched_accounts;
      const r = await authFetch(`/api/clients/${slug}/meta`, { method: 'PUT', body: JSON.stringify(payload) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Save failed');
      const a1r = await authFetch(`/api/clients/${slug}/action1/config`, {
        method: 'POST', body: JSON.stringify({ action1_org: meta.action1_org || '' })
      });
      const a1d = await a1r.json();
      if (!a1r.ok) throw new Error(a1d.error || 'Failed to save Action1 config');
      setSuccess('Saved'); setTimeout(() => setSuccess(''), 2000);
      setInitialMeta(meta);
      onSaved();
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  const toggleSector = (s) => {
    setMeta(p => {
      const current = asSectorList(p.sector);
      const next = current.includes(s) ? current.filter(x => x !== s) : [...current, s];
      return { ...p, sector: next };
    });
  };

  const lookupCompaniesHouse = async () => {
    const number = meta.company_number;
    if (!number) return;
    setChLoading(true); setChError(''); setChResult(null);
    try {
      const r = await authFetch(`/api/clients/${slug}/companies-house-lookup?number=${encodeURIComponent(number)}`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Lookup failed');
      setChResult(d);
      if (d.sectors && d.sectors.length) {
        setMeta(p => {
          const current = asSectorList(p.sector);
          const merged = [...current];
          d.sectors.forEach(s => { if (!merged.includes(s)) merged.push(s); });
          return { ...p, sector: merged };
        });
      }
    } catch (err) { setChError(err.message); }
    finally { setChLoading(false); }
  };

  const rename = async () => {
    if (!newName.trim()) return;
    if (!window.confirm(`Rename "${displayName || slug.replace(/_/g, ' ')}" to "${newName.trim()}"? This updates the folder and all linked users.`)) return;
    setRenaming(true);
    try {
      const r = await authFetch(`/api/clients/${slug}/rename`, { method: 'POST', body: JSON.stringify({ new_name: newName.trim() }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Rename failed');
      setSuccess(`Renamed — ${d.users_updated} user(s) updated`);
      setNewName(''); onSaved();
    } catch (err) { setError(err.message); }
    finally { setRenaming(false); }
  };

  const archive = async () => {
    if (!window.confirm(`Archive "${displayName}"? Reports will be preserved.`)) return;
    try {
      const r = await authFetch(`/api/clients/${slug}`, { method: 'DELETE' });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Archive failed');
      onArchived();
    } catch (err) { setError(err.message); }
  };

  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;

  return (
    <>
    <form onSubmit={save} style={{display:'flex',flexDirection:'column',gap:16}}>
      {error && <div className="error-msg">{error}</div>}
      {codeError && <div className="error-msg">{codeError}</div>}
      {success && <div className="success-msg">{success}</div>}
      <div>
        <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Client Identity</div>
        <div style={{maxWidth:160}}>
          <label>Company Code</label>
          <input className="input-sm"
            value={meta.company_code||''}
            onChange={e=>setMeta(p=>({...p,company_code:sanitizeCompanyCode(e.target.value)}))}
            placeholder="APS"
            maxLength={3}
            style={{ textTransform:'uppercase', letterSpacing:'0.1em' }}
          />
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>3-letter code prefixing computer names and client-specific items across Clearview, Clearscope and Clearaware.</div>
        </div>
        {edgeNodes.length > 0 && (
          <div style={{marginTop:14}}>
            <label>Edge Nodes</label>
            <div style={{display:'flex',flexDirection:'column',gap:6,marginTop:4}}>
              {edgeNodes.map(n => (
                <div key={n.edge_id} style={{display:'flex',alignItems:'center',gap:12,padding:'8px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,flexWrap:'wrap'}}>
                  <div style={{flex:1,minWidth:200}}>
                    <div style={{fontSize:13,fontWeight:600}}>{n.label || n.edge_id.substring(0,8)}</div>
                    <div style={{fontSize:11,color:'var(--text-muted)',fontFamily:'var(--font-mono)',marginTop:2}}>{n.edge_id}</div>
                  </div>
                  <button className="btn btn-secondary btn-sm" type="button"
                    onClick={()=>{navigator.clipboard.writeText(n.edge_id);}}>Copy ID</button>
                  <a href={`https://cias-${n.edge_id.substring(0,8)}.stg.limited`} target="_blank" rel="noopener noreferrer"
                    style={{fontSize:11,color:'var(--accent)',textDecoration:'none',fontFamily:'var(--font-mono)',whiteSpace:'nowrap'}}>CISO ↗</a>
                  <a href={`https://cowe-${n.edge_id.substring(0,8)}.stg.limited`} target="_blank" rel="noopener noreferrer"
                    style={{fontSize:11,color:'var(--accent)',textDecoration:'none',fontFamily:'var(--font-mono)',whiteSpace:'nowrap'}}>Terminal ↗</a>
                  <div style={{flexBasis:'100%',display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                    <LinuxDesktopControls node={n} onRefresh={loadEdgeNodes} compact />
                  </div>
                </div>
              ))}
            </div>
            <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Read-only. Edge nodes are registered and managed from the Edge Nodes page.</div>
          </div>
        )}
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
        <div style={{gridColumn:'1/-1'}}>
          <label>Domains</label>
          <input value={meta.domains||''} onChange={e=>setMeta(p=>({...p,domains:e.target.value}))} placeholder="domain.com, domain.co.uk"/>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Comma-separated. Used for assessments and cyber checks.</div>
        </div>
        <div>
          <label>Companies House Number</label>
          <div style={{display:'flex',gap:8,alignItems:'flex-start'}}>
            <input className="input-sm"
              value={meta.company_number||''}
              onChange={e=>setMeta(p=>({...p,company_number:sanitizeCompanyNumber(e.target.value)}))}
              placeholder="e.g. 12345678"
              maxLength={8}
              style={{ letterSpacing:'0.05em' }}
            />
            <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }} type="button" disabled={!meta.company_number||chLoading}
              onClick={lookupCompaniesHouse}>
              {chLoading ? 'Looking up…' : 'Look Up Sector'}
            </button>
          </div>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Optional. Sole traders and unregistered businesses can leave this blank and select a sector manually.</div>
          {chError && <div style={{fontSize:11,color:'#ff2d55',marginTop:4}}>{chError}</div>}
          {chResult && (
            <div style={{fontSize:11,color:'var(--green)',marginTop:4}}>
              Found "{chResult.company_name}"{chResult.sectors.length ? ` — ${chResult.sectors.length===1?'sector':'sectors'} added below` : ' — no SIC codes returned, select sector manually'}
            </div>
          )}
        </div>
        <div>
          <label>Primary Location</label>
          <input value={meta.location||''} onChange={e=>setMeta(p=>({...p,location:e.target.value}))} placeholder="e.g. Coventry, West Midlands"/>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Town or city used for location checks and competitor search queries.</div>
        </div>
        <div style={{gridColumn:'1/-1'}}>
          <label>Business Sector</label>
          <div style={{border:'1px solid var(--border)',borderRadius:8,padding:10,maxHeight:170,overflowY:'auto',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'4px 12px',background:'var(--surface)'}}>
            {SIC_SECTORS.map(s => (
              <label key={s} style={{display:'flex',alignItems:'center',gap:6,fontSize:12,fontWeight:400,cursor:'pointer',padding:'2px 0'}}>
                <input type="checkbox" checked={asSectorList(meta.sector).includes(s)}
                  onChange={()=>toggleSector(s)}
                  style={{accentColor:'#30d158',width:13,height:13,cursor:'pointer',flexShrink:0}}/>
                {s}
              </label>
            ))}
          </div>
          {asSectorList(meta.sector).filter(s=>!SIC_SECTORS.includes(s)).length > 0 && (
            <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:8}}>
              {asSectorList(meta.sector).filter(s=>!SIC_SECTORS.includes(s)).map(s => (
                <span key={s} style={{fontSize:11,padding:'3px 8px',borderRadius:12,background:'var(--accent)18',border:'1px solid var(--accent)40',color:'var(--accent)',display:'inline-flex',alignItems:'center',gap:6}}>
                  {s}
                  <button className="btn btn-quiet btn-sm btn-icon" type="button" onClick={()=>toggleSector(s)}>×</button>
                </span>
              ))}
            </div>
          )}
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Used to personalise Digital Hub recommendations and competitor discovery. Select one or more — legacy freeform entries appear above as removable tags.</div>
        </div>
        {/* ── Locations ─────────────────────────────────────────────────────── */}
        <div style={{gridColumn:'1/-1',borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
            <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)'}}>Locations <span style={{fontWeight:400,fontSize:10}}>({(meta.locations||[]).length}/5) — used for Search Strength and Google Reputation</span></div>
          </div>
          {(meta.locations||[]).map((loc,i) => (
            <div key={i} style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr auto',gap:8,marginBottom:8,padding:10,borderRadius:8,border:'1px solid var(--border)',background:'var(--surface)'}}>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Name</label>
                <input className="input-sm" value={loc.name||''} onChange={e=>updateLocation(i,'name',e.target.value)} placeholder="e.g. Grangemouth"/>
              </div>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Town</label>
                <input className="input-sm" value={loc.town||''} onChange={e=>updateLocation(i,'town',e.target.value)} placeholder="e.g. Grangemouth"/>
              </div>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Region</label>
                <input className="input-sm" value={loc.region||''} onChange={e=>updateLocation(i,'region',e.target.value)} placeholder="e.g. Falkirk"/>
              </div>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Google reputation query</label>
                <input className="input-sm" value={loc.reputation_query||''} onChange={e=>updateLocation(i,'reputation_query',e.target.value)} placeholder="e.g. JK Tyres Grangemouth"/>
              </div>
              <div style={{display:'flex',alignItems:'flex-end',paddingBottom:1}}>
                <button className="btn btn-secondary" type="button" onClick={()=>removeLocation(i)}>✕</button>
              </div>
            </div>
          ))}
          {(meta.locations||[]).length < 5 && (
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr auto',gap:8,padding:10,borderRadius:8,border:'1px dashed var(--border)',background:'var(--surface)',opacity:0.8}}>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Name</label>
                <input className="input-sm" value={newLoc.name} onChange={e=>setNewLoc(p=>({...p,name:e.target.value}))} placeholder="e.g. Stirling"/>
              </div>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Town</label>
                <input className="input-sm" value={newLoc.town} onChange={e=>setNewLoc(p=>({...p,town:e.target.value}))} placeholder="e.g. Stirling"/>
              </div>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Region</label>
                <input className="input-sm" value={newLoc.region} onChange={e=>setNewLoc(p=>({...p,region:e.target.value}))} placeholder="e.g. Stirlingshire"/>
              </div>
              <div>
                <label style={{fontSize:11,marginBottom:3,display:'block'}}>Google reputation query</label>
                <input className="input-sm" value={newLoc.reputation_query} onChange={e=>setNewLoc(p=>({...p,reputation_query:e.target.value}))} placeholder="e.g. JK Tyres Stirling"/>
              </div>
              <div style={{display:'flex',alignItems:'flex-end',paddingBottom:1}}>
                <button className="btn btn-secondary btn-sm" type="button" onClick={addLocation} disabled={!newLoc.name.trim()}>+ Add</button>
              </div>
            </div>
          )}
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:8}}>Each location runs separate local and regional competitor searches. Google reputation query is used to look up that branch's rating on Google.</div>
        </div>
        {/* ── Search Terms ──────────────────────────────────────────────────── */}
        <div style={{gridColumn:'1/-1',borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
          <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Search Terms <span style={{fontWeight:400,fontSize:10}}>({(meta.search_terms||[]).length}/5) — shared across all locations</span></div>
          <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:8,minHeight:28}}>
            {(meta.search_terms||[]).map((t,i) => (
              <span key={i} style={{fontSize:12,padding:'4px 10px',borderRadius:20,background:'var(--accent)18',border:'1px solid var(--accent)40',color:'var(--accent)',display:'inline-flex',alignItems:'center',gap:6}}>
                {t}
                <button className="btn btn-quiet btn-sm btn-icon" type="button" onClick={()=>removeSearchTerm(i)}>×</button>
              </span>
            ))}
          </div>
          {(meta.search_terms||[]).length < 5 && (
            <div style={{display:'flex',gap:8}}>
              <input value={ssNewTerm} onChange={e=>setSsNewTerm(e.target.value)}
                onKeyDown={e=>{ if(e.key==='Enter'){e.preventDefault();addSearchTerm(ssNewTerm);}}}
                placeholder="e.g. tyre fitting" style={{flex:1}}/>
              <button className="btn btn-secondary" style={{ flexShrink: 0 }} type="button" onClick={()=>addSearchTerm(ssNewTerm)}>Add</button>
            </div>
          )}
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:6}}>Plain-English terms used to find competitors — applied nationally and at each location. Overrides Business Sector for Search Strength discovery.</div>
        </div>
        {/* ── Markets ───────────────────────────────────────────────────────── */}
        <div style={{gridColumn:'1/-1',borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
          <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Markets <span style={{fontWeight:400,fontSize:10}}>({(meta.markets||[]).length}/5) — optional national competitor tracking per country</span></div>
          <div style={{display:'flex',flexWrap:'wrap',gap:8,marginBottom:10}}>
            {(meta.markets||[]).map((m,i) => (
              <span key={i} style={{fontSize:12,padding:'5px 12px',borderRadius:20,background:'var(--surface)',border:'1px solid var(--border)',color:'var(--text)',display:'inline-flex',alignItems:'center',gap:8}}>
                <span style={{fontSize:14}}>{SS_MARKETS.find(x=>x.gl===m.gl)?.flag||'🌐'}</span>
                {m.country}
                <button className="btn btn-quiet btn-sm btn-icon" type="button" onClick={()=>removeMarket(i)}>×</button>
              </span>
            ))}
          </div>
          {(meta.markets||[]).length < 5 && (
            <select className="input-sm"
              defaultValue=""
              onChange={e=>{
                const m = SS_MARKETS.find(x=>x.gl===e.target.value);
                if(m) addMarket(m);
                e.target.value='';
              }}
              style={{ maxWidth:280 }}
            >
              <option value="" disabled>+ Add a market…</option>
              {SS_MARKETS.filter(m=>!(meta.markets||[]).some(x=>x.gl===m.gl)).map(m=>(
                <option key={m.gl} value={m.gl}>{m.flag} {m.country}</option>
              ))}
            </select>
          )}
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:8}}>Each market runs Search Strength competitor searches nationally for that country using the Search Terms above.</div>
        </div>
        <div><label>Contact Name</label><input value={meta.contact||''} onChange={e=>setMeta(p=>({...p,contact:e.target.value}))}/></div>
        <div><label>Contact Email</label><input type="email" value={meta.contact_email||''} onChange={e=>setMeta(p=>({...p,contact_email:e.target.value}))}/></div>
        <div style={{gridColumn:'1/-1',borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
          <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Finance Contact</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
            <div><label>Finance Contact Name</label><input value={meta.finance_contact||''} onChange={e=>setMeta(p=>({...p,finance_contact:e.target.value}))} placeholder="Finance Manager"/></div>
            <div><label>Finance Contact Email</label><input type="email" value={meta.finance_email||''} onChange={e=>setMeta(p=>({...p,finance_email:e.target.value}))} placeholder="finance@client.com"/></div>
            <div style={{gridColumn:'1/-1'}}>
              <label>Xero Contact ID</label>
              <input className="input-sm" value={meta.xero_contact_id||''} onChange={e=>setMeta(p=>({...p,xero_contact_id:e.target.value}))} placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"/>
              <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Paste the UUID from the Xero contact URL. Enables a direct link to their Xero profile.</div>
            </div>
          </div>
        </div>
        <div style={{gridColumn:'1/-1'}}>
          <label>Notes</label>
          <textarea value={meta.notes||''} onChange={e=>setMeta(p=>({...p,notes:e.target.value}))} rows={3} style={{resize:'vertical'}}/>
        </div>
      </div>
      <div style={{borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
        <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Device Management</div>
        <div>
          <label>Action1 Organisation ID</label>
          <input className="input-sm"
            value={meta.action1_org||''}
            onChange={e=>setMeta(p=>({...p,action1_org:e.target.value}))}
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"/>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Find this in your Action1 URL: <span style={{fontFamily:'var(--font-mono)'}}>app.eu.action1.com/console/dashboard?org=...</span></div>
        </div>
      </div>

      <div style={{borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
        <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Microsoft 365</div>
        <div>
          <label>M365 Config Drift Tenant UUID</label>
          <input className="input-sm"
            value={meta.trustm365_tenant_id||''}
            onChange={e=>setMeta(p=>({...p,trustm365_tenant_id:e.target.value}))}
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"/>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Tenant UUID for M365 config drift monitoring.</div>
        </div>
      </div>

      <div style={{borderTop:'1px solid var(--border)',paddingTop:12,marginTop:4}}>
        <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Authentication</div>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
          <input
            type="checkbox"
            id="ms-login-enabled"
            checked={!!meta.ms_login?.enabled}
            onChange={e=>setMeta(p=>({...p,ms_login:{...(p.ms_login||{}),enabled:e.target.checked}}))}
            style={{width:14,height:14,flexShrink:0,cursor:'pointer'}}
          />
          <label htmlFor="ms-login-enabled" style={{fontSize:13,cursor:'pointer'}}>Allow sign-in with Microsoft for this client</label>
        </div>
        <div>
          <label>Microsoft Login Tenant ID</label>
          <div style={{display:'flex',gap:6}}>
            <input className="input-sm"
              value={meta.ms_login?.tenant_id||''}
              onChange={e=>setMeta(p=>({...p,ms_login:{...(p.ms_login||{}),tenant_id:e.target.value}}))}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              style={{ flex:1 }}
            />
            {meta.trustm365_tenant_id && (
              <button className="btn btn-secondary btn-sm"
                type="button"
               
               
                onClick={()=>setMeta(p=>({...p,ms_login:{...(p.ms_login||{}),tenant_id:p.trustm365_tenant_id}}))}
                title="Copy the Microsoft 365 Tenant ID set above into this field"
              >
                Copy from M365
              </button>
            )}
          </div>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>
            The client's Entra (Azure AD) tenant ID. Usually the same GUID as the Microsoft 365 Tenant ID above — copy it from there if already set. This is separate from the Productivity Tenants connection below: enabling sign-in does not require or affect M365 data pulls, and vice versa.
          </div>
          {meta.ms_login?.enabled && !meta.ms_login?.tenant_id && (
            <div style={{fontSize:11,color:'#ff9f0a',marginTop:6}}>⚠ Sign-in is enabled but no Tenant ID is set — Microsoft login will not work for this client until one is added.</div>
          )}
          {meta.ms_login?.enabled && meta.ms_login?.tenant_id && (
            <div style={{fontSize:11,color:'#30d158',marginTop:6}}>● Users with an existing portal account can sign in with Microsoft using this tenant. Local username and password login always remains available.</div>
          )}
        </div>
      </div>

      <div style={{borderTop:'1px solid var(--border)',paddingTop:16}}>
        <SectionTitle>Rename Client</SectionTitle>
        <div style={{display:'flex',gap:8}}>
          <input value={newName} onChange={e=>setNewName(e.target.value)} placeholder={`New name for ${displayName}`} style={{flex:1}}/>
          <button className="btn btn-secondary" type="button" disabled={renaming||!newName.trim()} onClick={rename}>{renaming?<span className="spinner"/>:'Rename'}</button>
        </div>
        <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Renames the folder, archive and updates all linked users.</div>
      </div>

      <div style={{borderTop:'1px solid var(--border)',paddingTop:16}}>
        <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Clearview Agent Enrollment</div>
        <EnrollmentTokenPanel slug={slug}/>
      </div>
    </form>
    <div style={{borderTop:'1px solid var(--border)',paddingTop:16,marginTop:4}}>
      <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:10}}>Productivity Tenants</div>
      <ProductivityTab slug={slug} />
    </div>
    <div style={{borderTop:'1px solid var(--border)',paddingTop:16,marginTop:4}}>
      <XeroPanel slug={slug} />
    </div>
    <div style={{borderTop:'1px solid var(--border)',paddingTop:16,marginTop:4}}>
      <div style={{fontSize:11,fontWeight:600,letterSpacing:'0.07em',textTransform:'uppercase',color:'var(--text-muted)',marginBottom:4}}>Account Watch</div>
      <div style={{fontSize:11,color:'var(--text-muted)',marginBottom:12}}>Monitor specific accounts and receive email and Teams alerts on sign-in activity.</div>
      <WatchedAccountsPanel slug={slug} />
    </div>

    <div style={{borderTop:'1px solid var(--border)',paddingTop:16,marginTop:4}}>
      {dirty && <div className="error-msg" style={{marginBottom:12}}>You have unsaved changes — click Save Settings to apply them.</div>}
      {error && <div className="error-msg" style={{marginBottom:12}}>{error}</div>}
      {codeError && <div className="error-msg" style={{marginBottom:12}}>{codeError}</div>}
      {success && <div className="success-msg" style={{marginBottom:12}}>{success}</div>}
      <div style={{display:'flex',gap:8}}>
        <button className="btn btn-primary" type="button" disabled={saving} onClick={save}>{saving?<span className="spinner"/>:'Save Settings'}</button>
        <button className="btn btn-danger" type="button" onClick={archive}>Archive Client</button>
      </div>
    </div>
    </>
  );
}

// ── Enrollment Token Panel ──────────────────────────────────────────────────────

function EnrollmentTokenPanel({ slug }) {
  const [token, setToken]       = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [generating, setGenerating] = useState(false);
  const [copied, setCopied]     = useState(false);
  const [error, setError]       = useState('');

  const generate = async () => {
    setGenerating(true); setError(''); setToken(''); setExpiresAt('');
    try {
      const r = await authFetch('/api/endpoint/generate-token', {
        method: 'POST',
        body: JSON.stringify({ client_slug: slug }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Failed to generate token');
      setToken(d.token);
      setExpiresAt(d.expires_at);
    } catch (err) { setError(err.message); }
    finally { setGenerating(false); }
  };

  const copy = () => {
    navigator.clipboard.writeText(token).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  };

  const formatExpiry = (iso) => {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleString('en-GB', {
        day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit', timeZone:'Europe/London'
      }) + ' GMT';
    } catch { return iso; }
  };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:10}}>
      <div style={{fontSize:12,color:'var(--text-muted)',lineHeight:1.5}}>
        Generate a one-time enrollment token. Valid for 48 hours.
        For a full install command go to <strong>Device Hub &rsaquo; Clearview Agent</strong>, which builds a ready-to-run PowerShell installer with the token embedded.
      </div>
      {error && <div className="error-msg">{error}</div>}
      {token ? (
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            <input className="input-sm"
              readOnly
              value={token}
              style={{ flex:1 }}
            />
            <button className="btn btn-secondary" style={{ flexShrink: 0, minWidth: 70 }} type="button" onClick={copy}>
              {copied ? '✓ Copied' : 'Copy'}
            </button>
          </div>
          <div style={{fontSize:11,color:'var(--text-muted)'}}>
            Expires: <span style={{fontWeight:600,color:'#e6b800'}}>{formatExpiry(expiresAt)}</span> · Single use only
          </div>
          <button className="btn btn-secondary btn-sm" style={{ alignSelf: 'flex-start' }} type="button" onClick={generate} disabled={generating}>
            {generating ? <span className="spinner"/> : 'Generate New Token'}
          </button>
        </div>
      ) : (
        <button className="btn btn-primary" style={{ alignSelf: 'flex-start' }} type="button" onClick={generate} disabled={generating}>
          {generating ? <span className="spinner"/> : 'Generate Enrollment Token'}
        </button>
      )}
    </div>
  );
}

// ── Security tab ───────────────────────────────────────────────────────────────

const CYBER_TOOLS = [
  { id: 'harvester',    label: 'Harvester',           desc: 'OSINT subdomain and IP discovery',         schedule: '01:00' },
  { id: 'headers',      label: 'HTTP Headers',         desc: 'Security header configuration check',      schedule: '02:00' },
  { id: 'abuseipdb',   label: 'IP Reputation',        desc: 'AbuseIPDB check on public IPs',            schedule: '02:15' },
  { id: 'shodan',       label: 'Internet Exposure',    desc: 'Shodan open port and CVE check',           schedule: '02:30' },
  { id: 'wpscan',       label: 'WordPress',            desc: 'WordPress vulnerability scan',             schedule: '02:45' },
  { id: 'blacklist',    label: 'Email Blacklists',     desc: 'DNS blacklist check on mail servers',      schedule: '03:00' },
  { id: 'portals',      label: 'Exposed Portals',      desc: 'Admin panel and login page detection',     schedule: '03:15' },
  { id: 'certs',        label: 'Certificates',         desc: 'SSL cert expiry and CT log monitoring',    schedule: '03:30' },
  { id: 'urlhaus',      label: 'Threat Feeds',         desc: 'URLhaus malware and threat feed check',    schedule: '03:45' },
  { id: 'phishing',     label: 'Phishing Detection',   desc: 'Lookalike and typosquat domain sweep',     schedule: '04:00' },
  { id: 'buckets',      label: 'Cloud Storage',        desc: 'Public cloud bucket detection',            schedule: '04:15' },
  { id: 'takeover',     label: 'Subdomain Takeover',   desc: 'Dangling CNAME vulnerability check',       schedule: '04:30' },
  { id: 'credexposure', label: 'Exposed Files',        desc: 'Config file and credential exposure',      schedule: '04:45' },
  { id: 'dbexposure',   label: 'Database Exposure',    desc: 'Open database service detection',          schedule: '05:00' },
  { id: 'dnsmonitor',   label: 'DNS Monitoring',       desc: 'DNS record change detection',              schedule: '05:15' },
  { id: 'portscan',     label: 'Port Scan',            desc: 'External port scan of site public IPs',    schedule: '05:30' },
];

function SecurityTab({ slug }) {
  const [toolData, setToolData] = useState({});
  const [running, setRunning]   = useState({});
  const [error, setError]       = useState('');

  useEffect(() => {
    // Load scanned_at for each tool
    const endpoints = {
      harvester: 'harvester', headers: 'headers', abuseipdb: 'abuseipdb',
      shodan: 'shodan', wpscan: 'wpscan', blacklist: 'blacklist',
      portals: 'portals', certs: 'certs', urlhaus: 'urlhaus', phishing: 'phishing',
      buckets: 'buckets', takeover: 'takeover', credexposure: 'credexposure',
      dbexposure: 'dbexposure', dnsmonitor: 'dnsmonitor', portscan: 'portscan',
    };
    Object.entries(endpoints).forEach(([id, ep]) => {
      authFetch(`/api/clients/${slug}/${ep}`)
        .then(r => r.json())
        .then(d => setToolData(prev => ({...prev, [id]: d})))
        .catch(() => {});
    });
  }, [slug]);

  const runTool = async (id) => {
    setRunning(r => ({...r, [id]: true})); setError('');
    try {
      const r = await authFetch(`/api/clients/${slug}/cyber/run/${id}`, { method: 'POST' });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Run failed');
    } catch (err) { setError(`${id}: ${err.message}`); }
    finally { setRunning(r => ({...r, [id]: false})); }
  };

  return (
    <div>
      <SectionTitle>Cyber Security Checks</SectionTitle>
      <div style={{fontSize:11,color:'var(--text-muted)',marginBottom:16}}>All checks run automatically overnight. Use ↺ Run to trigger immediately.</div>
      {error && <div className="error-msg" style={{marginBottom:12}}>{error}</div>}
      <div style={{display:'flex',flexDirection:'column',gap:6}}>
        {CYBER_TOOLS.map(tool => {
          const d = toolData[tool.id];
          const scannedAt = d?.data?.scanned_at || d?.scanned_at;
          return (
            <div key={tool.id} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600}}>{tool.label}</div>
                <div style={{fontSize:11,color:'var(--text-muted)',marginTop:1}}>{tool.desc}</div>
              </div>
              <div style={{textAlign:'right',flexShrink:0}}>
                {scannedAt && d?.available
                  ? <div style={{fontSize:11,color:'#30d158'}}>{fmtDate(scannedAt)}</div>
                  : <div style={{fontSize:11,color:'var(--text-muted)'}}>No data yet · {tool.schedule} GMT</div>
                }
              </div>
              <button className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }}
                disabled={running[tool.id]} onClick={() => runTool(tool.id)}>
                {running[tool.id] ? <span className="spinner"/> : '↺ Run'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Run assessment (v3.75) ────────────────────────────────────────────────────

function AssessmentPanel({ client, onRefresh }) {
  const [status,     setStatus]     = useState(null);   // null | 'running' | 'done' | 'failed'
  const [started,    setStarted]    = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [busy,       setBusy]       = useState(false);
  const [error,      setError]      = useState('');
  const [officeIps,  setOfficeIps]  = useState(null);
  const pollRef = useRef(null);
  const sawRunning = useRef(false);   // only report finished or failed for a run seen here
  const domains = (client.meta?.domains || '').split(/[,\n]/).map(d => d.trim()).filter(Boolean);

  const check = useCallback(() => {
    return authFetch(`/api/assessments/${client.slug}/status`)
      .then(r => r.json())
      .then(d => {
        if (!d || d.status === 'unknown') { setStatus(null); return false; }
        setStarted(d.started || null);
        if (!d.done) { sawRunning.current = true; setStatus('running'); return true; }
        if (!sawRunning.current) { setStatus(null); return false; }
        setStatus(d.exit_code === 0 || d.exit_code === null ? 'done' : 'failed');
        return false;
      })
      .catch(() => false);
  }, [client.slug]);

  const startPolling = useCallback(() => {
    if (pollRef.current) return;
    pollRef.current = setInterval(() => {
      check().then(stillRunning => {
        if (!stillRunning) {
          clearInterval(pollRef.current);
          pollRef.current = null;
          if (onRefresh) onRefresh();
        }
      });
    }, 15000);
  }, [check, onRefresh]);

  useEffect(() => {
    check().then(running => { if (running) startPolling(); });
    return () => { if (pollRef.current) clearInterval(pollRef.current); pollRef.current = null; };
  }, [check, startPolling]);

  const run = async () => {
    setConfirming(false); setBusy(true); setError('');
    try {
      const r = await authFetch(`/api/clients/${client.slug}/assessment/run`, { method: 'POST' });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) {
        setError(r.status === 429 ? 'Too many assessments started in the last hour. Try again later.' : (d.error || 'Could not start the assessment'));
      } else {
        sawRunning.current = true;
        setOfficeIps(Array.isArray(d.office_ips) ? d.office_ips : []);
        setStatus('running');
        setStarted(new Date().toISOString());
        startPolling();
      }
    } catch {
      setError('Could not start the assessment');
    }
    setBusy(false);
  };

  const watchLink = `/new?slug=${encodeURIComponent(client.slug)}&client=${encodeURIComponent(client.display_name)}`;
  const fmtTime = iso => {
    if (!iso) return '';
    const d = new Date(iso.endsWith('Z') || iso.includes('+') ? iso : iso + 'Z');
    return isNaN(d) ? '' : d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
  };

  return (
    <div style={{marginBottom:16}}>
      <SectionTitle>Assessment</SectionTitle>
      <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:'12px 14px',display:'flex',flexDirection:'column',gap:10}}>
        <div style={{display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
          <div style={{flex:1,minWidth:200}}>
            <div style={{fontSize:13,fontWeight:600,color:'var(--text)'}}>
              {client.latest_report?.date
                ? <>Last assessed {fmtDate(client.latest_report.date)}{client.latest_report?.grade ? ` · Grade ${client.latest_report.grade}` : ''}</>
                : 'Not assessed yet'}
            </div>
            <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>
              {domains.length
                ? <>Scans {domains.join(', ')}</>
                : <span style={{color:'var(--amber)'}}>No domains set. Add them in the Settings tab first.</span>}
            </div>
          </div>

          {status === 'running' ? (
            <div style={{display:'flex',alignItems:'center',gap:10}}>
              <span style={{display:'inline-flex',alignItems:'center',gap:6,fontSize:12,color:'var(--accent)',fontWeight:600}}>
                <span className="spinner" style={{width:12,height:12}}/> Running{started ? ` since ${fmtTime(started)}` : ''}
              </span>
              <Link className="btn btn-secondary btn-sm" to={watchLink}>Watch progress</Link>
            </div>
          ) : confirming ? (
            <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
              <span style={{fontSize:12,color:'var(--accent)',fontWeight:600}}>Run a full external assessment now?</span>
              <button className="btn btn-primary btn-sm" onClick={run}>Confirm</button>
              <button className="btn btn-secondary btn-sm" onClick={() => setConfirming(false)}>Cancel</button>
            </div>
          ) : (
            <button className="btn btn-primary btn-sm" disabled={busy || !domains.length} onClick={() => { setError(''); setConfirming(true); }}>
              {busy ? 'Starting…' : client.latest_report ? 'Re-run assessment' : 'Run assessment'}
            </button>
          )}
        </div>

        {confirming && (
          <div style={{fontSize:11,color:'var(--text-muted)'}}>
            This scans the domains above from the internet and can take an hour or more. Only run it if the client has agreed to be scanned.
          </div>
        )}
        {status === 'running' && officeIps && (
          <div style={{fontSize:11,color:'var(--text-muted)'}}>
            {officeIps.length
              ? <>Office IPs included in the port scan: {officeIps.map(o => `${o.ip} (${o.site})`).join(', ')}</>
              : 'No office IPs on record for this client, so only its domains are scanned. Name its sites in Network Labels to include them.'}
          </div>
        )}
        {status === 'done' && (
          <div style={{fontSize:12,color:'var(--green)'}}>
            Assessment finished. The new report is on the Reports tab.
          </div>
        )}
        {status === 'failed' && (
          <div style={{fontSize:12,color:'var(--red)'}}>
            The last assessment finished with errors, so the report may not have been created. <Link to={watchLink} style={{color:'var(--accent)'}}>See the scan output</Link>.
          </div>
        )}
        {error && <div style={{fontSize:12,color:'var(--red)'}}>{error}</div>}
      </div>
    </div>
  );
}

// ── Company details (v3.78) ───────────────────────────────────────────────────

function CompanyDetails({ meta }) {
  const rows = [
    ['Companies House', meta.company_number ? (
      <a href={`https://find-and-update.company-information.service.gov.uk/company/${meta.company_number}`} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',textDecoration:'none'}}>{meta.company_number} ↗</a>
    ) : null],
    ['Company type', meta.company_type ? meta.company_type.replace(/-/g, ' ').replace(/^\w/, c => c.toUpperCase()) : null],
    ['Incorporated', meta.incorporated ? fmtDate(meta.incorporated) : null],
    ['Registered address', meta.registered_address || null],
    ['Website', meta.website ? <a href={meta.website} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',textDecoration:'none'}}>{meta.website.replace(/^https?:\/\//, '')} ↗</a> : null],
    ['Phone', meta.phone ? <a href={`tel:${meta.phone}`} style={{color:'var(--accent)',textDecoration:'none'}}>{meta.phone}</a> : null],
    ['Account manager', meta.account_manager || null],
  ].filter(([, v]) => v);
  const contacts = Array.isArray(meta.contacts) ? meta.contacts.filter(c => c && c.name) : [];
  if (!rows.length && !contacts.length) return null;
  return (
    <div style={{marginBottom:16}}>
      <SectionTitle>Company Details{meta.source === 'sales_pipeline' ? <span style={{fontWeight:500,textTransform:'none',letterSpacing:0,color:'var(--text-muted)'}}> · from the sales pipeline</span> : null}</SectionTitle>
      <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:'12px 14px',display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:'10px 20px'}}>
        {rows.map(([k, v]) => (
          <div key={k}>
            <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.08em',fontWeight:600}}>{k}</div>
            <div style={{fontSize:13,color:'var(--text)',marginTop:2}}>{v}</div>
          </div>
        ))}
      </div>
      {contacts.length > 0 && (
        <div style={{marginTop:8,background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
          {contacts.map((c, i) => (
            <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'8px 14px',borderTop:i?'1px solid var(--border)':'none',fontSize:12,flexWrap:'wrap'}}>
              <span style={{fontWeight:600,color:'var(--text)',minWidth:160}}>{c.name}</span>
              <span style={{color:'var(--text-muted)',minWidth:120}}>{c.role || '—'}</span>
              {c.email && <a href={`mailto:${c.email}`} style={{color:'var(--accent)',textDecoration:'none'}}>{c.email}</a>}
              {c.phone && <span style={{color:'var(--text-muted)'}}>{c.phone}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Overview tab ───────────────────────────────────────────────────────────────

function OverviewTab({ client, users, onRefresh }) {
  const linkedUsers = users.filter(u => u.client_slug === client.slug);
  return (
    <div>
      <div style={{display:'flex',gap:12,flexWrap:'wrap',marginBottom:20}}>
        <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:'12px 18px',flex:'1 1 100px',minWidth:100}}>
          <div style={{fontSize:22,fontWeight:800,fontFamily:'var(--font-mono)',lineHeight:1,marginBottom:4}}>{client.report_count}</div>
          <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.1em',fontWeight:600}}>Assessments</div>
        </div>
        {[['IT Health Grade', client.it_health], ['External Grade', client.latest_report]].map(([lbl, r]) => r?.grade && (
          <div key={lbl} style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:'12px 18px',flex:'1 1 100px',minWidth:100}}>
            <div style={{fontSize:22,fontWeight:800,fontFamily:'var(--font-mono)',lineHeight:1,marginBottom:4}}>{r.grade}</div>
            <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.1em',fontWeight:600}}>{lbl}</div>
          </div>
        ))}
        <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:'12px 18px',flex:'1 1 100px',minWidth:100}}>
          <div style={{fontSize:22,fontWeight:800,fontFamily:'var(--font-mono)',lineHeight:1,marginBottom:4}}>{linkedUsers.length}</div>
          <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.1em',fontWeight:600}}>Users</div>
        </div>
      </div>

      <AssessmentPanel client={client} onRefresh={onRefresh}/>
      <CompanyDetails meta={client.meta || {}}/>

      {(client.meta?.finance_contact || client.meta?.finance_email || client.meta?.xero_contact_id) && (
        <div style={{marginBottom:16}}>
          <SectionTitle>Finance Contact</SectionTitle>
          <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:'12px 14px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,flexWrap:'wrap'}}>
            <div>
              {client.meta?.finance_contact && <div style={{fontSize:13,fontWeight:600,color:'var(--text)'}}>{client.meta.finance_contact}</div>}
              {client.meta?.finance_email && (
                <a href={`mailto:${client.meta.finance_email}`} style={{fontSize:12,color:'var(--accent)',textDecoration:'none'}}>
                  {client.meta.finance_email}
                </a>
              )}
            </div>
            {client.meta?.xero_contact_id && (
              <a className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }} href={`https://go.xero.com/Contacts/View/${client.meta.xero_contact_id}`}
                target="_blank" rel="noopener noreferrer"
               >
                <span style={{fontSize:14}}></span> View in Xero
              </a>
            )}
          </div>
        </div>
      )}

      {linkedUsers.length > 0 && (
        <div>
          <SectionTitle>Linked Users</SectionTitle>
          <div style={{display:'flex',flexDirection:'column',gap:6}}>
            {linkedUsers.map(u => (
              <div key={u.username} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
                <div className="client-user-avatar" style={{width:28,height:28,fontSize:12}}>{u.username[0].toUpperCase()}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:600}}>{u.username}</div>
                  <div style={{fontSize:11,color:'var(--text-muted)'}}>{u.email || ''}</div>
                </div>
                {u.blocked && <span style={{fontSize:10,color:'#ff2d55',background:'#ff2d5518',border:'1px solid #ff2d5540',borderRadius:3,padding:'2px 6px'}}>Blocked</span>}
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{marginTop:16}}>
        <a className="btn btn-secondary btn-sm" href={`/clients/${client.slug}?as=client`} target="_blank" rel="noopener noreferrer">
          View as Client →
        </a>
        <div style={{fontSize:11,color:'var(--text-muted)',marginTop:6}}>Opens in new tab with client navigation</div>
      </div>
    </div>
  );
}



// ── Inline hub wrappers ───────────────────────────────────────────────────────
// These pull in the real hub components without the full page chrome

// ── Clearview Agent tab (inline admin version) ────────────────────────────────


// ── Device enrichment pills ───────────────────────────────────────────────────
function DeviceEnrichmentPillsMgmt({ dev }) {
  const pills = [];

  // Hardware make/model
  if (dev.hardware?.manufacturer || dev.hardware?.model) {
    const label = [dev.hardware.manufacturer, dev.hardware.model].filter(Boolean).join(' ');
    pills.push(
      <span key="hardware" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,
        padding:'2px 7px',borderRadius:4,background:'var(--surface)',border:'1px solid var(--border)',color:'var(--text-muted)'}}>
         {label}
      </span>
    );
  }

  // Firmware updates pending
  if (dev.firmware_updates?.length) {
    const oldest = dev.firmware_updates.reduce((a, b) =>
      new Date(a.detected_at) < new Date(b.detected_at) ? a : b);
    const ageDays = oldest.detected_at
      ? Math.floor((Date.now() - new Date(oldest.detected_at)) / 86400000)
      : null;
    const overdue  = ageDays !== null && ageDays >= 14;
    const color    = overdue ? '#ff2d55' : '#e6b800';
    const bg       = overdue ? '#ff2d5518' : '#e6b80018';
    const bdr      = overdue ? '#ff2d5540' : '#e6b80040';
    const ageLabel = ageDays !== null ? ` · ${ageDays}d` : '';
    pills.push(
      <span key="firmware" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,fontWeight:600,
        padding:'2px 7px',borderRadius:4,background:bg,border:`1px solid ${bdr}`,color}}
        title={dev.firmware_updates.map(u => u.title).join('\n')}>
        ⬆ Firmware update pending{ageLabel}{overdue ? ' — overdue' : ''}
      </span>
    );
  }

  if (dev.pending_reboot?.pending) {
    pills.push(
      <span key="reboot" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,fontWeight:600,
        padding:'2px 7px',borderRadius:4,background:'#e6b80018',border:'1px solid #e6b80040',color:'#e6b800'}}>
        ↺ Reboot required
      </span>
    );
  }

  if (dev.logged_in_user) {
    pills.push(
      <span key="user" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,
        padding:'2px 7px',borderRadius:4,background:'var(--surface)',border:'1px solid var(--border)',color:'var(--text-muted)'}}>
         {dev.logged_in_user}
      </span>
    );
  }

  if (dev.uptime_seconds > 0) {
    const days = Math.floor(dev.uptime_seconds / 86400);
    const hrs  = Math.floor((dev.uptime_seconds % 86400) / 3600);
    const label = days > 0 ? `Up ${days}d ${hrs}h` : `Up ${hrs}h`;
    const amber = days >= 7;
    pills.push(
      <span key="uptime" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,
        padding:'2px 7px',borderRadius:4,
        background:amber?'#e6b80018':'var(--surface)',
        border:`1px solid ${amber?'#e6b80040':'var(--border)'}`,
        color:amber?'#e6b800':'var(--text-muted)'}}>
        ⏱ {label}
      </span>
    );
  }

  if (dev.disk_space?.length) {
    dev.disk_space.forEach(drive => {
      const pct = drive.used_pct;
      const red   = pct >= 95;
      const amber = pct >= 85 && !red;
      const color = red ? '#ff2d55' : amber ? '#e6b800' : 'var(--text-muted)';
      const bg    = red ? '#ff2d5518' : amber ? '#e6b80018' : 'var(--surface)';
      const bdr   = red ? '#ff2d5540' : amber ? '#e6b80040' : 'var(--border)';
      pills.push(
        <span key={`disk-${drive.letter}`} style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,
          padding:'2px 7px',borderRadius:4,background:bg,border:`1px solid ${bdr}`,color}}>
           {drive.letter} {Math.round(pct)}%
        </span>
      );
    });
  }

  if (dev.battery) {
    const pct      = dev.battery.percent_remaining;
    const charging = dev.battery.charging;
    const lowBatt  = pct < 20 && !charging;
    const chargeColor = charging ? '#30d158' : lowBatt ? '#ff2d55' : 'var(--text-muted)';
    const chargeBg    = charging ? '#30d15818' : lowBatt ? '#ff2d5518' : 'var(--surface)';
    const chargeBdr   = charging ? '#30d15840' : lowBatt ? '#ff2d5540' : 'var(--border)';
    pills.push(
      <span key="battery-charge" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,
        padding:'2px 7px',borderRadius:4,background:chargeBg,border:`1px solid ${chargeBdr}`,color:chargeColor}}>
        {charging ? '⚡' : ''} {pct}%
      </span>
    );
    if (dev.battery.health_pct > 0) {
      const h     = dev.battery.health_pct;
      const hRed  = h < 60;
      const hAmb  = h < 80 && !hRed;
      const hGrn  = h >= 80;
      const hColor = hRed ? '#ff2d55' : hAmb ? '#e6b800' : '#30d158';
      const hBg    = hRed ? '#ff2d5518' : hAmb ? '#e6b80018' : '#30d15818';
      const hBdr   = hRed ? '#ff2d5540' : hAmb ? '#e6b80040' : '#30d15840';
      pills.push(
        <span key="battery-health" style={{display:'inline-flex',alignItems:'center',gap:3,fontSize:10,
          padding:'2px 7px',borderRadius:4,background:hBg,border:`1px solid ${hBdr}`,color:hColor}}>
          Battery Health {Math.round(h)}%
        </span>
      );
    }
  }

  if (!pills.length) return null;
  return (
    <div style={{display:'flex',flexWrap:'wrap',gap:4,marginTop:4}}>
      {pills}
    </div>
  );
}


// ── iperf3 performance panel (management view) ───────────────────────────────
function IperfSparklineMgmt({ points, color, height }) {
  if (!points || points.length < 2) return null;
  const W = 600;
  const H = height * 4;
  const max = Math.max(...points, 1);
  const min = Math.min(...points);
  const range = (max - min) || max || 1;
  const pad = 8;
  const w = W - pad * 2;
  const h = H - pad * 2;
  const coords = points.map((v, i) => {
    const x = pad + (i / (points.length - 1)) * w;
    const y = pad + h - ((v - min) / range) * h;
    return `${x},${y}`;
  });
  const areaPoints = `${pad},${H - pad} ${coords.join(' ')} ${pad + w},${H - pad}`;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={height} preserveAspectRatio="none" style={{display:'block'}}>
      <polygon points={areaPoints} fill={color} fillOpacity="0.08" />
      <polyline points={coords.join(' ')} fill="none" stroke={color} strokeWidth="3" strokeLinejoin="round" />
    </svg>
  );
}

function IperfPanelMgmt({ slug, deviceId }) {
  const [data, setData]             = useState(null);
  const [loading, setLoading]       = useState(true);
  const [triggering, setTriggering] = useState(false);
  const [triggered, setTriggered]   = useState(false);

  useEffect(() => {
    authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/iperf`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug, deviceId]);

  const handleTrigger = async () => {
    setTriggering(true);
    try {
      await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/iperf-trigger`, { method: 'POST' });
      setTriggered(true);
      setTimeout(() => setTriggered(false), 5000);
    } finally {
      setTriggering(false);
    }
  };

  const targetColors = { 'STG Services': '#00d4ff', 'Local Network': '#30d158' };

  if (loading) return (
    <div style={{padding:'8px 14px',fontSize:11,color:'var(--text-muted)'}}>
      Loading performance data...
    </div>
  );

  const latest  = data?.history?.[0];
  const history = (data?.history||[]).slice().reverse();
  const allTargets = [...new Set(history.flatMap(h => h.results?.filter(r=>r.status==='ok').map(r=>r.label)||[]))];

  return (
    <div style={{padding:'10px 14px',background:'rgba(0,212,255,0.02)'}}>
      {/* Latest summary row */}
      <div style={{display:'flex',flexWrap:'wrap',gap:6,alignItems:'center',marginBottom:8}}>
        <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginRight:4}}>Network Performance</span>
        {latest?.results?.filter(r => r.status === 'ok').map(r => (
          <span key={r.label} style={{fontSize:11,padding:'2px 7px',borderRadius:4,
            background:'var(--surface)',border:`1px solid ${targetColors[r.label]||'var(--accent)'}40`}}>
            <span style={{color:targetColors[r.label]||'var(--accent)',fontWeight:600,marginRight:4}}>{r.label}</span>
            <span>↓{r.download_mbps?.toFixed(0)} ↑{r.upload_mbps?.toFixed(0)} Mbps</span>
            {r.latency_ms > 0 && <span style={{color:'var(--text-muted)',marginLeft:4}}>{r.latency_ms?.toFixed(0)}ms</span>}
          </span>
        ))}
        {latest?.results?.filter(r => r.status === 'off_site').map(r => (
          <span key={r.label} style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'var(--surface)',border:'1px solid var(--border)',color:'var(--text-muted)'}}>
            {r.label}: Not on company site
          </span>
        ))}
        {latest?.results?.filter(r => r.status === 'blocked').map(r => (
          <span key={r.label} style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'#e6b80018',border:'1px solid #e6b80040',color:'#e6b800'}}>
            {r.label}: Blocked
          </span>
        ))}
        {!latest && <span style={{fontSize:11,color:'var(--text-muted)'}}>No data yet — tests run every 4 hours.</span>}
        <button className="btn btn-secondary btn-sm" aria-pressed={!(triggered)} style={{ marginLeft: 'auto' }} onClick={handleTrigger} disabled={triggering||triggered}
         >
          {triggered ? '✓ Queued' : triggering ? '...' : '▶ Run Test'}
        </button>
      </div>

      {/* Sparkline charts per target — stacked with download and ping */}
      {history.length > 1 && allTargets.length > 0 && (
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {allTargets.map(label => {
            const dlPoints   = history.map(h => h.results?.find(r=>r.label===label&&r.status==='ok')?.download_mbps||null).filter(v=>v!==null);
            const pingPoints = history.map(h => h.results?.find(r=>r.label===label&&r.status==='ok')?.latency_ms||null).filter(v=>v!==null);
            if (!dlPoints.length) return null;
            return (
              <div key={label}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:2}}>
                  <span style={{width:8,height:8,borderRadius:'50%',background:targetColors[label]||'var(--accent)',flexShrink:0,display:'inline-block'}}/>
                  <span style={{fontSize:10,fontWeight:600,color:targetColors[label]||'var(--accent)'}}>{label}</span>
                  <span style={{fontSize:10,color:'var(--text-muted)'}}>↓ Download Mbps</span>
                </div>
                <IperfSparklineMgmt points={dlPoints} color={targetColors[label]||'var(--accent)'} height={50} />
                {pingPoints.length > 1 && pingPoints.some(p=>p>0) && (
                  <div style={{marginTop:2}}>
                    <span style={{fontSize:10,color:'var(--text-muted)'}}>Ping ms</span>
                    <IperfSparklineMgmt points={pingPoints} color={'#86868b'} height={30} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}


function OsquerySecurityPanelMgmt({ slug, deviceId }) {
  const [data, setData]           = useState(null);
  const [loading, setLoading]     = useState(true);
  const [triggering, setTriggering] = useState(false);
  const [triggered, setTriggered] = useState(false);
  const [expandedCve, setExpandedCve] = useState(null);
  const [showAllPorts, setShowAllPorts] = useState(false);

  useEffect(() => {
    authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/osquery-scan`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug, deviceId]);

  const handleTrigger = async () => {
    setTriggering(true);
    try {
      await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/osquery-scan-trigger`, { method: 'POST' });
      setTriggered(true);
      setTimeout(() => setTriggered(false), 5000);
    } finally {
      setTriggering(false);
    }
  };

  const cvssColor = (cvss) => {
    if (cvss >= 9) return '#ff2d55';
    if (cvss >= 7) return '#ff9f0a';
    if (cvss >= 4) return '#e6b800';
    return '#30d158';
  };

  const scStateColor = (item) => {
    const s = (item.state || '').toLowerCase();
    if (s === 'good' || s === 'on') return '#30d158';
    if (s === 'warn') return '#e6b800';
    if (s.includes('off') || s.includes('disabled')) return '#ff2d55';
    return '#e6b800';
  };

  if (loading) return (
    <div style={{padding:'8px 14px',fontSize:11,color:'var(--text-muted)'}}>
      Loading security scan...
    </div>
  );

  if (!data?.available) return (
    <div style={{padding:'8px 14px'}}>
      <div style={{display:'flex',alignItems:'center',gap:8}}>
        <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em'}}>Security Scan</span>
        <span style={{fontSize:11,color:'var(--text-muted)'}}>No scan data yet — scans run daily.</span>
        <button className="btn btn-secondary btn-sm" onClick={handleTrigger} disabled={triggering||triggered} style={{marginLeft:'auto', color: triggered ? 'var(--green-ink)' : undefined}}>
          {triggered ? '✓ Queued' : triggering ? '...' : '▶ Run Scan'}
        </button>
      </div>
    </div>
  );

  const cveFindings  = (data.cve_findings || []).filter(f => f.cves?.length > 0);
  const enriched     = !!data.cve_enriched_at;
  const criticalCnt  = cveFindings.reduce((a, f) => a + f.cves.filter(c => c.cvss >= 9).length, 0);
  const highCnt      = cveFindings.reduce((a, f) => a + f.cves.filter(c => c.cvss >= 7 && c.cvss < 9).length, 0);
  const secCenter    = (data.security_center || []);
  const localAdmins  = (data.local_admins || []);
  const ports        = (data.ports || []);
  const patches      = (data.patches || []);

  const scannedAt = data.scanned_at
    ? new Date(data.scanned_at).toLocaleString('en-GB', {
        day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit', timeZone:'Europe/London'
      }) + ' GMT'
    : '';

  return (
    <div style={{padding:'10px 14px',background:'rgba(255,45,85,0.02)'}}>

      {/* Header row */}
      <div style={{display:'flex',flexWrap:'wrap',gap:6,alignItems:'center',marginBottom:10}}>
        <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginRight:4}}>
          Security Scan
        </span>
        {enriched && criticalCnt > 0 && (
          <span style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'#ff2d5518',border:'1px solid #ff2d5540',color:'#ff2d55',fontWeight:600}}>
            {criticalCnt} Critical
          </span>
        )}
        {enriched && highCnt > 0 && (
          <span style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'#ff9f0a18',border:'1px solid #ff9f0a40',color:'#ff9f0a',fontWeight:600}}>
            {highCnt} High
          </span>
        )}
        {enriched && criticalCnt === 0 && highCnt === 0 && (
          <span style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'#30d15818',border:'1px solid #30d15840',color:'#30d158',fontWeight:600}}>
            No CVE findings
          </span>
        )}
        {!enriched && (
          <span style={{fontSize:11,color:'var(--text-muted)'}}>CVE analysis pending...</span>
        )}
        {scannedAt && (
          <span style={{fontSize:10,color:'var(--text-muted)',marginLeft:2}}>Updated {scannedAt}</span>
        )}
        <button className="btn btn-secondary btn-sm" onClick={handleTrigger} disabled={triggering||triggered} style={{marginLeft:'auto', color: triggered ? 'var(--green-ink)' : undefined}}>
          {triggered ? '✓ Queued' : triggering ? '...' : '▶ Run Scan'}
        </button>
      </div>

      {/* Security Center tiles */}
      {secCenter.length > 0 && (
        <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:10}}>
          {secCenter.map((item, i) => {
            const col = scStateColor(item);
            return (
              <div key={i} style={{display:'flex',alignItems:'center',gap:6,padding:'4px 10px',
                borderRadius:6,border:`1px solid ${col}40`,background:`${col}10`}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:col,flexShrink:0}}/>
                <span style={{fontSize:11,color:'var(--text)',fontWeight:500,maxWidth:180,overflow:'hidden',
                  textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item.name}</span>
                {!item.signatures_up_to_date && (
                  <span style={{fontSize:10,color:'#e6b800',fontWeight:600,flexShrink:0}}>Defs outdated</span>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Local Admins */}
      {localAdmins.length > 0 && (
        <div style={{marginBottom:10}}>
          <div style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',
            letterSpacing:'0.07em',marginBottom:4}}>
            Local Administrators ({localAdmins.length})
          </div>
          <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
            {localAdmins.map((u, i) => (
              <span key={i} style={{fontSize:11,padding:'2px 8px',borderRadius:4,
                background:'rgba(0,212,255,0.08)',border:'1px solid rgba(0,212,255,0.2)',color:'var(--text)'}}>
                {u.username}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* CVE Findings */}
      {enriched && cveFindings.length > 0 && (
        <div style={{marginBottom:10}}>
          <div style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:4}}>
            Potential CVE Findings
            <span style={{fontWeight:400,textTransform:'none',marginLeft:6,fontSize:10,opacity:0.7}}>
              based on installed software — verify applicability to installed version
            </span>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:3}}>
            {cveFindings.map((finding, fi) => {
              const isExp   = expandedCve === fi;
              const topCvss = finding.cves?.[0]?.cvss || 0;
              const topCol  = cvssColor(topCvss);
              return (
                <div key={fi} style={{borderRadius:6,border:'1px solid var(--border)',overflow:'hidden'}}>
                  <div onClick={() => setExpandedCve(isExp ? null : fi)}
                    style={{display:'flex',alignItems:'center',gap:8,padding:'5px 10px',cursor:'pointer',
                      background:isExp?'rgba(0,212,255,0.03)':'transparent'}}>
                    <span style={{fontSize:11,fontWeight:600,color:'var(--text)',flex:1,
                      overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                      {finding.program}
                    </span>
                    <span style={{fontSize:10,color:'var(--text-muted)',flexShrink:0}}>{finding.version}</span>
                    <span style={{fontSize:10,padding:'1px 6px',borderRadius:3,flexShrink:0,fontWeight:600,
                      background:`${topCol}18`,border:`1px solid ${topCol}40`,color:topCol}}>
                      {finding.cves.length} CVE{finding.cves.length !== 1 ? 's' : ''} · {finding.cves[0]?.severity}
                    </span>
                    <span style={{fontSize:10,color:'var(--text-muted)'}}>{isExp ? '▲' : '▼'}</span>
                  </div>
                  {isExp && (
                    <div style={{borderTop:'1px solid var(--border)',background:'var(--surface)'}}>
                      {finding.cves.map((cve, ci) => (
                        <div key={ci} style={{display:'flex',alignItems:'flex-start',gap:8,padding:'5px 10px',
                          borderBottom:ci < finding.cves.length - 1 ? '1px solid var(--border)' : 'none'}}>
                          <span style={{fontSize:10,padding:'1px 5px',borderRadius:3,flexShrink:0,fontWeight:600,
                            background:cvssColor(cve.cvss)+'18',border:`1px solid ${cvssColor(cve.cvss)}40`,
                            color:cvssColor(cve.cvss),minWidth:36,textAlign:'center'}}>
                            {cve.cvss.toFixed(1)}
                          </span>
                          <span style={{fontSize:10,fontFamily:'var(--font-mono)',color:'var(--accent)',
                            flexShrink:0,minWidth:100}}>{cve.id}</span>
                          <span style={{fontSize:10,color:'var(--text)',overflow:'hidden',
                            textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{cve.description}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {enriched && cveFindings.length === 0 && patches.length > 0 && (
        <div style={{fontSize:11,color:'var(--text-muted)',marginBottom:10}}>
          {patches.length} Windows patch{patches.length !== 1 ? 'es' : ''} installed · no CVE matches found
        </div>
      )}

      {/* Listening Ports */}
      {ports.length > 0 && (
        <div>
          <div style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',
            letterSpacing:'0.07em',marginBottom:4}}>
            Listening Ports ({ports.length})
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:2}}>
            {(showAllPorts ? ports : ports.slice(0, 12)).map((p, i) => (
              <div key={i} style={{display:'flex',alignItems:'center',gap:8,padding:'3px 8px',
                borderRadius:4,background:'var(--surface)',border:'1px solid var(--border)'}}>
                <span style={{fontSize:11,fontFamily:'var(--font-mono)',color:'var(--accent)',minWidth:65,flexShrink:0}}>
                  {p.port}/{p.protocol}
                </span>
                <span style={{fontSize:11,color:'var(--text)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {p.process || 'unknown'}
                </span>
              </div>
            ))}
            {ports.length > 12 && (
              <button className="btn btn-quiet btn-sm" style={{ textAlign: 'left' }} onClick={() => setShowAllPorts(!showAllPorts)}
               >
                {showAllPorts ? 'Show less' : `+${ports.length - 12} more ports`}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function ScreenshotPanelMgmt({ slug, deviceId }) {
  const [data, setData]             = useState(null);
  const [loading, setLoading]       = useState(true);
  const [triggering, setTriggering] = useState(false);
  const [triggered, setTriggered]   = useState(false);
  const [polling, setPolling]       = useState(false);
  const [lightbox, setLightbox]     = useState(false);
  const pollRef                     = useRef(null);

  const fetchScreenshot = () =>
    authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/screenshot`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); return d; })
      .catch(() => { setLoading(false); });

  useEffect(() => {
    fetchScreenshot();
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, [slug, deviceId]);

  // Close lightbox on Escape
  useEffect(() => {
    if (!lightbox) return;
    const handler = (e) => { if (e.key === 'Escape') setLightbox(false); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [lightbox]);

  const handleTrigger = async () => {
    setTriggering(true);
    try {
      await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/screenshot-trigger`, { method: 'POST' });
      setTriggered(true);
      setPolling(true);
      let attempts = 0;
      pollRef.current = setInterval(async () => {
        attempts++;
        const d = await fetchScreenshot();
        const capturedAt = d?.captured_at;
        const isNew = capturedAt && (Date.now() - new Date(capturedAt).getTime() < 180000);
        if (isNew || attempts >= 18) {
          clearInterval(pollRef.current);
          setPolling(false);
          setTriggered(false);
        }
      }, 10000);
    } finally {
      setTriggering(false);
    }
  };

  if (loading) return (
    <div style={{padding:'8px 14px',fontSize:11,color:'var(--text-muted)'}}>
      Loading screenshot...
    </div>
  );

  const captured = data?.captured_at
    ? new Date(data.captured_at).toLocaleString('en-GB', {day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'}) + ' GMT'
    : null;

  const imgSrc = data?.image_b64 ? `data:image/jpeg;base64,${data.image_b64}` : null;

  return (
    <div style={{padding:'10px 14px',background:'rgba(0,212,255,0.02)'}}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:imgSrc ? 10 : 0}}>
        <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em'}}>Screenshot</span>
        {captured && !polling && (
          <span style={{fontSize:10,color:'var(--text-muted)'}}>Updated {captured}</span>
        )}
        {polling && (
          <span style={{fontSize:10,color:'var(--accent)'}}>Waiting for agent response...</span>
        )}
        {!imgSrc && !polling && (
          <span style={{fontSize:11,color:'var(--text-muted)'}}>No screenshot available — request one below.</span>
        )}
        <button className="btn btn-secondary btn-sm" aria-pressed={!(polling)} style={{ marginLeft: 'auto' }} onClick={handleTrigger} disabled={triggering||polling}
         >
          {polling ? '⏳ Waiting...' : triggering ? '...' : ' Take Screenshot'}
        </button>
      </div>

      {/* Thumbnail — click to expand */}
      {imgSrc && (
        <div onClick={() => setLightbox(true)}
          style={{borderRadius:6,overflow:'hidden',border:'1px solid var(--border)',cursor:'zoom-in',position:'relative'}}>
          <img
            src={imgSrc}
            alt="Device screenshot"
            style={{width:'100%',display:'block',maxHeight:200,objectFit:'contain',background:'#000'}}
          />
          <div style={{position:'absolute',bottom:6,right:8,fontSize:10,color:'rgba(255,255,255,0.6)',
            background:'rgba(0,0,0,0.5)',padding:'2px 6px',borderRadius:3,pointerEvents:'none'}}>
            Click to expand
          </div>
        </div>
      )}

      {/* Lightbox */}
      {lightbox && imgSrc && (
        <div onClick={() => setLightbox(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.92)',zIndex:2000,
            display:'flex',alignItems:'center',justifyContent:'center',padding:16,cursor:'zoom-out'}}>
          <div onClick={e => e.stopPropagation()} style={{position:'relative',maxWidth:'95vw',maxHeight:'95vh'}}>
            <img
              src={imgSrc}
              alt="Device screenshot fullscreen"
              style={{display:'block',maxWidth:'95vw',maxHeight:'92vh',objectFit:'contain',borderRadius:6,
                border:'1px solid rgba(255,255,255,0.1)'}}
            />
            <div style={{position:'absolute',top:-10,right:-10}}>
              <button className="btn btn-secondary btn-sm btn-icon" onClick={() => setLightbox(false)}
               >
                ×
              </button>
            </div>
            {captured && (
              <div style={{textAlign:'center',fontSize:11,color:'rgba(255,255,255,0.4)',marginTop:8}}>
                {captured}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function RebootPanelMgmt({ slug, deviceId, dev }) {
  const [status, setStatus]         = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [rebooting, setRebooting]   = useState(false);
  const [rebooted, setRebooted]     = useState(false);
  const pollRef                     = useRef(null);

  const fetchStatus = () =>
    authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/reboot-status`)
      .then(r => r.json())
      .then(d => { setStatus(d); return d; })
      .catch(() => {});

  useEffect(() => {
    fetchStatus();
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, [slug, deviceId]);

  const handleReboot = async () => {
    setConfirming(false);
    setRebooting(true);
    try {
      await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/reboot-trigger`, { method: 'POST' });
      setRebooted(true);
      let attempts = 0;
      pollRef.current = setInterval(async () => {
        attempts++;
        const d = await fetchStatus();
        if (d?.ack_at || attempts >= 36) {
          clearInterval(pollRef.current);
          setRebooting(false);
        }
      }, 5000);
    } catch {
      setRebooting(false);
    }
  };

  const formatDate = (iso) => {
    if (!iso) return null;
    try {
      return new Date(iso).toLocaleString('en-GB', {
        day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit', timeZone:'Europe/London',
      }) + ' GMT';
    } catch { return iso; }
  };

  const isQueued  = status?.queued;
  const isPending = status?.pending_at && !status?.ack_at;
  const isAcked   = !!status?.ack_at;
  const osRebootPending = dev?.pending_reboot?.pending;

  return (
    <div style={{padding:'10px 14px',borderTop:'1px solid var(--border)',background:'rgba(230,184,0,0.02)'}}>
      <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
        <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em'}}>Remote Reboot</span>

        {osRebootPending && (
          <span style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'#e6b80018',border:'1px solid #e6b80040',color:'#e6b800',fontWeight:600}}>
            OS reboot required{dev.pending_reboot.reason ? ' · ' + dev.pending_reboot.reason : ''}
          </span>
        )}
        {isAcked && (
          <span style={{fontSize:11,color:'var(--text-muted)'}}>
            Reboot acknowledged {formatDate(status.ack_at)}{status.eta_seconds ? ` — ${status.eta_seconds}s delay` : ''}
          </span>
        )}
        {isPending && !isAcked && (
          <span style={{fontSize:11,color:'var(--accent)'}}>Reboot instruction sent — waiting for agent...</span>
        )}
        {isQueued && !isPending && (
          <span style={{fontSize:11,color:'var(--accent)'}}>Reboot queued — will execute on next heartbeat</span>
        )}
        {!osRebootPending && !isQueued && !isPending && !isAcked && !rebooted && (
          <span style={{fontSize:11,color:'var(--text-muted)'}}>No reboot pending.</span>
        )}

        {!confirming && !rebooting && (
          <button className="btn btn-secondary btn-sm" onClick={() => setConfirming(true)} disabled={isQueued || isPending} style={{marginLeft:'auto'}}>
            ↺ Reboot Device
          </button>
        )}
        {rebooting && (
          <span style={{fontSize:11,color:'var(--text-muted)',marginLeft:'auto'}}>Waiting for agent...</span>
        )}
        {confirming && (
          <div style={{marginLeft:'auto',display:'flex',gap:6,alignItems:'center'}}>
            <span style={{fontSize:11,color:'#e6b800',fontWeight:600}}>Reboot {dev?.display_name || dev?.hostname || 'this device'}?</span>
            <button className="btn btn-secondary btn-sm" style={{ color: '#e6b800' }} onClick={handleReboot}
             >
              Confirm
            </button>
            <button className="btn btn-secondary btn-sm" onClick={() => setConfirming(false)}
             >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function ServiceStatusRow({ statuses = [] }) {
  if (!statuses || statuses.length === 0) return null;
  const colour = s => s === 'running' ? '#30d158' : s === 'stopped' ? '#e6b800' : '#ff2d55';
  const label  = s => s === 'running' ? 'Running' : s === 'stopped' ? 'Stopped' : 'Not Installed';
  return (
    <div style={{padding:'8px 14px',borderTop:'1px solid var(--border)',display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
      <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginRight:4}}>Services</span>
      {statuses.map(svc => (
        <span key={svc.name} style={{fontSize:11,padding:'2px 7px',borderRadius:4,
          background:`${colour(svc.status)}18`,border:`1px solid ${colour(svc.status)}40`,
          color:colour(svc.status),fontWeight:600,display:'flex',alignItems:'center',gap:4}}>
          <span style={{width:6,height:6,borderRadius:'50%',background:colour(svc.status),display:'inline-block'}}/>
          {svc.display || svc.name}: {label(svc.status)}
        </span>
      ))}
    </div>
  );
}

function AgentUpdatePanelMgmt({ slug, deviceId, dev }) {
  const [queued, setQueued]         = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy]             = useState(false);
  const [published, setPublished]   = useState(null);

  useEffect(() => {
    authFetch('/api/admin/agent-update/published')
      .then(r => r.json())
      .then(d => setPublished(d.published || null))
      .catch(() => {});
  }, []);

  const handleForceUpdate = async () => {
    setConfirming(false);
    setBusy(true);
    try {
      const r = await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/force-update`, { method: 'POST' });
      if (r.ok) setQueued(true);
      else { const d = await r.json(); alert(d.error || 'Failed to queue update'); }
    } catch { alert('Failed to queue update'); }
    setBusy(false);
  };

  const deviceVersion    = dev?.agent_version || '—';
  const publishedVersion = published?.version || null;
  const upToDate = publishedVersion && deviceVersion === publishedVersion;

  return (
    <div style={{padding:'10px 14px',borderTop:'1px solid var(--border)',background:'rgba(0,212,255,0.02)'}}>
      <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
        <span style={{fontSize:10,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em'}}>Agent Update</span>

        <span style={{fontSize:11,color:'var(--text-muted)'}}>
          Device: <span style={{color:'var(--text)',fontWeight:600}}>{deviceVersion}</span>
          {publishedVersion && (
            <> · Published: <span style={{color: upToDate ? 'var(--green)' : 'var(--accent)', fontWeight:600}}>{publishedVersion}</span></>
          )}
        </span>

        {upToDate && !queued && (
          <span style={{fontSize:11,padding:'2px 7px',borderRadius:4,background:'#30d15818',border:'1px solid #30d15840',color:'#30d158',fontWeight:600}}>Up to date</span>
        )}
        {queued && (
          <span style={{fontSize:11,color:'var(--accent)'}}>Update queued — will apply on next heartbeat</span>
        )}

        {!confirming && !busy && !queued && (
          <button className="btn btn-secondary btn-sm" style={{ marginLeft: 'auto' }} onClick={() => setConfirming(true)}
           >
            ↑ Force Update
          </button>
        )}
        {busy && <span style={{fontSize:11,color:'var(--text-muted)',marginLeft:'auto'}}>Queuing...</span>}

        {confirming && (
          <div style={{marginLeft:'auto',display:'flex',gap:6,alignItems:'center'}}>
            <span style={{fontSize:11,color:'var(--accent)',fontWeight:600}}>Force update {dev?.display_name || dev?.hostname || 'this device'} to v{publishedVersion || '?'}?</span>
            <button className="btn btn-secondary btn-sm" onClick={handleForceUpdate}
             >
              Confirm
            </button>
            <button className="btn btn-secondary btn-sm" onClick={() => setConfirming(false)}
             >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Software Inventory Tab (Management) ──────────────────────────────────────
function SoftwareInventoryTabMgmt({ dev }) {
  const [filter, setFilter] = useState('');
  const inv = dev.software_inventory || null;

  if (!inv) {
    return (
      <div style={{padding:'14px',fontSize:12,color:'var(--text-muted)'}}>
        Software inventory not yet collected — will appear after the next daily agent cycle.
      </div>
    );
  }

  const items = inv.items || [];
  const filtered = filter
    ? items.filter(i =>
        i.name?.toLowerCase().includes(filter.toLowerCase()) ||
        i.publisher?.toLowerCase().includes(filter.toLowerCase()) ||
        i.version?.toLowerCase().includes(filter.toLowerCase())
      )
    : items;

  return (
    <div style={{padding:'14px'}}>
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12,flexWrap:'wrap'}}>
        <div style={{fontSize:11,color:'var(--text-muted)'}}>
          {inv.count} application{inv.count !== 1 ? 's' : ''} installed
          {' · '}collected {inv.collected_at
            ? new Date(inv.collected_at).toLocaleString('en-GB',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'}) + ' GMT'
            : 'unknown'}
        </div>
        <input className="input-sm"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          placeholder="Filter by name, publisher or version…"
          style={{ flex:1, minWidth:180 }}
        />
        {filter && (
          <span style={{fontSize:11,color:'var(--text-muted)'}}>
            {filtered.length} of {items.length}
          </span>
        )}
      </div>
      <div style={{overflowX:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
          <thead>
            <tr style={{borderBottom:'1px solid var(--border)'}}>
              {['Name','Version','Publisher','Installed'].map(h => (
                <th key={h} style={{textAlign:'left',padding:'4px 8px',fontSize:10,fontWeight:700,
                  color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',
                  whiteSpace:'nowrap'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={4} style={{padding:'12px 8px',color:'var(--text-muted)',fontSize:11}}>
                No matching applications.
              </td></tr>
            ) : filtered.map((item, i) => (
              <tr key={i} style={{borderBottom:'1px solid var(--border)',
                background:i%2===0?'transparent':'var(--bg-secondary)'}}>
                <td style={{padding:'5px 8px',color:'var(--text-primary)',fontWeight:500}}>{item.name}</td>
                <td style={{padding:'5px 8px',color:'var(--text-muted)',fontFamily:'monospace',fontSize:10}}>{item.version||'—'}</td>
                <td style={{padding:'5px 8px',color:'var(--text-muted)'}}>{item.publisher||'—'}</td>
                <td style={{padding:'5px 8px',color:'var(--text-muted)',whiteSpace:'nowrap'}}>{item.install_date||'—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── Hardware Inventory Tab (Management) ──────────────────────────────────────
function HardwareInventoryTabMgmt({ dev }) {
  const hw  = dev.hardware || {};
  const inv = dev.hardware_inventory || null;

  const HWSection = ({ title, children }) => (
    <div style={{width:'100%',marginBottom:12}}>
      <div style={{fontSize:10,fontWeight:700,color:'var(--text-muted)',textTransform:'uppercase',
        letterSpacing:'0.08em',marginBottom:8,paddingBottom:4,borderBottom:'1px solid var(--border)'}}>
        {title}
      </div>
      <div style={{display:'flex',flexWrap:'wrap',gap:16}}>{children}</div>
    </div>
  );

  const Chip = ({ label, value, mono }) => {
    if (!value && value !== 0 && value !== false) return null;
    const display = value === true ? 'Yes' : value === false ? 'No' : String(value);
    return (
      <div style={{minWidth:100}}>
        <div style={{fontSize:9,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',
          letterSpacing:'0.07em',marginBottom:2}}>{label}</div>
        <div style={{fontSize:12,color:'var(--text-primary)',fontFamily:mono?'monospace':'inherit'}}>{display}</div>
      </div>
    );
  };

  const tpmColor = inv?.tpm?.present
    ? (inv.tpm.enabled && inv.tpm.activated ? '#30d158' : '#e6b800')
    : '#ff2d55';
  const sbColor = inv?.secure_boot === true ? '#30d158' : inv?.secure_boot === false ? '#ff2d55' : 'var(--text-muted)';

  return (
    <div style={{padding:'14px'}}>
      <HWSection title="System">
        <Chip label="Manufacturer" value={hw.manufacturer} />
        <Chip label="Model" value={hw.model} />
        <Chip label="Service Tag" value={hw.service_tag} mono />
        <Chip label="BIOS Version" value={hw.bios_version} mono />
        <Chip label="BIOS Date" value={hw.bios_release_date} mono />
        {dev.battery?.health_pct != null && <Chip label="Battery Health" value={`${dev.battery.health_pct}%`} />}
      </HWSection>

      {!hw.manufacturer && !hw.model && !hw.service_tag && !inv && (
        <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:12}}>No hardware data reported yet.</div>
      )}

      {inv ? (
        <>
          {inv.cpu?.length > 0 && (
            <HWSection title="Processor">
              {inv.cpu.map((c, i) => (
                <div key={i} style={{display:'flex',flexWrap:'wrap',gap:16,width:'100%',
                  paddingBottom:inv.cpu.length>1?8:0,borderBottom:inv.cpu.length>1&&i<inv.cpu.length-1?'1px dashed var(--border)':'none'}}>
                  <Chip label="CPU" value={c.name} />
                  <Chip label="Cores" value={c.cores ? `${c.cores}C / ${c.logical_cores}T` : null} />
                  <Chip label="Speed" value={c.speed_mhz ? `${(c.speed_mhz/1000).toFixed(1)} GHz` : null} />
                  <Chip label="Architecture" value={c.architecture} />
                </div>
              ))}
            </HWSection>
          )}

          {inv.ram?.length > 0 && (
            <HWSection title={`Memory${inv.total_ram_gb ? ` (${inv.total_ram_gb} GB total)` : ''}`}>
              {inv.ram.map((r, i) => (
                <div key={i} style={{display:'flex',flexWrap:'wrap',gap:12,width:'100%',
                  paddingBottom:8,borderBottom:i<inv.ram.length-1?'1px dashed var(--border)':'none'}}>
                  <Chip label="Slot" value={r.slot} mono />
                  <Chip label="Capacity" value={r.capacity_gb ? `${r.capacity_gb} GB` : null} />
                  <Chip label="Type" value={r.memory_type} />
                  <Chip label="Speed" value={r.speed_mhz ? `${r.speed_mhz} MHz` : null} />
                  <Chip label="Manufacturer" value={r.manufacturer} />
                  <Chip label="Part Number" value={r.part_number} mono />
                </div>
              ))}
            </HWSection>
          )}

          {inv.storage?.length > 0 && (
            <HWSection title="Storage">
              {inv.storage.map((d, i) => (
                <div key={i} style={{display:'flex',flexWrap:'wrap',gap:12,width:'100%',
                  paddingBottom:8,borderBottom:i<inv.storage.length-1?'1px dashed var(--border)':'none'}}>
                  <Chip label="Drive" value={d.model} />
                  <Chip label="Type" value={d.type || d.media_type} />
                  <Chip label="Interface" value={d.interface} />
                  <Chip label="Capacity" value={d.capacity_gb ? `${d.capacity_gb} GB` : null} />
                  <Chip label="Serial" value={d.serial_number} mono />
                </div>
              ))}
            </HWSection>
          )}

          {inv.gpu?.length > 0 && (
            <HWSection title="Graphics">
              {inv.gpu.map((g, i) => (
                <div key={i} style={{display:'flex',flexWrap:'wrap',gap:12,width:'100%',
                  paddingBottom:8,borderBottom:i<inv.gpu.length-1?'1px dashed var(--border)':'none'}}>
                  <Chip label="GPU" value={g.name} />
                  <Chip label="VRAM" value={g.vram_gb ? `${g.vram_gb} GB` : null} />
                  <Chip label="Driver" value={g.driver_version} mono />
                </div>
              ))}
            </HWSection>
          )}

          {inv.displays?.length > 0 && (
            <HWSection title="Displays">
              {inv.displays.map((d, i) => (
                <div key={i} style={{display:'flex',flexWrap:'wrap',gap:12,width:'100%',
                  paddingBottom:8,borderBottom:i<inv.displays.length-1?'1px dashed var(--border)':'none'}}>
                  <Chip label="Display" value={d.name} />
                  <Chip label="Manufacturer" value={d.manufacturer} />
                  {d.width_px > 0 && <Chip label="Resolution" value={`${d.width_px} × ${d.height_px}`} />}
                </div>
              ))}
            </HWSection>
          )}

          {(inv.tpm != null || inv.secure_boot != null) && (
            <HWSection title="Platform Security">
              {inv.tpm && (
                <>
                  <div style={{minWidth:100}}>
                    <div style={{fontSize:9,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:2}}>TPM</div>
                    <div style={{fontSize:12,color:tpmColor}}>
                      {inv.tpm.present
                        ? `Present${inv.tpm.spec_version ? ` (${inv.tpm.spec_version})` : ''}${inv.tpm.enabled && inv.tpm.activated ? '' : ' — not active'}`
                        : 'Not detected'}
                    </div>
                  </div>
                  {inv.tpm.manufacturer_id && <Chip label="TPM Manufacturer" value={inv.tpm.manufacturer_id} />}
                </>
              )}
              {inv.secure_boot != null && (
                <div style={{minWidth:100}}>
                  <div style={{fontSize:9,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:2}}>Secure Boot</div>
                  <div style={{fontSize:12,color:sbColor}}>{inv.secure_boot ? 'Enabled' : 'Disabled'}</div>
                </div>
              )}
            </HWSection>
          )}

          <div style={{fontSize:10,color:'var(--text-muted)',marginTop:4}}>
            Inventory collected {inv.collected_at ? new Date(inv.collected_at).toLocaleString('en-GB',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'}) + ' GMT' : 'unknown'}
          </div>
        </>
      ) : (
        hw.manufacturer || hw.model ? (
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>
            Full inventory not yet collected — will appear after the next daily agent cycle.
          </div>
        ) : null
      )}
    </div>
  );
}

const DEVICE_CARD_TABS_MGMT = [
  { id: 'overview',     label: 'Overview' },
  { id: 'hardware',     label: 'Hardware' },
  { id: 'software',     label: 'Software' },
  { id: 'connectivity', label: 'Connectivity' },
  { id: 'security',     label: 'Security' },
  { id: 'activity',     label: 'Activity' },
];

function DeviceCardTabsMgmt({ slug, dev }) {
  const [tab, setTab] = useState('overview');
  const hw = dev.hardware || {};
  const adapters = hw.network_adapters || [];

  return (
    <div style={{borderTop:'1px solid var(--border)'}}>
      <div style={{display:'flex',gap:2,padding:'8px 14px 0',borderBottom:'1px solid var(--border)',overflowX:'auto'}}>
        {DEVICE_CARD_TABS_MGMT.map(t => (
          <button className="tab-btn" aria-selected={tab===t.id} key={t.id} onClick={()=>setTab(t.id)}
           >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'overview' && (
        <div style={{padding:'14px',display:'flex',flexWrap:'wrap',gap:20}}>
          <DetailFieldMgmt label="Model" value={[hw.manufacturer, hw.model].filter(Boolean).join(' ')} />
          <DetailFieldMgmt label="Location" value={[dev.geo?.city, dev.geo?.country].filter(Boolean).join(', ')} />
          <DetailFieldMgmt label="ISP" value={dev.geo?.isp} />
          <DetailFieldMgmt label="Logged In User" value={dev.logged_in_user} />
          <DetailFieldMgmt label="Uptime" value={formatUptimeMgmt(dev.uptime_seconds)} />
          {dev.pending_reboot?.pending && (
            <DetailFieldMgmt label="Reboot Required" value={dev.pending_reboot.reason||'Yes'} color="#e6b800" />
          )}
          <DetailFieldMgmt label="Last Seen" value={fmtDate(dev.last_seen)} mono />
        </div>
      )}

      {tab === 'hardware' && (
        <HardwareInventoryTabMgmt dev={dev} />
      )}

      {tab === 'software' && (
        <SoftwareInventoryTabMgmt dev={dev} />
      )}

      {tab === 'connectivity' && (
        <div>
          <IperfPanelMgmt slug={slug} deviceId={dev.device_id} />
          <div style={{padding:'14px',borderTop:'1px solid var(--border)'}}>
            <div style={{fontSize:11,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:8}}>
              Network Adapters
            </div>
            {adapters.length === 0 ? (
              <div style={{fontSize:12,color:'var(--text-muted)'}}>No adapter data reported yet.</div>
            ) : (
              <div style={{display:'flex',flexDirection:'column',gap:8}}>
                {adapters.map((a, i) => (
                  <div key={i} style={{display:'flex',alignItems:'center',gap:10,fontSize:12,flexWrap:'wrap'}}>
                    <span style={{fontSize:9,fontWeight:700,padding:'2px 6px',borderRadius:4,textTransform:'uppercase',letterSpacing:'0.05em',
                      background:a.type==='wireless'?'#00d4ff18':'#30d15818',color:a.type==='wireless'?'var(--accent)':'#30d158'}}>
                      {a.type==='wireless' ? 'Wi-Fi' : 'Wired'}
                    </span>
                    <span style={{fontWeight:600}}>{a.name||a.description||'Adapter'}</span>
                    <span style={{fontFamily:'var(--font-mono)',color:'var(--text-muted)'}}>{a.mac_address}</span>
                    {a.ssid && <span style={{color:'var(--text-muted)'}}>{'SSID: '+a.ssid}</span>}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {tab === 'security' && (
        <div>
          <OsquerySecurityPanelMgmt slug={slug} deviceId={dev.device_id} />
        </div>
      )}

      {tab === 'activity' && (
        <div>
          <div style={{padding:'14px',display:'flex',flexWrap:'wrap',gap:20,borderBottom:'1px solid var(--border)'}}>
            <DetailFieldMgmt label="Last Seen" value={fmtDate(dev.last_seen)} mono />
            {dev.last_compliance_check && (
              <DetailFieldMgmt label="Last Compliance Check" value={fmtDate(dev.last_compliance_check)} mono />
            )}
            {dev.last_summary?.ce_plus && (
              <DetailFieldMgmt label="CE+ Score" value={`${dev.last_summary.ce_plus.pct}%`}
                color={dev.last_summary.ce_plus.grade==='pass'?'#30d158':dev.last_summary.ce_plus.grade==='fail'?'#ff2d55':'var(--text-muted)'} />
            )}
          </div>
          <ScreenshotPanelMgmt slug={slug} deviceId={dev.device_id} />
          <PublicIpHistoryPanelMgmt dev={dev} />
          <RebootPanelMgmt slug={slug} deviceId={dev.device_id} dev={dev} />
          <AgentUpdatePanelMgmt slug={slug} deviceId={dev.device_id} dev={dev} />
        </div>
      )}
    </div>
  );
}

function PublicIpHistoryPanelMgmt({ dev }) {
  const stats = dev.ip_stats;
  if (!stats || !stats.top?.length) return null;
  const currentIp = dev.last_ip;
  const flagged = stats.current_is_most_common === false;

  return (
    <div style={{padding:'14px',borderTop:'1px solid var(--border)'}}>
      <div style={{fontSize:11,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:8,display:'flex',alignItems:'center',gap:8}}>
        Public IP History
        <span style={{fontSize:9,fontWeight:500,color:'var(--text-muted)',textTransform:'none',letterSpacing:'normal'}}>
          {`(last ${stats.sample_size} check-ins)`}
        </span>
      </div>

      {flagged && (
        <div style={{fontSize:11,color:'#e6b800',background:'#e6b80014',border:'1px solid #e6b80040',
          borderRadius:6,padding:'6px 10px',marginBottom:10}}>
          {`Currently checking in from ${currentIp || 'an IP'}, which is not this device's most common public IP.`}
        </div>
      )}

      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {stats.top.map((entry, i) => {
          const isCurrent = entry.ip === currentIp;
          const barColor = i === 0 ? (flagged ? '#e6b800' : '#30d158') : 'var(--border)';
          return (
            <div key={entry.ip} style={{display:'flex',alignItems:'center',gap:10}}>
              <span style={{fontSize:10,fontWeight:700,color:'var(--text-muted)',width:14,flexShrink:0}}>{`#${i + 1}`}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:3}}>
                  <span style={{fontFamily:'var(--font-mono)',fontSize:12,fontWeight:isCurrent?700:500}}>{entry.ip}</span>
                  {isCurrent && (
                    <span style={{fontSize:9,fontWeight:700,padding:'1px 6px',borderRadius:4,
                      background:'#00d4ff18',color:'var(--accent)',textTransform:'uppercase',letterSpacing:'0.05em'}}>
                      Current
                    </span>
                  )}
                  <span style={{fontSize:10,color:'var(--text-muted)',marginLeft:'auto',fontFamily:'var(--font-mono)'}}>
                    {`${entry.pct}% · ${entry.count}`}
                  </span>
                </div>
                <div style={{height:4,borderRadius:2,background:'var(--border)',overflow:'hidden'}}>
                  <div style={{height:'100%',width:`${entry.pct}%`,background:barColor,borderRadius:2}} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function DetailFieldMgmt({ label, value, mono, color }) {
  if (!value) return null;
  return (
    <div>
      <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:2}}>{label}</div>
      <div style={{fontSize:12,fontFamily:mono?'var(--font-mono)':undefined,color:color||'var(--text)'}}>{value}</div>
    </div>
  );
}

function formatUptimeMgmt(seconds) {
  if (!seconds && seconds !== 0) return null;
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  if (days > 0) return `${days}d ${hours}h`;
  const mins = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${mins}m`;
}

// Sort order for the Clearview Agent device list is viewer-controlled and
// must stay stable across polling refreshes — never fall back to raw API
// order, which can reshuffle between fetches.
const AGENT_SORT_OPTIONS = [
  { key: 'name',      label: 'Name' },
  { key: 'status',    label: 'Status' },
  { key: 'last_seen', label: 'Last Seen' },
  { key: 'uptime',    label: 'Uptime' },
];

function agentDeviceName(d) {
  return (d.display_name || d.hostname || d.device_id || '').toLowerCase();
}

function compareAgentDevices(a, b, sortKey, sortDir) {
  const dir = sortDir === 'desc' ? -1 : 1;
  let cmp = 0;
  switch (sortKey) {
    case 'status': {
      const rank = s => s === 'online' ? 0 : s === 'offline' ? 1 : 2;
      cmp = rank(a.status) - rank(b.status);
      break;
    }
    case 'last_seen': {
      const ta = a.last_seen ? new Date(a.last_seen).getTime() : 0;
      const tb = b.last_seen ? new Date(b.last_seen).getTime() : 0;
      cmp = ta - tb;
      break;
    }
    case 'uptime':
      cmp = (a.uptime_seconds || 0) - (b.uptime_seconds || 0);
      break;
    case 'name':
    default:
      cmp = agentDeviceName(a).localeCompare(agentDeviceName(b));
      break;
  }
  // Stable secondary sort by name so ties (e.g. two online devices) never
  // jitter position between refreshes.
  if (cmp === 0) cmp = agentDeviceName(a).localeCompare(agentDeviceName(b));
  return cmp * dir;
}

function AgentSortBar({ sortKey, sortDir, onChange }) {
  return (
    <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
      <span style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em',fontWeight:600}}>Sort:</span>
      {AGENT_SORT_OPTIONS.map(opt => {
        const active = sortKey === opt.key;
        return (
          <button className="btn btn-secondary btn-sm" aria-pressed={active} key={opt.key}
            onClick={() => onChange(opt.key, active && sortDir === 'asc' ? 'desc' : 'asc')}
           >
            {opt.label}{active && <span style={{fontSize:9}}>{sortDir === 'asc' ? '▲' : '▼'}</span>}
          </button>
        );
      })}
    </div>
  );
}

// ── Agent Installer Panel ──────────────────────────────────────────────────────

function AgentInstallerPanel({ slug }) {
  const [downloading, setDownloading] = useState(false);
  const [error, setError]             = useState('');

  const download = async () => {
    setDownloading(true); setError('');
    try {
      const token = localStorage.getItem('stg_token');
      const res = await fetch(`/api/client/${slug}/agent/installer.ps1`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || 'Failed to generate installer');
      }
      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = `ClearviewAgent-${slug}.ps1`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) { setError(err.message); }
    finally { setDownloading(false); }
  };

  return (
    <div style={{background:'var(--card-bg)',border:'1px solid var(--border)',borderRadius:10,padding:'16px 18px',marginBottom:16}}>
      <div style={{fontSize:11,fontWeight:700,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.08em',marginBottom:8}}>
        Install Clearview Agent
      </div>
      <div style={{fontSize:12,color:'var(--text-muted)',lineHeight:1.5,marginBottom:12}}>
        Downloads a pre-configured PowerShell installer for this client.
        Right-click the file and select <strong>Run with PowerShell</strong> on the target device.
        The installer token is valid for 48 hours from download.
      </div>
      {error && <div className="error-msg" style={{marginBottom:10}}>{error}</div>}
      <button className="btn btn-primary" onClick={download} disabled={downloading}>
        {downloading ? <span className="spinner"/> : '↓ Download Installer (.ps1)'}
      </button>
    </div>
  );
}

function ClearviewAgentTabInline({ slug, clients = [] }) {
  const isMobile = useIsMobile();
  const [data, setData]         = useState(null);
  const [loading, setLoading]             = useState(true);
  const [selected, setSelected]           = useState(null);
  const [confirming, setConfirming]       = useState(null);
  const [actioning, setActioning]         = useState(null);
  const [expandedDevice, setExpandedDevice] = useState(null);
  const [showArchived, setShowArchived] = useState(false);
  const [moveModal, setMoveModal]   = useState(null); // device object
  const [moveSlug, setMoveSlug]     = useState('');
  const [moving, setMoving]         = useState(false);
  const [renameModal, setRenameModal] = useState(null); // device object
  const [renameValue, setRenameValue] = useState('');
  const [renaming, setRenaming]       = useState(false);
  const [sortKey, setSortKey] = useState('name');
  const [sortDir, setSortDir] = useState('asc');

  const fetchDevices = useCallback(() => {
    authFetch(`/api/clients/${slug}/endpoint/devices`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  const handleArchive = async (deviceId) => {
    setActioning(deviceId);
    try {
      const r = await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/archive`, { method: 'POST' });
      if (r.ok) {
        setSelected(null);
        fetchDevices();
      }
      else { const d = await r.json(); alert(d.error || 'Archive failed'); }
    } catch { alert('Archive failed'); }
    setActioning(null);
  };

  const handleDelete = async (deviceId) => {
    setConfirming(null);
    setActioning(deviceId);
    try {
      const r = await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}`, { method: 'DELETE' });
      if (r.ok) {
        setSelected(null);
        fetchDevices();
      }
      else { const d = await r.json(); alert(d.error || 'Delete failed'); }
    } catch { alert('Delete failed'); }
    setActioning(null);
  };

  const handleMove = async () => {
    if (!moveModal || !moveSlug) return;
    setMoving(true);
    try {
      const r = await authFetch(`/api/clients/${slug}/endpoint/device/${moveModal.device_id}/move`, {
        method: 'POST',
        body: JSON.stringify({ new_client_slug: moveSlug }),
      });
      if (r.ok) {
        setMoveModal(null);
        setMoveSlug('');
        fetchDevices();
      }
      else { const d = await r.json(); alert(d.error || 'Move failed'); }
    } catch { alert('Move failed'); }
    setMoving(false);
  };

  const handleRename = async () => {
    if (!renameModal) return;
    setRenaming(true);
    try {
      const r = await authFetch(`/api/clients/${slug}/endpoint/device/${renameModal.device_id}/rename`, {
        method: 'POST',
        body: JSON.stringify({ display_name: renameValue.trim() }),
      });
      if (r.ok) {
        setRenameModal(null);
        setRenameValue('');
        fetchDevices();
      }
      else { const d = await r.json(); alert(d.error || 'Rename failed'); }
    } catch { alert('Rename failed'); }
    setRenaming(false);
  };
  const mapRef    = useRef(null);
  const leafletMap = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    fetchDevices();
    const interval = setInterval(fetchDevices, 30000);
    return () => clearInterval(interval);
  }, [fetchDevices]);

  useEffect(() => {
    if (!data?.devices?.length || !mapRef.current) return;
    const devices = data.devices.filter(d => d.geo?.lat && d.geo?.lng);
    if (!devices.length) return;
    if (!leafletMap.current) {
      leafletMap.current = window.L.map(mapRef.current, { zoomControl: true, scrollWheelZoom: false });
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors', maxZoom: 18,
      }).addTo(leafletMap.current);
      const tp = leafletMap.current.getPane('tilePane');
      if (tp) tp.style.filter = 'invert(1) hue-rotate(180deg) brightness(0.75) contrast(1.1)';
    }
    markersRef.current.forEach(m => m.remove());
    markersRef.current = [];
    const bounds = [];
    const coordCount = {};
    devices.forEach(dev => {
      const key = `${dev.geo.lat},${dev.geo.lng}`;
      coordCount[key] = (coordCount[key] || 0) + 1;
    });
    const coordIndex = {};
    devices.forEach(dev => {
      const key = `${dev.geo.lat},${dev.geo.lng}`;
      const total = coordCount[key];
      const idx = coordIndex[key] = (coordIndex[key] || 0);
      coordIndex[key]++;
      const angle = (2 * Math.PI * idx) / Math.max(total, 1);
      const offset = total > 1 ? 0.0003 : 0;
      const lat = dev.geo.lat + offset * Math.sin(angle);
      const lng = dev.geo.lng + offset * Math.cos(angle);
      const color = dev.status === 'online' ? '#30d158' : '#ff2d55';
      const icon = window.L.divIcon({
        className: '',
        html: `<div style="width:12px;height:12px;border-radius:50%;background:${color};border:2px solid rgba(255,255,255,0.6);box-shadow:0 0 6px ${color}80;"></div>`,
        iconSize: [12, 12], iconAnchor: [6, 6],
      });
      const marker = window.L.marker([lat, lng], { icon })
        .addTo(leafletMap.current)
        .on('click', () => setSelected(dev));
      markersRef.current.push(marker);
      bounds.push([lat, lng]);
    });
    if (bounds.length === 1) leafletMap.current.setView(bounds[0], 10);
    else leafletMap.current.fitBounds(bounds, { padding: [30, 30] });
  }, [data]);

  const fmt = iso => {
    if (!iso) return '—';
    try { return new Date(iso).toLocaleString('en-GB', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit', timeZone:'Europe/London' }) + ' GMT'; }
    catch { return iso; }
  };

  if (loading) return <div style={{padding:32,textAlign:'center'}}><span className="spinner"/></div>;

  const allDevices = data?.devices || [];
  const archived   = allDevices.filter(d => d.archived);
  const unsorted   = showArchived ? archived : allDevices.filter(d => !d.archived);
  const hasDevices = data?.available && allDevices.filter(d => !d.archived).length > 0;
  const devices    = [...unsorted].sort((a, b) => compareAgentDevices(a, b, sortKey, sortDir));
  const online     = allDevices.filter(d => d.status === 'online' && !d.archived).length;
  const offline    = allDevices.filter(d => d.status === 'offline' && !d.archived).length;
  const geoDevices = devices.filter(d => d.geo?.lat && d.geo?.lng);

  return (
    <>
    <div style={{display:'flex',flexDirection:'column',gap:16}}>
      <AgentInstallerPanel slug={slug} />
      {!hasDevices ? (
        <div style={{padding:'8px 0',color:'var(--text-muted)',fontSize:13,textAlign:'center'}}>
          No devices enrolled yet. Generate an install command above to enroll your first device.
        </div>
      ) : (<>
      <div className="stat-tiles">{[{label:'Active',val:allDevices.filter(d=>!d.archived).length,tone:'accent'},{label:'Online',val:online,tone:'green'},{label:'Offline',val:offline,tone:offline>0?'red':'muted'}].map(({label,val,tone})=>(
          <div key={label} className="stat-card">
            <div className={`stat-value ${tone}`}>{val}</div>
            <div className="stat-label">{label}</div>
          </div>
        ))}
        {archived.length > 0 && (
          <button className="btn-card" aria-pressed={showArchived} onClick={()=>setShowArchived(s=>!s)} style={{minWidth:90,textAlign:'center'}}>
            <div style={{fontSize:20,fontWeight:800,color:'var(--text-muted)',fontFamily:'var(--font-mono)',lineHeight:1,marginBottom:4}}>{archived.length}</div>
            <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.08em',fontWeight:600}}>{showArchived?'◀ Active':'Archived'}</div>
          </button>
        )}
      </div>
      {geoDevices.length > 0 && (
        <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',overflow:'hidden'}}>
          <div style={{padding:'8px 14px',borderBottom:'1px solid var(--border)',fontSize:11,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.07em'}}>
            Device Locations
          </div>
          <div ref={mapRef} style={{height:260,width:'100%'}}/>
          {selected && (
            <div style={{padding:'10px 14px',borderTop:'1px solid var(--border)',display:'flex',gap:16,flexWrap:'wrap',alignItems:'center'}}>
              <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>Device</div><div style={{fontSize:13,fontWeight:600}}>{selected.display_name||selected.hostname||'Unknown'}</div></div>
              <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>Status</div>
                <span style={{fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:4,background:selected.status==='online'?'#30d15818':'#ff2d5518',border:`1px solid ${selected.status==='online'?'#30d15840':'#ff2d5540'}`,color:selected.status==='online'?'#30d158':'#ff2d55',fontFamily:'var(--font-mono)'}}>
                  {selected.status==='online'?'Online':'Offline'}
                </span>
              </div>
              <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>Location</div><div style={{fontSize:12}}>{[selected.geo?.city,selected.geo?.country].filter(Boolean).join(', ')||'—'}</div></div>
              <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>ISP</div><div style={{fontSize:12}}>{selected.geo?.isp||'—'}</div></div>
              {selected.logged_in_user && <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>Logged In</div><div style={{fontSize:12}}>{selected.logged_in_user}</div></div>}
              {selected.pending_reboot?.pending && <div><div style={{fontSize:10,color:'#e6b800',textTransform:'uppercase',marginBottom:2}}>Reboot Required</div><div style={{fontSize:12,color:'#e6b800'}}>{selected.pending_reboot.reason||'Yes'}</div></div>}
              {(selected.hardware?.manufacturer || selected.hardware?.model) && <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>Hardware</div><div style={{fontSize:12}}>{[selected.hardware.manufacturer, selected.hardware.model].filter(Boolean).join(' ')}</div></div>}
              {selected.firmware_updates?.length > 0 && (() => {
                const oldest = selected.firmware_updates.reduce((a,b) => new Date(a.detected_at) < new Date(b.detected_at) ? a : b);
                const ageDays = oldest.detected_at ? Math.floor((Date.now()-new Date(oldest.detected_at))/86400000) : null;
                const overdue = ageDays !== null && ageDays >= 14;
                return <div><div style={{fontSize:10,color:overdue?'#ff2d55':'#e6b800',textTransform:'uppercase',marginBottom:2}}>Firmware Update{selected.firmware_updates.length>1?'s':''}</div><div style={{fontSize:12,color:overdue?'#ff2d55':'#e6b800'}}>{selected.firmware_updates.length} pending{ageDays!==null?` · ${ageDays}d`:''}{ overdue?' — overdue':''}</div></div>;
              })()}
              <div><div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',marginBottom:2}}>Last Seen</div><div style={{fontSize:12,fontFamily:'var(--font-mono)'}}>{fmt(selected.last_seen)}</div></div>
              <button className="btn btn-quiet btn-icon" style={{ marginLeft: 'auto' }} onClick={()=>setSelected(null)}>✕</button>
            </div>
          )}
        </div>
      )}
      <AgentSortBar sortKey={sortKey} sortDir={sortDir} onChange={(k,d)=>{setSortKey(k);setSortDir(d);}} />
      <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)'}}>
        {devices.map((dev,i) => (
          <div key={dev.device_id||i}
            style={{borderBottom:i<devices.length-1?'1px solid var(--border)':'none'}}>
            <div onClick={()=>{setSelected(dev);setExpandedDevice(expandedDevice===dev.device_id?null:dev.device_id);}}
              style={{display:'flex',flexWrap:isMobile?'wrap':'nowrap',alignItems:isMobile?'flex-start':'center',gap:isMobile?8:12,padding:'10px 14px',cursor:'pointer',background:expandedDevice===dev.device_id?'rgba(0,212,255,0.04)':'transparent'}}>
            <div style={{width:8,height:8,borderRadius:'50%',flexShrink:0,background:dev.status==='online'?'#30d158':dev.status==='offline'?'#ff2d55':'#86868b'}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:600,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'flex',alignItems:'center',gap:6}}>
                <span style={{overflow:'hidden',textOverflow:'ellipsis'}}>{dev.display_name||dev.hostname||dev.device_id?.substring(0,8)||'Unknown'}</span>
                {dev.superseded_by && (
                  <span title={`Superseded by device ${dev.superseded_by}`}
                    style={{fontSize:9,fontWeight:700,padding:'1px 6px',borderRadius:4,background:'#86868b18',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.05em',flexShrink:0}}>
                    Superseded
                  </span>
                )}
              </div>
              <div style={{fontSize:11,color:'var(--text-muted)'}}>{[dev.geo?.city,dev.geo?.country].filter(Boolean).join(', ')||'Location unknown'} · {dev.os_friendly||dev.os||''}{dev.agent_version && <span style={{marginLeft:6,opacity:0.6}}>· Agent v{dev.agent_version}</span>}</div>
              <DeviceEnrichmentPillsMgmt dev={dev} />
            </div>
            <div style={isMobile?{flexBasis:'100%',display:'flex',flexWrap:'wrap',alignItems:'center',justifyContent:'space-between',gap:6,paddingLeft:20}:{flexShrink:0,textAlign:'right',display:'flex',flexDirection:'column',alignItems:'flex-end',gap:4}}>
              <div style={{fontSize:10,color:'var(--text-muted)',fontFamily:'var(--font-mono)'}}>{fmt(dev.last_seen)}</div>
              {!dev.archived && (
                <div style={{display:'flex',flexWrap:'wrap',gap:4}} onClick={e=>e.stopPropagation()}>
                  <button className="btn btn-secondary btn-sm" onClick={()=>{ setRenameModal(dev); setRenameValue(dev.display_name||''); }} disabled={actioning===dev.device_id}
                   >Rename</button>
                  <button className="btn btn-secondary btn-sm" onClick={()=>{ setMoveModal(dev); setMoveSlug(''); }} disabled={actioning===dev.device_id}
                   >Move</button>
                  <button className="btn btn-secondary btn-sm" onClick={()=>handleArchive(dev.device_id)} disabled={actioning===dev.device_id}
                   >Archive</button>
                  {confirming===dev.device_id ? (
                    <span style={{display:'flex',gap:4}}>
                      <button className="btn btn-danger btn-sm" onClick={()=>handleDelete(dev.device_id)} disabled={actioning===dev.device_id}
                       >Confirm</button>
                      <button className="btn btn-secondary btn-sm" onClick={()=>setConfirming(null)}
                       >Cancel</button>
                    </span>
                  ) : (
                    <button className="btn btn-danger btn-sm" onClick={()=>setConfirming(dev.device_id)}
                     >Delete</button>
                  )}
                </div>
              )}
              {dev.archived && (
                <div onClick={e=>e.stopPropagation()}>
                  <button className="btn btn-danger btn-sm" onClick={()=>handleDelete(dev.device_id)} disabled={actioning===dev.device_id}
                   >Delete</button>
                </div>
              )}
            </div>
            </div>
            {expandedDevice === dev.device_id && (
              <DeviceCardTabsMgmt slug={slug} dev={dev} />
            )}
            {dev.service_statuses && dev.service_statuses.length > 0 && (
              <ServiceStatusRow statuses={dev.service_statuses} />
            )}
          </div>
        ))}
      </div>
      </>)}
    </div>
    {moveModal && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}
        onClick={()=>{ if (!moving) { setMoveModal(null); setMoveSlug(''); } }}>
        <div style={{background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:24,width:360,maxWidth:'90vw'}}
          onClick={e=>e.stopPropagation()}>
          <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>Move Device</div>
          <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:16}}>
            {moveModal.display_name || moveModal.hostname || moveModal.device_id} will be reassigned on its next heartbeat.
          </div>
          <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.07em',color:'var(--text-muted)',marginBottom:6}}>Move to Client</div>
          <select className="input-sm"
            value={moveSlug}
            onChange={e=>setMoveSlug(e.target.value)}
            style={{ width:'100%', marginBottom:20, cursor:'pointer' }}>
            <option value="">Select a client...</option>
            {clients.filter(c => c.slug !== slug && !c.archived).map(c => (
              <option key={c.slug} value={c.slug}>{c.display_name || c.slug}</option>
            ))}
          </select>
          <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
            <button className="btn btn-secondary btn-sm" onClick={()=>{ setMoveModal(null); setMoveSlug(''); }} disabled={moving}>Cancel</button>
            <button className="btn btn-primary btn-sm" onClick={handleMove} disabled={!moveSlug || moving}>
              {moving ? <span className="spinner"/> : 'Move Device'}
            </button>
          </div>
        </div>
      </div>
    )}
    {renameModal && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}
        onClick={()=>{ if (!renaming) { setRenameModal(null); setRenameValue(''); } }}>
        <div style={{background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:24,width:360,maxWidth:'90vw'}}
          onClick={e=>e.stopPropagation()}>
          <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>Rename Device</div>
          <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:16}}>
            {'Sets a display name for '}{renameModal.hostname||renameModal.device_id}{'. The reported hostname is unchanged.'}
          </div>
          <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.07em',color:'var(--text-muted)',marginBottom:6}}>Display Name</div>
          <input className="input-sm" type="text" value={renameValue} onChange={e=>setRenameValue(e.target.value)}
            placeholder={renameModal.hostname||'Enter a name…'}
            style={{ width:'100%', marginBottom:20 }}
            autoFocus
            onKeyDown={e=>{ if (e.key==='Enter') handleRename(); }} />
          <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
            <button className="btn btn-secondary btn-sm" onClick={()=>{ setRenameModal(null); setRenameValue(''); }} disabled={renaming}>Cancel</button>
            <button className="btn btn-primary btn-sm" onClick={handleRename} disabled={renaming}>
              {renaming ? <span className="spinner"/> : 'Save'}
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}

function ipInSubnet(ip, cidr) {
  try {
    const [net, bits] = cidr.split('/');
    const mask   = ~((1 << (32 - parseInt(bits))) - 1) >>> 0;
    const ipInt  = ip.split('.').reduce((a,b) => (a << 8) | parseInt(b), 0) >>> 0;
    const netInt = net.split('.').reduce((a,b) => (a << 8) | parseInt(b), 0) >>> 0;
    return (ipInt & mask) === (netInt & mask);
  } catch { return false; }
}

// ── Site subnets card ─────────────────────────────────────────────────────────
// One row per scanned subnet: CIDR, device count, site name, public IP and the
// last scan time for that site. Multi-site agent clients scan each site
// separately (app.py v3.51+), so each row carries its own Updated time from
// summary.scanners. Falls back to summary.subnet (comma-separated) for edge data.
function SiteSubnetsCard({ summary, hosts, sites, isAdmin }) {
  const scanners = summary?.scanners || [];
  const fromSummary = String(summary?.subnet || '').split(',').map(s => s.trim()).filter(Boolean);
  const subnets = [...new Set([...fromSummary, ...scanners.map(s => s.subnet).filter(Boolean)])];
  if (!subnets.length) return null;
  const fmt = iso => new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
  return (
    <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:'12px 18px',minWidth:120,maxWidth:'100%',boxSizing:'border-box',display:'flex',flexDirection:'column',gap:10}}>
      {subnets.map(subnet => {
        const base = subnet.split('/')[0];
        const v = (sites || {})[subnet] ?? Object.entries(sites || {}).find(([k]) => ipInSubnet(base, k))?.[1];
        const siteLabel = typeof v === 'string' ? v : (v?.label || '');
        const pub = v && typeof v === 'object' ? v.public_ip : null;
        const auto = v && typeof v === 'object' && ['edge', 'agent'].includes(v.public_ip_source);
        const count = (hosts || []).filter(h => ipInSubnet(h.ip, subnet)).length;
        const sc = scanners.find(s => s.subnet === subnet);
        return (
          <div key={subnet}>
            <div style={{display:'flex',alignItems:'baseline',gap:8,flexWrap:'wrap'}}>
              <span style={{fontSize:14,fontWeight:700,fontFamily:'var(--font-mono)',color:'var(--text-muted)'}}>{subnet}</span>
              <span style={{fontSize:10,color:'var(--text-muted)',fontFamily:'var(--font-mono)'}}>{count} device{count === 1 ? '' : 's'}</span>
            </div>
            {siteLabel
              ? <div style={{fontSize:11,color:'var(--accent)',fontWeight:600,marginTop:2}}>{siteLabel}{pub ? ` · ${auto ? '↻ ' : ''}${pub}` : ''}</div>
              : <div style={{fontSize:10,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.1em',fontWeight:600,marginTop:2}}>Subnet</div>}
            {sc?.scanned_at && <div style={{fontSize:10,color:'var(--text-muted)',marginTop:2}}>Updated {fmt(sc.scanned_at)}{isAdmin && sc.hostname ? ` · ${sc.hostname}` : ''}</div>}
          </div>
        );
      })}
    </div>
  );
}

function DeviceHubInline({ slug, clients = [] }) {
  const [subTab, setSubTab] = useState('network');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [labels, setLabels] = useState({ sites: {}, devices: {} });
  const [filter, setFilter] = useState('');
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [bulkImportTab, setBulkImportTab] = useState('discovered');
  const [showNewOnly, setShowNewOnly] = useState(false);

  useEffect(() => {
    authFetch(`/api/clients/${slug}/network`).then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
    authFetch(`/api/clients/${slug}/network/labels`).then(r=>r.json()).then(d=>setLabels(d||{sites:{},devices:{}})).catch(()=>{});
  }, [slug]);

  const SUB_TABS = [{id:'network',label:'Discovered Devices'},{id:'computers',label:'Managed Computers'},{id:'agent',label:'Clearview Agent'}];
  const tabBar = (
    <div style={{display:'flex',gap:2,borderBottom:'1px solid var(--border)',marginBottom:16}}>
      {SUB_TABS.map(t=>(
        <button className="tab-btn" aria-selected={subTab===t.id} key={t.id} onClick={()=>setSubTab(t.id)}>
          {t.label}
        </button>
      ))}
    </div>
  );

  const [cveBusy, setCveBusy] = useState(false);
  const [cveMsg, setCveMsg] = useState('');
  const recheckCves = async () => {
    setCveBusy(true); setCveMsg('');
    try {
      const r = await authFetch(`/api/clients/${slug}/network/cve-check`, { method: 'POST' });
      const d = await r.json();
      setCveMsg(r.ok ? 'Started — refresh in a few minutes' : (d.error || 'Could not start'));
    } catch (e) { setCveMsg('Could not start'); }
    finally { setCveBusy(false); }
  };

  const bulkImportBtn = (tab) => (
    <button className="btn btn-secondary btn-sm" onClick={()=>{ setBulkImportTab(tab); setShowBulkImport(true); }}>⊕ Import to Assets Hub</button>
  );

  if (subTab === 'computers') return (
    <div>
      {tabBar}
      <div style={{display:'flex',justifyContent:'flex-end',marginBottom:12}}>{bulkImportBtn('managed')}</div>
      <ComputersSubTabInline slug={slug}/>
      {showBulkImport && <BulkImportModal slug={slug} defaultTab={bulkImportTab} onClose={()=>setShowBulkImport(false)} onImported={()=>setShowBulkImport(false)}/>}
    </div>
  );

  if (subTab === 'agent') return (
    <div>
      {tabBar}
      <ClearviewAgentTabInline slug={slug} clients={clients}/>
    </div>
  );

  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;
  const hosts = data?.hosts || [];
  const summary = data?.summary || {};
  if (!loading && !data?.available) return <div>{tabBar}<div style={{padding:24,color:'var(--text-muted)',fontSize:13}}>No network scan data yet. Scans run automatically when a Clearview Edge node or an agent-based primary scanner is active on the client network.</div></div>;

  return (
    <div>
      {tabBar}
      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:10,marginBottom:16,flexWrap:'wrap'}}>
        <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
          {[{label:'Total Devices',val:summary.total_hosts??0,color:'var(--accent)',clickable:false},{label:'New Since Last',val:hosts.filter(h=>h.is_new).length,color:'#e6b800',clickable:hosts.filter(h=>h.is_new).length>0}].map(({label,val,color,clickable})=>{
            const isActive = clickable && showNewOnly;
            return (
              <div key={label}
                onClick={clickable ? () => setShowNewOnly(v => !v) : undefined}
                style={{background:isActive?'#e6b80012':'var(--surface)',border:isActive?'1px solid #e6b80060':'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:'12px 18px',minWidth:100,cursor:clickable?'pointer':'default',transition:'border 0.15s,background 0.15s',userSelect:'none'}}>
                <div style={{fontSize:22,fontWeight:800,color,fontFamily:'var(--font-mono)',lineHeight:1,marginBottom:4}}>{val}</div>
                <div style={{fontSize:10,color:isActive?'#e6b800':'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.1em',fontWeight:600}}>{isActive?'New Only · Clear':label}</div>
              </div>
            );
          })}
          <SiteSubnetsCard summary={summary} hosts={hosts} sites={labels.sites} isAdmin={true}/>
          {data?.source&&<div style={{fontSize:9,fontWeight:700,padding:'2px 8px',borderRadius:4,
            background:data.source==='edge'?'rgba(0,212,255,0.10)':'rgba(48,209,88,0.10)',
            border:data.source==='edge'?'1px solid rgba(0,212,255,0.30)':'1px solid rgba(48,209,88,0.30)',
            color:data.source==='edge'?'var(--accent)':'#30d158',
            fontFamily:'var(--font-mono)',letterSpacing:'0.06em',alignSelf:'center'}}>
            {data.source==='edge'?'Edge':'Agent'}
          </div>}
        </div>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          {cveMsg&&<span style={{fontSize:11,color:'var(--text-muted)'}}>{cveMsg}</span>}
          <button className="btn btn-secondary btn-sm" onClick={recheckCves} disabled={cveBusy} title="Check the latest network scan against the national vulnerability database again">{cveBusy?<span className="spinner"/>:'↻ Re-check vulnerabilities'}</button>
          {bulkImportBtn('discovered')}
        </div>
      </div>
      <input className="input-sm" type="text" placeholder="Filter by IP, hostname or label…" value={filter} onChange={e=>setFilter(e.target.value)}
        style={{ width:'100%', marginBottom:12 }}/>
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {hosts.filter(h=>(!showNewOnly||h.is_new)&&(!filter||h.ip.includes(filter)||(h.hostname||'').toLowerCase().includes(filter.toLowerCase()))).map(host=>{
          const macKey=(host.mac||'').toLowerCase();
          const _dv=labels.devices?.[macKey]; const devLabel=typeof _dv==='string'?_dv:(_dv?.label||'');
          const services=(host.services||[]).filter((s,i,a)=>a.findIndex(x=>x.label===s.label)===i);
          return (
            <div key={host.ip} style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',padding:'12px 16px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:6}}>
                <div>
                  {devLabel?<div style={{fontSize:13,fontWeight:600}}>{devLabel}</div>:host.edge_node?<div style={{fontSize:13,fontWeight:600}}>STG Edge Node (NAS)</div>:host.device_type?<div style={{fontSize:13,fontWeight:500}}>{host.device_type}</div>:<div style={{fontSize:12,color:'var(--text-muted)',fontStyle:'italic'}}>Unlabelled</div>}
                  <div style={{fontSize:11,color:'var(--text-muted)',fontFamily:'var(--font-mono)',marginTop:2}}>{host.ip}{host.hostname?` · ${host.hostname}`:''}</div>
                  {host.mac&&<div style={{fontSize:10,color:'var(--text-muted)',fontFamily:'var(--font-mono)',marginTop:1}}>{host.mac}</div>}
                </div>
                <div style={{display:'flex',flexDirection:'column',gap:3,alignItems:'flex-end',flexShrink:0,marginLeft:8}}>
                  {host.edge_node&&<span className="tag tag-blue" title={`${host.edge_node.label}: the Edge Node${host.edge_node.role==='nas'?"'s NAS":''}`}>STG Edge Node</span>}
                  {host.is_new&&<span style={{fontSize:9,fontWeight:700,padding:'2px 6px',borderRadius:3,background:'#e6b80020',border:'1px solid #e6b80060',color:'#e6b800'}}>NEW</span>}
                  <HostCveBadge host={host}/>
                  {(host.source==='agent'||host.source==='both')&&<span style={{fontSize:9,fontWeight:700,padding:'2px 6px',borderRadius:3,background:'rgba(48,209,88,0.12)',border:'1px solid rgba(48,209,88,0.4)',color:'#30d158'}}>Agent</span>}
                  {(host.source==='edge'||host.source==='both')&&<span style={{fontSize:9,fontWeight:700,padding:'2px 6px',borderRadius:3,background:'rgba(0,212,255,0.10)',border:'1px solid rgba(0,212,255,0.35)',color:'var(--accent)'}}>Edge</span>}
                </div>
              </div>
              {services.length>0&&(
                <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                  {services.map((s,i)=>{
                    const color={'Web':'#00d4ff','Secure Web':'#00d4ff','Remote Access':'#ff2d55','Remote Desktop':'#ff2d55','Email':'#30d158','Database':'#ff9f0a','DNS':'#86868b','Printing':'#86868b','File Sharing':'#e6b800'}[s.label]||'#86868b';
                    return <span key={i} title={`Port ${s.port} · ${s.service||s.label}`} style={{padding:'2px 8px',borderRadius:4,fontSize:11,fontWeight:600,background:`${color}18`,border:`1px solid ${color}40`,color,fontFamily:'var(--font-mono)',cursor:'help'}}><span style={{opacity:0.6,fontSize:10,marginRight:3}}>{s.port}</span>{s.label}<ServiceCveDot service={s}/></span>;
                  })}
                </div>
              )}
              <HostCveList host={host}/>
            </div>
          );
        })}
      </div>
      {showBulkImport && <BulkImportModal slug={slug} defaultTab={bulkImportTab} onClose={()=>setShowBulkImport(false)} onImported={()=>setShowBulkImport(false)}/>}
    </div>
  );
}

function ComputersSubTabInline({ slug }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { authFetch(`/api/clients/${slug}/action1`).then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false)); }, [slug]);
  const { endpoints, live, newCount } = useAction1Live(slug, data?.data?.endpoints);
  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;
  if (!data?.available) return <div style={{padding:24,color:'var(--text-muted)',fontSize:13}}>No managed computer data yet.</div>;
  const summary=data?.data?.summary||{};
  return (
    <div>
      <div className="stat-tiles">{[{label:'Total',val:endpoints.length,tone:'accent'},{label:'Compliant',val:summary.compliant??0,tone:'green'},{label:'Non-compliant',val:summary.non_compliant??0,tone:summary.non_compliant>0?'red':'muted'},{label:'Critical updates',val:summary.with_critical??0,tone:summary.with_critical>0?'red':'muted'}].map(({label,val,tone})=>(
          <div key={label} className="stat-card">
            <div className={`stat-value ${tone}`}>{val}</div>
            <div className="stat-label">{label}</div>
          </div>
        ))}
      </div>
      <Action1StatusSource live={live} scannedAt={data?.scanned_at} newCount={newCount}/>
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {endpoints.map(ep=>{ const comp=a1Compliance(ep); return (
          <div key={ep.id} style={{background:'var(--surface)',border:'1px solid var(--border)',borderLeft:`3px solid ${comp.color}`,borderRadius:'var(--radius-lg)',padding:'12px 16px'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
              <div style={{fontFamily:'var(--font-mono)',fontSize:13,fontWeight:700}}>{ep.name}</div>
              <span style={{fontSize:12,fontWeight:700,color:comp.color}}>{comp.label}</span>
            </div>
            <div style={{fontSize:11,color:'var(--text-muted)'}}>{ep.os}{ep.os_eol?` — EOL`:''}  ·  <span style={{fontWeight:600,color:A1_STATUS_COLOR[ep.status]||'var(--text-muted)'}}>{ep.status||'-'}</span>{ep.status!=='Connected'&&ep.last_seen?`  ·  Last seen ${fmtA1Time(ep.last_seen)}`:''}</div>
            {ep.missing_critical>0&&<div style={{fontSize:11,color:'#ff2d55',marginTop:2}}>{ep.missing_critical} critical update{ep.missing_critical!==1?'s':''} pending</div>}
          </div>
        );})}
      </div>
    </div>
  );
}


// ── Endpoint Assessment (inline for admin) ────────────────────────────────────

const EP_CONTROL_COLORS = {
  "Firewalls":"#00d4ff","Secure Configuration":"#bf5af2","User Access Control":"#0a84ff",
  "Malware Protection":"#30d158","Security Update Management":"#ff9f0a",
  "Clearview Baseline":"#5856d6","Supplemental":"#86868b",
};
const EP_STATUS_COLOR = {pass:"#30d158",pass_assumed:"#e6b800",attested:"#30d158",fail:"#ff2d55",no_explicit_control_fail:"#ff2d55",no_data:"#86868b",informational:"#86868b",error:"#ff2d55"};
const EP_STATUS_LABEL = {pass:"Pass",pass_assumed:"Pass*",attested:"Verified",fail:"Fail",no_explicit_control_fail:"Manual check required",no_data:"No data",informational:"Info",error:"Check Error"};

function EndpointAssessmentInline({ slug }) {
  const [data, setData]             = useState(null);
  const [loading, setLoading]       = useState(true);
  const [attestations, setAttestations] = useState({});
  const [selDev, setSelDev]         = useState(0);
  const [layer, setLayer]           = useState("all");
  const [triggering, setTriggering] = useState(false);
  const [triggered, setTriggered]   = useState(false);

  const loadData = () => {
    if (!slug) return;
    authFetch(`/api/clients/${slug}/endpoint`).then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  };

  useEffect(() => {
    loadData();
    authFetch(`/api/clients/${slug}/endpoint/attestations`).then(r=>r.json()).then(d=>setAttestations(d.attestations||{})).catch(()=>{});
  }, [slug]);

  const handleAttest = async (queryId, attested) => {
    try {
      const r = await authFetch(`/api/clients/${slug}/endpoint/attestations`, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({query_id: queryId, attested}),
      });
      if (r.ok) {
        loadData();
        authFetch(`/api/clients/${slug}/endpoint/attestations`).then(r=>r.json()).then(d=>setAttestations(d.attestations||{})).catch(()=>{});
      }
    } catch(e) {}
  };

  const handleTriggerAssessment = async (deviceId) => {
    if (!deviceId) return;
    setTriggering(true);
    try {
      await authFetch(`/api/clients/${slug}/endpoint/device/${deviceId}/assessment-trigger`, { method: 'POST' });
      setTriggered(true);
      setTimeout(() => setTriggered(false), 5000);
    } finally {
      setTriggering(false);
    }
  };

  if (loading) return <div style={{padding:32,textAlign:"center"}}><span className="spinner"/></div>;
  if (!data?.available || !data?.data?.devices?.length) return (
    <div style={{padding:24,textAlign:"center",color:"var(--text-muted)",fontSize:13}}>
      No endpoint assessment data yet. Deploy the STG Endpoint Agent to begin collecting data.
    </div>
  );

  const devices = data.data.devices;
  const dev     = devices[selDev] || devices[0];
  const results = dev.results || [];
  const ce      = dev.summary?.ce_plus || {};
  const bl      = dev.summary?.clearview_baseline || {};
  const gradeColor = ce.grade==="pass"?"#30d158":ce.grade==="fail"?"#ff2d55":"#86868b";
  const layerCounts = results.reduce((acc,r)=>{acc[r.layer]=(acc[r.layer]||0)+1;return acc;},{});
  const attestable = s => s==="no_explicit_control_fail"||s==="error";

  // Group results by control
  const filtered = results.filter(r => layer==="all" || r.layer===layer);
  const grouped = {};
  filtered.forEach(r=>{const c=r.control||"Other";if(!grouped[c])grouped[c]=[];grouped[c].push(r);});

  return (
    <div>
      {/* Device selector if multiple */}
      {devices.length > 1 && (
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
          {devices.map((d,i)=>{
            const dc=d.summary?.ce_plus||{};
            const gc=dc.grade==="pass"?"#30d158":dc.grade==="fail"?"#ff2d55":"#86868b";
            return (
              <button className="btn btn-secondary btn-sm" aria-pressed={i===selDev} key={i} onClick={()=>setSelDev(i)}>
                <span style={{display:"inline-block",width:6,height:6,borderRadius:"50%",background:gc,marginRight:5}}/>
                {d.device?.hostname||d.device?.uuid?.substring(0,8)||`Device ${i+1}`}
                <span style={{marginLeft:6,color:gc,fontFamily:"var(--font-mono)"}}>{dc.pct??0}%</span>
              </button>
            );
          })}
        </div>
      )}

      {/* Device header */}
      <div style={{marginBottom:12,display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"var(--text)"}}>{dev.device?.hostname||"Unknown Device"}</div>
          <div style={{fontSize:11,color:"var(--text-muted)",marginTop:2}}>
            {dev.device?.model&&<span>{dev.device.model} · </span>}
            {dev.device?.serial&&<span>S/N {dev.device.serial} · </span>}
            {dev.collected_at&&<span>Assessed {new Date(dev.collected_at).toLocaleString("en-GB",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit",timeZone:"Europe/London"})} GMT</span>}
          </div>
        </div>
        <button className="btn btn-secondary btn-sm" aria-pressed={!(triggered)} onClick={()=>handleTriggerAssessment(dev.device_id)} disabled={triggering||triggered||!dev.device_id}
         >
          {triggered ? '✓ Queued — runs on next heartbeat' : triggering ? '...' : '▶ Run Assessment Now'}
        </button>
      </div>

      {/* Summary strip */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16}}>
        {[
          {label:"Cyber Essentials Plus",val:`${ce.pct??0}%`,sub:ce.grade==="pass"?"PASS":ce.grade==="fail"?"FAIL":"—",color:gradeColor,extra:ce.auto_fails>0?` · ${ce.auto_fails} auto-fail`:""},
          {label:"Clearview Baseline",val:`${bl.pct??0}%`,sub:`${bl.pass??0} of ${bl.total??0} passed`,color:"#5856d6"},
          {label:"Pass",val:ce.pass??0,color:"#30d158"},
          {label:"Fail",val:ce.fail??0,color:"#ff2d55"},
          {label:"Auto-Fail",val:ce.auto_fails??0,color:"#ff2d55"},
        ].map(({label,val,sub,color,extra})=>(
          <div key={label} style={{background:"var(--card-bg)",border:"1px solid var(--border)",borderTop:`2px solid ${color}`,borderRadius:8,padding:"10px 14px",minWidth:90,textAlign:"center"}}>
            <div style={{fontSize:18,fontWeight:800,color,fontFamily:"var(--font-mono)",lineHeight:1}}>{val}</div>
            <div style={{fontSize:10,color:"var(--text-muted)",marginTop:3,textTransform:"uppercase",letterSpacing:"0.07em",fontWeight:600}}>{label}</div>
            {sub&&<div style={{fontSize:10,fontWeight:700,color,marginTop:2}}>{sub}{extra}</div>}
          </div>
        ))}
      </div>

      {/* Layer filter */}
      <div style={{display:"flex",gap:6,marginBottom:12,flexWrap:"wrap"}}>
        {[
          {id:"all",label:`All (${results.length})`},
          {id:"Cyber Essentials Plus",label:`CE+ (${layerCounts["Cyber Essentials Plus"]||0})`},
          {id:"Clearview Baseline",label:`Baseline (${layerCounts["Clearview Baseline"]||0})`},
        ].map(f=>(
          <button className="btn btn-secondary btn-sm" aria-pressed={layer===f.id} key={f.id} onClick={()=>setLayer(f.id)}>{f.label}</button>
        ))}
      </div>

      {/* Results grouped by control */}
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {Object.entries(grouped).map(([ctrl,items])=>(
          <div key={ctrl}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
              <div style={{width:8,height:8,borderRadius:"50%",background:EP_CONTROL_COLORS[ctrl]||"#86868b"}}/>
              <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-muted)"}}>{ctrl}</div>
            </div>
            <div style={{background:"var(--card-bg)",border:"1px solid var(--border)",borderRadius:8,overflow:"hidden"}}>
              {items.map((r,i)=>{
                const sc=EP_STATUS_COLOR[r.status]||"#86868b";
                const isAttested=r.status==="attested";
                const rowBg=isAttested?"rgba(48,209,88,0.04)":r.status==="fail"||r.status==="no_explicit_control_fail"||r.status==="error"?"rgba(255,45,85,0.04)":"transparent";
                return (
                  <div key={r.query_id} style={{
                    display:"flex",alignItems:"flex-start",gap:10,padding:"10px 14px",
                    borderBottom:i<items.length-1?"1px solid var(--border)":"none",
                    background:rowBg,
                  }}>
                    <span style={{fontSize:9,fontWeight:700,padding:"2px 6px",borderRadius:3,background:`${sc}18`,border:`1px solid ${sc}40`,color:sc,whiteSpace:"nowrap",fontFamily:"var(--font-mono)",flexShrink:0,marginTop:1}}>
                      {EP_STATUS_LABEL[r.status]||r.status}{r.auto_fail&&r.status==="fail"?" ⚠":""}
                    </span>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:11,fontWeight:600,color:"var(--text)",marginBottom:2}}>{r.requirement}</div>
                      {r.status==="fail"&&<div style={{fontSize:10,color:"#ff2d55"}}>{r.fail_label}</div>}
                      {r.status==="pass_assumed"&&<div style={{fontSize:10,color:"#e6b800"}}>No Explicit Control - {r.no_data_note||"Default behaviour assumed safe. Manual verification recommended."}</div>}
                      {r.status==="no_explicit_control_fail"&&<div style={{fontSize:10,color:"#ff2d55"}}>{r.no_data_note||"Cannot be verified automatically. Admin verification required."}</div>}
                      {r.status==="error"&&<div style={{fontSize:10,color:"#ff2d55"}}>Check failed to run — verify agent permissions or query compatibility.</div>}
                      {r.status==="no_data"&&<div style={{fontSize:10,color:"var(--text-muted)"}}>No data — check agent permissions or key absent.</div>}
                      {isAttested&&<div style={{fontSize:10,color:"#30d158"}}>Verified by {r.attested_by||"admin"}{r.attested_at?" on "+new Date(r.attested_at).toLocaleString("en-GB",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit",timeZone:"Europe/London"})+" GMT":""}</div>}
                      {attestable(r.status)&&(
                        <label style={{display:"inline-flex",alignItems:"center",gap:6,marginTop:5,cursor:"pointer"}}>
                          <input type="checkbox" checked={false} onChange={e=>{if(e.target.checked)handleAttest(r.query_id,true);}} style={{accentColor:"#30d158",width:12,height:12,cursor:"pointer"}}/>
                          <span style={{fontSize:10,color:"var(--text-muted)"}}>Mark as verified — I have manually confirmed this control is in place</span>
                        </label>
                      )}
                      {isAttested&&(
                        <label style={{display:"inline-flex",alignItems:"center",gap:6,marginTop:5,cursor:"pointer"}}>
                          <input type="checkbox" checked={true} onChange={e=>{if(!e.target.checked)handleAttest(r.query_id,false);}} style={{accentColor:"#30d158",width:12,height:12,cursor:"pointer"}}/>
                          <span style={{fontSize:10,color:"#30d158"}}>Verified by admin — untick to remove</span>
                        </label>
                      )}
                    </div>
                    <div style={{fontSize:9,color:"var(--text-muted)",fontFamily:"var(--font-mono)",flexShrink:0,whiteSpace:"nowrap"}}>{r.layer==="Clearview Baseline"?"Baseline":"CE+"}</div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ComplianceHubInline({ slug }) {
  const [subTab, setSubTab] = useState('overview');
  const TABS = [
    { id: 'overview',  label: 'Overview' },
    { id: 'endpoint',  label: 'Endpoint Assessment' },
    { id: 'phishing',  label: 'Phishing Simulation' },
  ];
  return (
    <div>
      <div style={{display:"flex",gap:2,borderBottom:"1px solid var(--border)",marginBottom:16}}>
        {TABS.map(t=>(
          <button className="tab-btn" aria-selected={subTab===t.id} key={t.id} onClick={()=>setSubTab(t.id)}>{t.label}</button>
        ))}
      </div>
      {subTab==="overview"  && <ComplianceTile slug={slug} />}
      {subTab==="endpoint"  && <EndpointAssessmentInline slug={slug} />}
      {subTab==="phishing"  && <PhishingSection slug={slug} isAdmin={true} />}
    </div>
  );
}

// v3.76: security assessment reports (clients/<slug>/assessment/reports)
function AssessmentReportsInline({ slug }) {
  const [items, setItems]           = useState(null);
  const [downloading, setDownloading] = useState('');
  const [deleting, setDeleting]     = useState('');

  const load = useCallback(() => {
    authFetch(`/api/clients/${slug}/assessment-reports`)
      .then(r => (r.ok ? r.json() : []))
      .then(d => setItems(Array.isArray(d) ? d : []))
      .catch(() => setItems([]));
  }, [slug]);
  useEffect(() => { load(); }, [load]);

  const view = (filename) => window.open(`/api/clients/${slug}/assessment-reports/${encodeURIComponent(filename)}?view=1`, '_blank');
  const download = async (filename) => {
    setDownloading(filename);
    try {
      const res = await authFetch(`/api/clients/${slug}/assessment-reports/${encodeURIComponent(filename)}`);
      if (!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = filename; a.click(); URL.revokeObjectURL(url);
    } catch (err) { alert('Download failed: ' + err.message); }
    finally { setDownloading(''); }
  };
  const remove = async (filename) => {
    if (!window.confirm(`Delete "${filename}"?\n\nThis also removes the paired client or internal report. This cannot be undone.`)) return;
    setDeleting(filename);
    try {
      const res = await authFetch(`/api/clients/${slug}/assessment-reports/${encodeURIComponent(filename)}`, { method: 'DELETE' });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { alert(d.error || 'Delete failed'); return; }
      load();
    } catch (err) { alert(err.message); }
    finally { setDeleting(''); }
  };

  const fmt = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return isNaN(d) ? iso : d.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
  };

  const sectionHead = { fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 };
  const row = { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8 };
  const small = { fontSize: 11, padding: '3px 10px' };

  if (items === null) return <div style={{ padding: 16, textAlign: 'center' }}><span className="spinner" /></div>;

  const clientItems   = items.filter(r => !r.is_internal);
  const internalItems = items.filter(r => r.is_internal);

  const renderRow = (r) => (
    <div key={r.filename} style={{ ...row, opacity: r.is_internal ? 0.8 : 1 }}>
      {r.is_internal
        ? <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 3, background: '#e6b80020', border: '1px solid #e6b80040', color: '#e6b800', flexShrink: 0 }}>INT</span>
        : r.grade
          ? <span className={`grade-badge grade-${r.grade[0]}`} style={{ width: 28, height: 28, fontSize: 12, flexShrink: 0 }}>{r.grade}</span>
          : <span className="grade-badge grade-unknown" style={{ width: 28, height: 28, fontSize: 12, flexShrink: 0 }}>?</span>}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.filename}</div>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
          {fmt(r.date)}{!r.is_internal && r.score != null ? ` · Score ${r.score}/100` : ''}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        <button className="btn btn-secondary btn-sm" onClick={() => view(r.filename)}>View</button>
        <button className="btn btn-secondary btn-sm" onClick={() => download(r.filename)} disabled={downloading === r.filename}>{downloading === r.filename ? <span className="spinner" /> : '↓'}</button>
        <button className="btn btn-danger btn-sm" onClick={() => remove(r.filename)} disabled={deleting === r.filename}>{deleting === r.filename ? <span className="spinner" /> : 'Delete'}</button>
      </div>
    </div>
  );

  return (
    <div style={{ marginBottom: 20 }}>
      <ReportSectionHeader title="External Cyber Security Assessments" count={items.filter(i => !i.is_internal).length} slug={slug} kind="assessment" />
      {items.length === 0 ? (
        <div style={{ ...row, fontSize: 12, color: 'var(--text-muted)' }}>No assessments yet. Use Generate to run one.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {clientItems.map(renderRow)}
          {internalItems.length > 0 && <div style={{ ...sectionHead, marginTop: 8, marginBottom: 2 }}>Internal assessment reports</div>}
          {internalItems.map(renderRow)}
        </div>
      )}
    </div>
  );
}

// v3.83: saved Website Analytics Reports (app.py v3.96 keeps a copy of each one sent)
function AnalyticsReportsInline({ slug }) {
  const [items, setItems]             = useState(null);
  const [downloading, setDownloading] = useState('');
  const [deleting, setDeleting]       = useState('');

  const load = useCallback(() => {
    authFetch(`/api/clients/${slug}/analytics-reports`)
      .then(r => (r.ok ? r.json() : []))
      .then(d => setItems(Array.isArray(d) ? d : []))
      .catch(() => setItems([]));
  }, [slug]);
  useEffect(() => { load(); }, [load]);

  const view = (filename) => window.open(`/api/clients/${slug}/analytics-reports/${encodeURIComponent(filename)}?view=1`, '_blank');
  const download = async (filename) => {
    setDownloading(filename);
    try {
      const res = await authFetch(`/api/clients/${slug}/analytics-reports/${encodeURIComponent(filename)}`);
      if (!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = filename; a.click(); URL.revokeObjectURL(url);
    } catch (err) { alert('Download failed: ' + err.message); }
    finally { setDownloading(''); }
  };
  const remove = async (filename) => {
    if (!window.confirm(`Delete "${filename}"?\n\nThis removes the saved copy only; the email already sent is not affected. This cannot be undone.`)) return;
    setDeleting(filename);
    try {
      const res = await authFetch(`/api/clients/${slug}/analytics-reports/${encodeURIComponent(filename)}`, { method: 'DELETE' });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { alert(d.error || 'Delete failed'); return; }
      load();
    } catch (err) { alert(err.message); }
    finally { setDeleting(''); }
  };

  const fmt = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return isNaN(d) ? iso : d.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }) + ' GMT';
  };
  const row = { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8 };
  const small = { fontSize: 11, padding: '3px 10px' };

  if (items === null) return null;
  return (
    <div style={{ marginTop: 20 }}>
      <ReportSectionHeader title="Website Analytics Reports" count={items.length} slug={slug} kind="analytics" onSent={load} />
      {items.length === 0 ? (
        <div style={{ ...row, fontSize: 12, color: 'var(--text-muted)' }}>No analytics reports sent yet. Each one sent, by hand or on its schedule, is kept here.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {items.map(r => {
            const stats = [r.period, r.visits != null ? `${r.visits} visit${String(r.visits) === '1' ? '' : 's'}` : '', r.enquiries != null ? `${r.enquiries} enquir${String(r.enquiries) === '1' ? 'y' : 'ies'}` : ''].filter(Boolean).join(' · ');
            const to = (r.recipients || []).length ? ` · sent to ${r.recipients.join(', ')}` : '';
            return (
              <div key={r.filename} style={row}>
                <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 3, background: '#00d4ff18', border: '1px solid #00d4ff40', color: '#00a8cc', flexShrink: 0 }}>WEB</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.subject || r.filename}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {fmt(r.date)}{stats ? ` · ${stats}` : ''}{to}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button className="btn btn-secondary btn-sm" onClick={() => view(r.filename)}>View</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => download(r.filename)} disabled={downloading === r.filename}>{downloading === r.filename ? <span className="spinner" /> : '↓'}</button>
                  <button className="btn btn-danger btn-sm" onClick={() => remove(r.filename)} disabled={deleting === r.filename}>{deleting === r.filename ? <span className="spinner" /> : 'Delete'}</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function ReportsHubInline({ slug }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState('');
  const [deleting, setDeleting] = useState('');
  const refreshReports = () => authFetch(`/api/clients/${slug}/reports`).then(r=>r.json()).then(d=>{if(Array.isArray(d))setReports(d);}).catch(()=>{});

  useEffect(() => { authFetch(`/api/clients/${slug}/reports`).then(r=>r.json()).then(d=>{setReports(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false)); }, [slug]);

  const handleDownload = async (filename) => {
    setDownloading(filename);
    try {
      const token = localStorage.getItem('stg_token');
      const res = await fetch(`/api/clients/${slug}/reports/${filename}`, {headers:{Authorization:`Bearer ${token}`}});
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href=url; a.download=filename; a.click(); URL.revokeObjectURL(url);
    } catch(err) { alert('Download failed: '+err.message); }
    finally { setDownloading(''); }
  };

  const handleDelete = async (filename) => {
    if(!window.confirm(`Delete "${filename}"?\n\nThis will also delete the paired internal report. This cannot be undone.`))return;
    setDeleting(filename);
    try{const res=await authFetch(`/api/clients/${slug}/reports/${encodeURIComponent(filename)}`,{method:'DELETE'});const d=await res.json();if(!res.ok){alert(d.error||'Delete failed');return;}
      refreshReports();
    }catch(err){alert(err.message);}finally{setDeleting('');}
  };

  const handleView = (filename) => {
    const token = localStorage.getItem('stg_token');
    window.open(`/api/clients/${slug}/reports/${filename}/view?token=${token}`, '_blank');
  };

  if (loading) return <div style={{padding:24,textAlign:'center'}}><span className="spinner"/></div>;

  const clientReports = reports.filter(r=>!r.is_internal);
  const internalReports = reports.filter(r=>r.is_internal);

  const fmtDate = (iso) => {
    if (!iso) return '—';
    try { const c=iso.replace(/\+00:00Z$/,'+00:00').replace(/Z$/,''); const d=new Date(c); if(isNaN(d)) return iso; return d.toLocaleString('en-GB',{day:'2-digit',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit',timeZone:'Europe/London'})+' GMT'; } catch { return iso; }
  };

  return (
    <div>
      <AssessmentReportsInline slug={slug}/>
      <ReportSectionHeader title="IT and Cyber Security Reports" count={clientReports.length} slug={slug} kind="it" />
      {reports.length===0?<div style={{padding:24,color:'var(--text-muted)',fontSize:13,textAlign:'center'}}>No reports yet.</div>:(
        <div style={{display:'flex',flexDirection:'column',gap:6}}>
          {clientReports.map(r=>(
            <div key={r.filename} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
              {r.grade&&<span className={`grade-badge grade-${r.grade[0]}`} style={{width:28,height:28,fontSize:12,flexShrink:0}}>{r.grade}</span>}
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.filename}</div>
                <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>{fmtDate(r.date)}</div>
              </div>
              <div style={{display:'flex',gap:6,flexShrink:0}}>
                <button className="btn btn-secondary btn-sm" onClick={()=>handleView(r.filename)}>View</button>
                <button className="btn btn-secondary btn-sm" onClick={()=>handleDownload(r.filename)} disabled={downloading===r.filename}>{downloading===r.filename?<span className="spinner"/>:'↓'}</button>
                <button className="btn btn-danger btn-sm" onClick={()=>handleDelete(r.filename)} disabled={deleting===r.filename}>{deleting===r.filename?<span className="spinner"/>:'Delete'}</button>
              </div>
            </div>
          ))}
          {internalReports.length>0&&(
            <>
              <div style={{fontSize:11,fontWeight:600,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.08em',marginTop:8,marginBottom:4}}>Internal Reports</div>
              {internalReports.map(r=>(
                <div key={r.filename} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,opacity:0.8}}>
                  <span style={{fontSize:10,fontWeight:700,padding:'2px 6px',borderRadius:3,background:'#e6b80020',border:'1px solid #e6b80040',color:'#e6b800',flexShrink:0}}>INT</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.filename}</div>
                    <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>{fmtDate(r.date)}</div>
                  </div>
                  <div style={{display:'flex',gap:6,flexShrink:0}}>
                    <button className="btn btn-secondary btn-sm" onClick={()=>handleView(r.filename)}>View</button>
                    <button className="btn btn-secondary btn-sm" onClick={()=>handleDownload(r.filename)} disabled={downloading===r.filename}>{downloading===r.filename?<span className="spinner"/>:'↓'}</button>
                    <button className="btn btn-danger btn-sm" onClick={()=>handleDelete(r.filename)} disabled={deleting===r.filename}>{deleting===r.filename?<span className="spinner"/>:'Delete'}</button>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      )}
      <AnalyticsReportsInline slug={slug}/>
    </div>
  );
}

// ── Subscription tier helpers ─────────────────────────────────────────────────

const ALL_HUBS = ['hub_cyber','hub_device','hub_compliance','hub_digital','hub_productivity','hub_assets','hub_schedules','hub_resources'];
const HUB_LABELS = {
  hub_cyber:        'Cyber Security Hub',
  hub_device:       'Device Hub',
  hub_compliance:   'Compliance Hub',
  hub_digital:      'Digital Hub',
  hub_productivity: 'Productivity Hub',
  hub_assets:       'Assets Hub',
  hub_schedules:    'Schedules',
  hub_resources:    'Resources',
};

// Widget catalogue hub mapping — mirrors ClientDashboard.js WIDGET_CATALOGUE
const WIDGET_HUB_MAP = {
  cyber_grade: 'hub_cyber', compliance: 'hub_compliance', productivity: 'hub_productivity',
  devices: 'hub_device', backup: 'hub_compliance', email_security: 'hub_cyber',
  web_presence: 'hub_digital', saas: 'hub_cyber',
};

function TierPill({ tierId, overridden }) {
  const [tiers, setTiers] = useState([]);
  useEffect(() => {
    authFetch('/api/admin/subscription-tiers')
      .then(r => r.json())
      .then(d => setTiers(d.tiers || []))
      .catch(() => {});
  }, []);
  if (!tierId) return null;
  const tier = tiers.find(t => t.id === tierId);
  if (!tier) return null;
  return (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:4,
      fontSize:10, fontWeight:700, padding:'2px 7px', borderRadius:10,
      background: `${tier.colour}22`, color: tier.colour,
      border: `1px solid ${tier.colour}44`,
      letterSpacing:'0.03em', lineHeight:1.4,
    }}>
      {tier.name}
      {overridden && <span title="Features modified from tier defaults" style={{opacity:0.7}}>·</span>}
    </span>
  );
}

function DemoPill() {
  return (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:4,
      fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:10,
      background:'rgba(168,85,247,0.15)', color:'#a855f7',
      border:'1px solid rgba(168,85,247,0.35)',
      letterSpacing:'0.05em', lineHeight:1.4,
    }}>
      DEMO
    </span>
  );
}

function SubscriptionTab({ slug, client, onRefresh }) {
  const [tiers,        setTiers]        = useState([]);
  const [features,     setFeatures]     = useState({});
  const [tierId,       setTierId]       = useState(null);
  const [overridden,   setOverridden]   = useState(false);
  const [saving,       setSaving]       = useState(false);
  const [saved,        setSaved]        = useState(false);
  const [pendingReset, setPendingReset] = useState(null); // { features, tierName } when confirm modal is open

  useEffect(() => {
    authFetch('/api/admin/subscription-tiers').then(r=>r.json()).then(d=>setTiers(d.tiers||[])).catch(()=>{});
    authFetch(`/api/clients/${slug}/features`).then(r=>r.json()).then(d=>{
      setFeatures(d?.features||{});
      setTierId(d?.subscription_tier_id||null);
      setOverridden(d?.tier_overridden||false);
    }).catch(()=>{});
  }, [slug]);

  const saveFeatures = async (newFeatures, newTierId, newOverridden) => {
    setSaving(true);
    try {
      await authFetch(`/api/admin/clients/${slug}/features`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ features: newFeatures, subscription_tier_id: newTierId, tier_overridden: newOverridden }),
      });
      setFeatures(newFeatures); setTierId(newTierId); setOverridden(newOverridden);
      setSaved(true); setTimeout(()=>setSaved(false), 2500);
      onRefresh?.();
    } catch(e) {}
    setSaving(false);
  };

  const resetDashboard = async (newFeatures) => {
    const res = await authFetch(`/api/clients/${slug}/dashboard-config`).catch(()=>null);
    const cfg = res ? await res.json().catch(()=>({})) : {};
    const widgets = cfg.widgets || [];
    if (!widgets.length) return;
    const updated = widgets.map(w => {
      const hub = WIDGET_HUB_MAP[w.id];
      return hub && !newFeatures[hub] ? { ...w, enabled: false } : w;
    });
    await authFetch(`/api/clients/${slug}/dashboard-config`, {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ ...cfg, widgets: updated, last_updated: new Date().toISOString() }),
    }).catch(()=>{});
  };

  const applyTier = async (tier) => {
    const newFeatures = { ...tier.hubs };
    await saveFeatures(newFeatures, tier.id, false);
    setPendingReset({ features: newFeatures, tierName: tier.name });
  };

  const toggleHub = async (hubKey) => {
    const newFeatures = { ...features, [hubKey]: !features[hubKey] };
    await saveFeatures(newFeatures, tierId, true);
  };

  const currentTier = tiers.find(t => t.id === tierId);

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20}}>

      {/* Dashboard reset confirmation modal */}
      {pendingReset && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}
          onClick={()=>setPendingReset(null)}>
          <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:12,padding:'28px 28px 22px',maxWidth:400,width:'90%',boxShadow:'0 8px 40px rgba(0,0,0,0.4)'}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:16,fontWeight:700,color:'var(--text)',marginBottom:10}}>Reset dashboard layout?</div>
            <div style={{fontSize:13,color:'var(--text-muted)',lineHeight:1.6,marginBottom:22}}>
              Reset dashboard widgets to match the <strong style={{color:'var(--text)'}}>{pendingReset.tierName}</strong> tier?
              Widgets for unavailable hubs will be hidden. Your widget order will be preserved.
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <button className="btn btn-secondary"
                onClick={()=>setPendingReset(null)}
               >
                Keep current layout
              </button>
              <button className="btn btn-primary"
                onClick={async()=>{ setPendingReset(null); await resetDashboard(pendingReset.features); }}
               >
                Yes, reset dashboard
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Current status */}
      <div style={{display:'flex',alignItems:'center',gap:12,padding:'12px 16px',background:'var(--surface)',borderRadius:8,border:'1px solid var(--border)'}}>
        <i className="ti ti-credit-card" style={{fontSize:18,color:'var(--accent)'}}/>
        <div style={{flex:1}}>
          <div style={{fontSize:13,fontWeight:600,color:'var(--text)'}}>
            {currentTier
              ? <span>
                  On <span style={{color:currentTier.colour,fontWeight:700}}>{currentTier.name}</span> tier
                  {overridden && <span style={{fontSize:11,color:'var(--text-muted)',marginLeft:8,fontWeight:400}}>· features modified from defaults</span>}
                </span>
              : <span style={{color:'var(--text-muted)'}}>No tier applied — using custom feature flags</span>}
          </div>
          {currentTier?.description && (
            <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>{currentTier.description}</div>
          )}
        </div>
        {saved && <span style={{fontSize:11,color:'#30d158',fontWeight:600}}>✓ Saved</span>}
        {saving && <span style={{fontSize:11,color:'var(--text-muted)'}}>Saving…</span>}
      </div>

      {/* Tier selector */}
      {tiers.length > 0 && (
        <div>
          <div style={{fontSize:12,fontWeight:600,color:'var(--text-muted)',marginBottom:10,textTransform:'uppercase',letterSpacing:'0.06em'}}>Apply tier</div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
            {tiers.map(tier => {
              const active = tierId === tier.id && !overridden;
              return (
                <div
                  key={tier.id}
                  onClick={() => applyTier(tier)}
                  style={{
                    flex:'1 1 160px', minWidth:140, padding:'14px 16px',
                    background: active ? `${tier.colour}15` : 'var(--surface)',
                    border:`2px solid ${active ? tier.colour : 'var(--border)'}`,
                    borderRadius:8, cursor:'pointer', transition:'border-color 0.15s, background 0.15s',
                  }}
                  onMouseEnter={e=>{ if(!active) e.currentTarget.style.borderColor=`${tier.colour}66`; }}
                  onMouseLeave={e=>{ if(!active) e.currentTarget.style.borderColor='var(--border)'; }}
                >
                  <div style={{fontSize:13,fontWeight:700,color:tier.colour,marginBottom:4}}>{tier.name}</div>
                  <div style={{fontSize:11,color:'var(--text-muted)',lineHeight:1.4}}>{tier.description}</div>
                  <div style={{marginTop:8,display:'flex',flexWrap:'wrap',gap:4}}>
                    {ALL_HUBS.filter(h=>tier.hubs[h]).map(h=>(
                      <span key={h} style={{fontSize:9,fontWeight:700,padding:'1px 6px',borderRadius:4,
                        background:`${tier.colour}20`,color:tier.colour,border:`1px solid ${tier.colour}33`}}>
                        {HUB_LABELS[h].replace(' Hub','').replace(' Security','')}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Individual hub toggles */}
      <div>
        <div style={{fontSize:12,fontWeight:600,color:'var(--text-muted)',marginBottom:10,textTransform:'uppercase',letterSpacing:'0.06em'}}>
          Feature overrides
          {overridden && <span style={{fontSize:10,color:'#e6b800',marginLeft:8,fontWeight:400,textTransform:'none'}}>Modified from {currentTier?.name||'tier'} defaults</span>}
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {ALL_HUBS.map(hub => {
            const enabled = !!features[hub];
            const tierEnabled = currentTier?.hubs?.[hub];
            const isDiff = currentTier && enabled !== tierEnabled;
            return (
              <div key={hub} style={{
                display:'flex',alignItems:'center',gap:12,
                padding:'10px 14px',
                background:enabled?'var(--surface)':'rgba(255,255,255,0.02)',
                border:`1px solid ${isDiff?'rgba(230,184,0,0.35)':'var(--border)'}`,
                borderRadius:8,
              }}>
                <div
                  onClick={()=>toggleHub(hub)}
                  style={{
                    width:34,height:20,borderRadius:10,
                    background:enabled?'var(--accent)':'rgba(255,255,255,0.12)',
                    position:'relative',cursor:'pointer',flexShrink:0,transition:'background 0.2s',
                  }}
                >
                  <div style={{
                    position:'absolute',top:2,left:enabled?16:2,
                    width:16,height:16,borderRadius:8,background:'#fff',
                    transition:'left 0.2s',boxShadow:'0 1px 3px rgba(0,0,0,0.3)',
                  }}/>
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:600,color:enabled?'var(--text)':'var(--text-muted)'}}>
                    {HUB_LABELS[hub]}
                  </div>
                  {isDiff && (
                    <div style={{fontSize:10,color:'#e6b800',marginTop:1}}>
                      {tierEnabled?'Enabled by default on this tier — override active':'Not included on this tier — manually enabled'}
                    </div>
                  )}
                </div>
                {isDiff && (
                  <span style={{fontSize:9,fontWeight:700,padding:'2px 7px',borderRadius:4,
                    background:'rgba(230,184,0,0.12)',color:'#e6b800',border:'1px solid rgba(230,184,0,0.3)'}}>
                    Override
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
}

// ── Client row with expandable tabs ───────────────────────────────────────────

const CLIENT_TABS = [
  { id: 'overview',      label: 'Overview' },
  { id: 'settings',      label: 'Settings' },
  { id: 'files',         label: 'Files' },
  { id: 'subscription',  label: 'Subscription' },
  { id: 'dashboard',     label: 'Dashboard' },
  { id: 'security',      label: 'Cyber Security Hub' },
  { id: 'domains',       label: 'Digital Hub' },
  { id: 'devices',       label: 'Device Hub' },
  { id: 'assets',        label: 'Assets Hub' },
  { id: 'compliance',    label: 'Compliance Hub' },
  { id: 'productivity',  label: 'Productivity Hub' },
  { id: 'network',       label: 'Network Labels' },
  { id: 'reports',       label: 'Reports' },
];

function ClientRow({ client, users, onRefresh, clients = [], expanded = false, onToggle }) {
  // v3.84: /manage?client=<slug>&tab=<tab> opens that client on that tab
  // (Active Scans' Reports button links here)
  // v3.99: open/closed is held by ClientManagement, which shows an open
  // client on its own (focus view)
  const location = useLocation();
  const _q       = new URLSearchParams(location.search);
  const _focus   = _q.get('client') === client.slug;
  const _tabQ    = CLIENT_TABS.some(t => t.id === _q.get('tab')) ? _q.get('tab') : 'overview';
  const [activeTab, setActiveTab] = useState(_focus ? _tabQ : 'overview');
  const [settingsDirty, setSettingsDirty] = useState(false);
  const rowRef = useRef(null);
  useEffect(() => {
    if (!_focus) return;
    setActiveTab(_tabQ);
  }, [location.search]);
  // v3.99: start at the top of the client when it opens
  useEffect(() => {
    if (!expanded) return;
    const t = setTimeout(() => { try { rowRef.current?.scrollIntoView({ block: 'start' }); } catch (e) { /* ignore */ } }, 30);
    return () => clearTimeout(t);
  }, [expanded]);

  const guardedAction = (action) => {
    if (activeTab === 'settings' && settingsDirty) {
      if (!window.confirm('You have unsaved changes on the Settings tab. Leave without saving?')) return;
      setSettingsDirty(false);
    }
    action();
  };

  const toggle = () => guardedAction(() => onToggle && onToggle());

  return (
    <div ref={rowRef} id={`cm-row-${client.slug}`} className={expanded ? 'cm-focus' : undefined}>
      {/* v3.99: stays at the top while scrolling the open client */}
      {expanded && (
        <div className="cm-focus-bar">
          <button className="btn btn-secondary btn-sm" onClick={toggle}>← All clients</button>
          <span className="cm-focus-name">{client.display_name}</span>
          <span className="cm-focus-tab">{(CLIENT_TABS.find(t => t.id === activeTab) || {}).label}</span>
        </div>
      )}
    <div className={`client-mgmt-card card${expanded ? ' cm-focus-card' : ''}`} style={{overflow:'hidden'}}>
      {/* Header row */}
      <div style={{display:'flex',alignItems:'center',gap:12,cursor:'pointer'}} onClick={toggle}>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
            <span style={{fontWeight:700,fontSize:14}}>{client.display_name}</span>
            <TierPill tierId={client.subscription_tier_id} overridden={client.tier_overridden}/>
            {client.is_demo && <DemoPill />}
          </div>
          <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>
            {client.report_count} assessment{client.report_count!==1?'s':''}
            {client.latest_report?.date ? ` · Last: ${fmtDate(client.latest_report.date)}` : ''}
            {users.filter(u=>u.client_slug===client.slug).length > 0 &&
              ` · ${users.filter(u=>u.client_slug===client.slug).length} user${users.filter(u=>u.client_slug===client.slug).length!==1?'s':''}`}
          </div>
        </div>
        {(client.it_health?.grade || client.latest_report?.grade) && (
          <div style={{display:'flex',gap:8,flexShrink:0}}>
            <LabelledGrade label="IT Health" grade={client.it_health?.grade} score={client.it_health?.score}
              date={client.it_health?.date} empty="No IT and Cyber Security Report yet"/>
            <LabelledGrade label="External" grade={client.latest_report?.grade} score={client.latest_report?.score}
              date={client.latest_report?.date} empty="No External Cyber Security Assessment yet"/>
          </div>
        )}
        <span style={{fontSize:12,color:'var(--text-muted)',flexShrink:0}}>{expanded ? '▲' : '▼'}</span>
      </div>

      {/* Expanded panel */}
      {expanded && (
        <div style={{marginTop:16,borderTop:'1px solid var(--border)',paddingTop:16}}>
          {/* Tab bar */}
          <div style={{display:'flex',gap:2,borderBottom:'1px solid var(--border)',marginBottom:16,overflowX:'auto',scrollbarWidth:'none'}}>
            <style>{`.cm-tabs::-webkit-scrollbar{display:none}`}</style>
            <div className="cm-tabs" style={{display:'flex',gap:2,overflowX:'auto',scrollbarWidth:'none'}}>
              {CLIENT_TABS.map(t => (
                <button className="tab-btn" aria-selected={activeTab===t.id} key={t.id} onClick={e=>{e.stopPropagation();guardedAction(()=>setActiveTab(t.id));}}>{t.label}</button>
              ))}
            </div>
          </div>

          {/* Tab content */}
          <div onClick={e => e.stopPropagation()}>
            {activeTab==='overview'     && <OverviewTab client={client} users={users} onRefresh={onRefresh}/>}
            {activeTab==='files'        && <FilesTab slug={client.slug}/>}
            {activeTab==='settings'     && <><TeamsPanel slug={client.slug}/><BackupsPanel slug={client.slug}/><SettingsTab slug={client.slug} displayName={client.display_name} users={users} onSaved={onRefresh} onArchived={onRefresh} onDirtyChange={setSettingsDirty}/></>}
            {activeTab==='subscription' && <SubscriptionTab slug={client.slug} client={client} onRefresh={onRefresh}/>}
            {activeTab==='dashboard'    && <DashboardAdmin slug={client.slug}/>}
            {activeTab==='security'     && <CyberSecurityHub slug={client.slug}/>}
            {activeTab==='domains'      && <DigitalHub slug={client.slug} isAdmin={true}/>}
            {activeTab==='devices'      && <DeviceHubInline slug={client.slug} clients={clients}/>}
            {activeTab==='assets'       && <AssetHub slug={client.slug} isAdmin={true}/>}
            {activeTab==='compliance'   && <ComplianceHubInline slug={client.slug}/>}
            {activeTab==='productivity' && <ProductivityHubInline slug={client.slug}/>}
            {activeTab==='network'      && <NetworkTab slug={client.slug}/>}
            {activeTab==='reports'      && <ReportsHubInline slug={client.slug}/>}
          </div>
        </div>
      )}
    </div>
      {expanded && (
        <div className="cm-focus-end">
          <span>End of {client.display_name}</span>
          <button className="btn btn-secondary btn-sm" onClick={toggle}>← All clients</button>
          <button className="btn btn-quiet btn-sm" onClick={() => { try { rowRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { /* ignore */ } }}>Back to top</button>
        </div>
      )}
    </div>
  );
}

// ── ProductivityHub inline (data view with Config Drift sub-tab) ──────────────

function ProductivityHubInline({ slug }) {
  const [subTab, setSubTab] = useState('m365');
  const SUB_TABS = [
    { id: 'm365',  label: 'Microsoft 365' },
    { id: 'drift', label: 'Config Drift' },
  ];
  return (
    <div>
      <SubTabBar tabs={SUB_TABS} active={subTab} onChange={setSubTab} />
      {subTab === 'm365'  && <ProductivityHub slug={slug} />}
      {subTab === 'drift' && <TrustM365DriftDetail slug={slug} />}
    </div>
  );
}

// ── TrustM365 Config Drift detail view ────────────────────────────────────────

function TrustM365DriftDetail({ slug }) {
  const [drift, setDrift] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authFetch(`/api/m365/drift/${slug}`)
      .then(r => r.json())
      .then(d => { setDrift(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) return <div style={{padding:'12px 0'}}><span className="spinner"/></div>;
  if (!drift || !drift.available) return (
    <div style={{padding:'16px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,fontSize:13,color:'var(--text-muted)'}}>
      No M365 config drift data available. Add a tenant UUID in Client Settings to enable M365 config drift monitoring.
    </div>
  );

  const status = String(drift.overall_status || '');
  const statusColor = status === 'drifted' ? '#ff2d55' : status === 'clean' ? '#30d158' : status === 'partial' ? '#e6b800' : 'var(--text-muted)';
  const statusLabel = status === 'drifted' ? 'Drift Detected' : status === 'clean' ? 'All Clean' : status === 'partial' ? 'Partially Monitored' : status === 'unconfigured' ? 'No Baseline Set' : status || 'Unknown';
  const areas = Array.isArray(drift.areas) ? drift.areas : [];

  return (
    <div>
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <span style={{fontSize:12,fontWeight:700,color:statusColor,background:`${statusColor}18`,border:`1px solid ${statusColor}40`,borderRadius:4,padding:'3px 10px'}}>{statusLabel}</span>
        {Number(drift.drifted_areas||0) > 0 && <span style={{fontSize:13,color:'var(--text-muted)'}}>{Number(drift.total_drifts||0)} change{Number(drift.total_drifts||0)!==1?'s':''} across {Number(drift.drifted_areas||0)} area{Number(drift.drifted_areas||0)!==1?'s':''}</span>}
        {drift.polled_at && <span style={{fontSize:12,color:'var(--text-muted)',marginLeft:'auto'}}>Updated {fmtDate(String(drift.polled_at))}</span>}
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:6}}>
        {areas.map((area,i) => {
          const hasDrift = area.drift?.status === 'drifted' && Number(area.drift?.drift_count||0) > 0;
          const isClean = area.drift?.status === 'clean' || (area.drift?.status === 'drifted' && Number(area.drift?.drift_count||0) === 0);
          const noBaseline = !area.hasBaseline;
          const dotColor = hasDrift ? '#ff2d55' : isClean ? '#30d158' : noBaseline ? 'var(--text-muted)' : '#e6b800';
          return (
            <div key={area.areaKey||i} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8}}>
              <span style={{color:dotColor,fontSize:10,flexShrink:0}}>●</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600,color:'var(--text)'}}>{String(area.displayName||area.areaKey||'')}</div>
                {hasDrift && <div style={{fontSize:11,color:'var(--text-muted)',marginTop:2}}>{Number(area.drift.drift_count)} change{Number(area.drift.drift_count)!==1?'s':''}</div>}
              </div>
              <div style={{textAlign:'right',flexShrink:0}}>
                {noBaseline ? <span style={{fontSize:11,color:'var(--text-muted)'}}>No baseline</span>
                  : hasDrift ? <span style={{fontSize:11,fontWeight:600,color:'#ff2d55'}}>Drifted</span>
                  : isClean  ? <span style={{fontSize:11,color:'#30d158'}}>Clean</span>
                  : <span style={{fontSize:11,color:'#e6b800'}}>Pending</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}



export default function ClientManagement() {
  const [clients, setClients] = useState([]);
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  // v3.99: the open client (shown on its own); ?client=<slug> opens one
  const location = useLocation();
  const navigate = useNavigate();
  const [openSlug, setOpenSlug] = useState(() => new URLSearchParams(location.search).get('client'));
  useEffect(() => {
    const s = new URLSearchParams(location.search).get('client');
    if (s) setOpenSlug(s);
  }, [location.search]);
  const [showArchived, setShowArchived] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [newClient, setNewClient]   = useState({ name:'', domains:'', contact:'', contact_email:'', notes:'', company_code:'' });
  const [codeTouched, setCodeTouched] = useState(false);
  const [creating, setCreating]     = useState(false);
  // v4.00: optional Teams team for the new client
  const [m365, setM365]             = useState(null);
  const [createTeam, setCreateTeam] = useState(false);
  const [teamName, setTeamName]     = useState('');
  const [teamTouched, setTeamTouched] = useState(false);
  const [error, setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [demoMode, setDemoMode] = useState(false);
  const [demoToggling, setDemoToggling] = useState(false);

  const load = useCallback(() => {
    Promise.all([
      authFetch('/api/clients').then(r => r.json()),
      authFetch('/api/users').then(r => r.json()),
      authFetch('/api/admin/demo/status').then(r => r.json()).catch(() => ({ enabled: false })),
    ]).then(([c, u, demo]) => {
      setClients(Array.isArray(c) ? c : []);
      setUsers(Array.isArray(u) ? u : []);
      setDemoMode(demo.enabled || false);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const toggleDemo = async () => {
    setDemoToggling(true);
    try {
      const r = await authFetch('/api/admin/demo/toggle', { method: 'POST' });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Toggle failed');
      setDemoMode(d.enabled);
      flash(d.message);
      // Reload client list after a short delay so seeded data is ready
      setTimeout(load, 1500);
    } catch (err) {
      flash(err.message, true);
    } finally {
      setDemoToggling(false);
    }
  };

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (!showCreate) return;
    authFetch('/api/admin/m365/config').then(r => r.json()).then(d => {
      setM365(d);
      setCreateTeam(!!d.configured && (d.team_owners || []).length > 0);
    }).catch(() => setM365(null));
  }, [showCreate]);

  const teamNameFor = (name) => ((m365?.team_name_format) || 'Client - {name}').replace('{name}', (name || '').trim());
  useEffect(() => {
    if (!teamTouched) setTeamName(newClient.name.trim() ? teamNameFor(newClient.name) : '');
  }, [newClient.name, m365, teamTouched]);

  const flash = (msg, isError=false) => {
    if (isError) { setError(msg); setSuccess(''); } else { setSuccess(msg); setError(''); }
    setTimeout(() => { setError(''); setSuccess(''); }, 4000);
  };

  const create = async (e) => {
    e.preventDefault();
    if (newClient.company_code && newClient.company_code.length !== 3) {
      flash('Company Code must be exactly 3 letters.', true);
      return;
    }
    setCreating(true); setError('');
    try {
      const body = { ...newClient, create_team: !!(createTeam && m365?.configured), team_name: teamName };
      const r = await authFetch('/api/clients', { method: 'POST', body: JSON.stringify(body) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Create failed');
      const label = newClient.client_name || newClient.name || (d.slug || '').replace(/_/g, ' ');
      if (d.team_error) flash(`Client "${label}" created, but the team was not started: ${d.team_error}`, true);
      else flash(`Client "${label}" created${d.team_job ? '. The Teams team is being created; progress shows on the client\'s Settings tab.' : ''}`);
      setShowCreate(false);
      setNewClient({ name:'', domains:'', contact:'', contact_email:'', notes:'', company_code:'' });
      setCodeTouched(false);
      setTeamTouched(false);
      load();
    } catch (err) { flash(err.message, true); }
    finally { setCreating(false); }
  };

  // Alphabetical, ignoring a leading "The " so "The Backroom" sorts under B.
  const sortName = (c) => (c.display_name || '').replace(/^the\s+/i, '').trim().toLowerCase();
  const filtered = clients
    .filter(c => (showArchived || !c.archived) && c.display_name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => sortName(a).localeCompare(sortName(b)));

  // v3.99: an open client is shown on its own
  const openClientObj = openSlug ? clients.find(c => c.slug === openSlug) : null;
  const openClient = (slug) => setOpenSlug(slug);
  const closeClient = () => {
    const was = openSlug;
    setOpenSlug(null);
    if (new URLSearchParams(location.search).get('client')) navigate(location.pathname, { replace: true });
    setTimeout(() => { try { document.getElementById(`cm-row-${was}`)?.scrollIntoView({ block: 'center' }); } catch (e) { /* ignore */ } }, 30);
  };

  return (
    <div>
      <div className="page-header" style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:12}}>
        <div>
          <div className="page-title">Client Management</div>
          <div className="page-subtitle">{clients.filter(c=>showArchived||!c.archived).length} client{clients.filter(c=>showArchived||!c.archived).length!==1?'s':''} · Click to expand</div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          {/* Demo mode toggle */}
          <button className="btn btn-secondary btn-sm" aria-pressed={!!demoMode}
            onClick={toggleDemo}
            disabled={demoToggling}
            title={demoMode ? 'Demo mode is ON — click to hide demo client' : 'Click to show demo client for screenshots and demos'}
          >
            <div style={{
              width:30, height:17, borderRadius:9, flexShrink:0,
              background: demoMode ? '#a855f7' : 'rgba(255,255,255,0.12)',
              position:'relative', transition:'background 0.2s',
            }}>
              <div style={{
                position:'absolute', top:2,
                left: demoMode ? 15 : 2,
                width:13, height:13, borderRadius:7,
                background:'#fff', transition:'left 0.2s',
                boxShadow:'0 1px 3px rgba(0,0,0,0.3)',
              }}/>
            </div>
            Demo Mode
          </button>
          <button className="btn btn-primary" onClick={() => setShowCreate(s => !s)}>
            {showCreate ? 'Cancel' : '+ New Client'}
          </button>
        </div>
      </div>

      {error   && <div className="error-msg"   style={{marginBottom:16}}>{error}</div>}
      {success && <div className="success-msg" style={{marginBottom:16}}>{success}</div>}

      {/* New client form */}
      {showCreate && (
        <div className="card" style={{marginBottom:20}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:16}}>New Client</div>
          <form onSubmit={create} style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
            <div style={{gridColumn:'1/-1'}}>
              <label>Company Name</label>
              <input
                value={newClient.name}
                onChange={e=>{
                  const name = e.target.value;
                  setNewClient(p=>({...p,name,company_code: codeTouched ? p.company_code : suggestCompanyCode(name, clients.map(c=>c.meta?.company_code))}));
                }}
                placeholder="Acme Corporation" required
              />
            </div>
            <div style={{gridColumn:'1/-1'}}>
              <label>Company Code</label>
              <div style={{display:'flex',gap:6,maxWidth:220}}>
                <input className="input-sm"
                  value={newClient.company_code}
                  onChange={e=>{setCodeTouched(true);setNewClient(p=>({...p,company_code:sanitizeCompanyCode(e.target.value)}));}}
                  placeholder="APS" maxLength={3} required
                  style={{ flex:1, textTransform:'uppercase', letterSpacing:'0.1em' }}
                />
                <button className="btn btn-secondary btn-sm"
                  type="button"
                  onClick={()=>{setCodeTouched(false);setNewClient(p=>({...p,company_code:suggestCompanyCode(p.name, clients.map(c=>c.meta?.company_code))}));}}
                >Suggest</button>
              </div>
              <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>3 letters — prefixes computer names and client items across all products. Auto-suggested from the company name; edit freely.</div>
            </div>
            <div style={{gridColumn:'1/-1'}}>
              <label>Domains</label>
              <input value={newClient.domains} onChange={e=>setNewClient(p=>({...p,domains:e.target.value}))} placeholder="acme.com, acme.co.uk"/>
              <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Comma-separated. Used for assessments and cyber checks.</div>
            </div>
            <div><label>Contact Name</label><input value={newClient.contact} onChange={e=>setNewClient(p=>({...p,contact:e.target.value}))} placeholder="Jane Smith"/></div>
            <div><label>Contact Email</label><input type="email" value={newClient.contact_email} onChange={e=>setNewClient(p=>({...p,contact_email:e.target.value}))} placeholder="jane@acme.com"/></div>
            <div style={{gridColumn:'1/-1'}}><label>Notes</label><textarea value={newClient.notes} onChange={e=>setNewClient(p=>({...p,notes:e.target.value}))} rows={2} style={{resize:'vertical'}}/></div>
            {m365?.configured && (
              <div style={{gridColumn:'1/-1'}}>
                <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontWeight:600}}>
                  <input type="checkbox" checked={createTeam} onChange={e=>setCreateTeam(e.target.checked)}
                    disabled={!(m365.team_owners || []).length} style={{width:'auto'}}/>
                  Create a Teams team
                </label>
                {createTeam && (
                  <div style={{marginTop:8,maxWidth:420}}>
                    <input className="input-sm" value={teamName} maxLength={256}
                      onChange={e=>{setTeamTouched(true);setTeamName(e.target.value);}}
                      placeholder={teamNameFor('Acme Corporation')}/>
                    <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>
                      Private team with a {m365.channel_name || 'Client Folder'} channel. Created in the background; progress shows on the client's Settings tab.
                    </div>
                  </div>
                )}
                {!(m365.team_owners || []).length && (
                  <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Set team owners in System Admin, Microsoft 365 first.</div>
                )}
              </div>
            )}
            <div style={{gridColumn:'1/-1',display:'flex',gap:8}}>
              <button className="btn btn-primary" type="submit" disabled={creating}>{creating?<span className="spinner"/>:'Create Client'}</button>
              <button className="btn btn-secondary" type="button" onClick={()=>setShowCreate(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      {openClientObj ? (
        <ClientRow key={openClientObj.slug} client={openClientObj} users={users} onRefresh={load} clients={clients}
          expanded={true} onToggle={closeClient}/>
      ) : (
      <div>
      {/* Search + archived toggle */}
      <div style={{display:'flex',gap:12,marginBottom:16,alignItems:'center',flexWrap:'wrap'}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search clients…" style={{maxWidth:320}}/>
        <button className="btn btn-secondary btn-sm" aria-pressed={showArchived} onClick={()=>setShowArchived(s=>!s)}>
          {showArchived?'Hide Archived':'Show Archived'}
        </button>
      </div>

      {loading ? (
        <div style={{padding:48,textAlign:'center'}}><span className="spinner"/></div>
      ) : filtered.length === 0 ? (
        <div style={{padding:48,textAlign:'center',color:'var(--text-muted)'}}>{search?'No clients match your search.':'No clients yet.'}</div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {filtered.map(c => (
            <ClientRow key={c.slug} client={c} users={users} onRefresh={load} clients={clients}
              expanded={false} onToggle={() => openClient(c.slug)}/>
          ))}
        </div>
      )}
      </div>
      )}
    </div>
  );
}